export default {
  '积石山保安族东乡族撒拉族自治县': '积石山保安族东乡族撒拉族自治县',
  '双江拉祜族佤族布朗族傣族自治县': '双江拉祜族佤族布朗族傣族自治县',
  '镇沅彝族哈尼族拉祜族自治县': '镇沅彝族哈尼族拉祜族自治县',
  '孟连傣族拉祜族佤族自治县': '孟连傣族拉祜族佤族自治县',
  '元江哈尼族彝族傣族自治县': '元江哈尼族彝族傣族自治县',
  '塔什库尔干塔吉克自治县': '塔什库尔干塔吉克自治县',
  '莫力达瓦达斡尔族自治旗': '莫力达瓦达斡尔族自治旗',
  '金平苗族瑶族傣族自治县': '金平苗族瑶族傣族自治县',
  '威宁彝族回族苗族自治县': '威宁彝族回族苗族自治县',
  '黔西南布依族苗族自治州': '黔西南布依族苗族自治州',
  '前郭尔罗斯蒙古族自治县': '前郭尔罗斯蒙古族自治县',
  '喀喇沁左翼蒙古族自治县': '喀喇沁左翼蒙古族自治县',
  '克孜勒苏柯尔克孜自治州': '克孜勒苏柯尔克孜自治州',
  '红河哈尼族彝族自治州': '红河哈尼族彝族自治州',
  '兰坪白族普米族自治县': '兰坪白族普米族自治县',
  '贡山独龙族怒族自治县': '贡山独龙族怒族自治县',
  '德宏傣族景颇族自治州': '德宏傣族景颇族自治州',
  '秀山土家族苗族自治县': '秀山土家族苗族自治县',
  '海西蒙古族藏族自治州': '海西蒙古族藏族自治州',
  '彭水苗族土家族自治县': '彭水苗族土家族自治县',
  '道真仡佬族苗族自治县': '道真仡佬族苗族自治县',
  '务川仡佬族苗族自治县': '务川仡佬族苗族自治县',
  '镇宁布依族苗族自治县': '镇宁布依族苗族自治县',
  '紫云苗族布依族自治县': '紫云苗族布依族自治县',
  '关岭布依族苗族自治县': '关岭布依族苗族自治县',
  '印江土家族苗族自治县': '印江土家族苗族自治县',
  '围场满族蒙古族自治县': '围场满族蒙古族自治县',
  '酉阳土家族苗族自治县': '酉阳土家族苗族自治县',
  '杜尔伯特蒙古族自治县': '杜尔伯特蒙古族自治县',
  '黔东南苗族侗族自治州': '黔东南苗族侗族自治州',
  '黔南布依族苗族自治州': '黔南布依族苗族自治州',
  '阿克塞哈萨克族自治县': '阿克塞哈萨克族自治县',
  '普洱哈尼族彝族自治县': '普洱哈尼族彝族自治县',
  '恩施土家族苗族自治州': '恩施土家族苗族自治州',
  '湘西土家族苗族自治州': '湘西土家族苗族自治州',
  '江城哈尼族彝族自治县': '江城哈尼族彝族自治县',
  '巴里坤哈萨克自治县': '巴里坤哈萨克自治县',
  '博尔塔拉蒙古自治州': '博尔塔拉蒙古自治州',
  '达尔罕茂明安联合旗': '达尔罕茂明安联合旗',
  '保亭黎族苗族自治县': '保亭黎族苗族自治县',
  '琼中黎族苗族自治县': '琼中黎族苗族自治县',
  '大通回族土族自治县': '大通回族土族自治县',
  '察布查尔锡伯自治县': '察布查尔锡伯自治县',
  '靖州苗族侗族自治县': '靖州苗族侗族自治县',
  '禄劝彝族苗族自治县': '禄劝彝族苗族自治县',
  '寻甸回族彝族自治县': '寻甸回族彝族自治县',
  '新平彝族傣族自治县': '新平彝族傣族自治县',
  '民和回族土族自治县': '民和回族土族自治县',
  '耿马傣族佤族自治县': '耿马傣族佤族自治县',
  '阿坝藏族羌族自治州': '阿坝藏族羌族自治州',
  '西双版纳傣族自治州': '西双版纳傣族自治州',
  '景谷傣族彝族自治县': '景谷傣族彝族自治县',
  '连山壮族瑶族自治县': '连山壮族瑶族自治县',
  '巍山彝族回族自治县': '巍山彝族回族自治县',
  '文山壮族苗族自治州': '文山壮族苗族自治州',
  '巴音郭楞蒙古自治州': '巴音郭楞蒙古自治州',
  '五峰土家族自治县': '五峰土家族自治县',
  '澜沧拉祜族自治县': '澜沧拉祜族自治县',
  '玉龙纳西族自治县': '玉龙纳西族自治县',
  '石柱土家族自治县': '石柱土家族自治县',
  '怒江傈僳族自治州': '怒江傈僳族自治州',
  '木垒哈萨克自治县': '木垒哈萨克自治县',
  '环江毛南族自治县': '环江毛南族自治县',
  '维西傈僳族自治县': '维西傈僳族自治县',
  '罗城仫佬族自治县': '罗城仫佬族自治县',
  '伊犁哈萨克自治州': '伊犁哈萨克自治州',
  '长阳土家族自治县': '长阳土家族自治县',
  '墨江哈尼族自治县': '墨江哈尼族自治县',
  '循化撒拉族自治县': '循化撒拉族自治县',
  '梅里斯达斡尔族区': '梅里斯达斡尔族区',
  '延边朝鲜族自治州': '延边朝鲜族自治州',
  '张家川回族自治县': '张家川回族自治县',
  '肃北蒙古族自治县': '肃北蒙古族自治县',
  '长白朝鲜族自治县': '长白朝鲜族自治县',
  '肃南裕固族自治县': '肃南裕固族自治县',
  '阜新蒙古族自治县': '阜新蒙古族自治县',
  '河南蒙古族自治县': '河南蒙古族自治县',
  '沿河土家族自治县': '沿河土家族自治县',
  '宽甸满族自治县': '宽甸满族自治县',
  '大厂回族自治县': '大厂回族自治县',
  '丰宁满族自治县': '丰宁满族自治县',
  '伊通满族自治县': '伊通满族自治县',
  '昌吉回族自治州': '昌吉回族自治州',
  '焉耆回族自治县': '焉耆回族自治县',
  '互助土族自治县': '互助土族自治县',
  '马边彝族自治县': '马边彝族自治县',
  '峨边彝族自治县': '峨边彝族自治县',
  '宽城满族自治县': '宽城满族自治县',
  '甘孜藏族自治州': '甘孜藏族自治州',
  '凉山彝族自治州': '凉山彝族自治州',
  '木里藏族自治县': '木里藏族自治县',
  '昌江黎族自治县': '昌江黎族自治县',
  '玉树藏族自治州': '玉树藏族自治州',
  '鄂温克族自治旗': '鄂温克族自治旗',
  '果洛藏族自治州': '果洛藏族自治州',
  '门源回族自治县': '门源回族自治县',
  '玉屏侗族自治县': '玉屏侗族自治县',
  '松桃苗族自治县': '松桃苗族自治县',
  '海北藏族自治州': '海北藏族自治州',
  '景宁畲族自治县': '景宁畲族自治县',
  '孟村回族自治县': '孟村回族自治县',
  '化隆回族自治县': '化隆回族自治县',
  '科尔沁右翼前旗': '科尔沁右翼前旗',
  '科尔沁右翼中旗': '科尔沁右翼中旗',
  '三都水族自治县': '三都水族自治县',
  '石林彝族自治县': '石林彝族自治县',
  '科尔沁左翼中旗': '科尔沁左翼中旗',
  '科尔沁左翼后旗': '科尔沁左翼后旗',
  '峨山彝族自治县': '峨山彝族自治县',
  '城步苗族自治县': '城步苗族自治县',
  '江华瑶族自治县': '江华瑶族自治县',
  '新晃侗族自治县': '新晃侗族自治县',
  '宁蒗彝族自治县': '宁蒗彝族自治县',
  '芷江侗族自治县': '芷江侗族自治县',
  '通道侗族自治县': '通道侗族自治县',
  '景东彝族自治县': '景东彝族自治县',
  '黄南藏族自治州': '黄南藏族自治州',
  '麻阳苗族自治县': '麻阳苗族自治县',
  '海南藏族自治州': '海南藏族自治州',
  '乳源瑶族自治县': '乳源瑶族自治县',
  '察哈尔右翼前旗': '察哈尔右翼前旗',
  '西盟佤族自治县': '西盟佤族自治县',
  '察哈尔右翼中旗': '察哈尔右翼中旗',
  '连南瑶族自治县': '连南瑶族自治县',
  '融水苗族自治县': '融水苗族自治县',
  '沧源佤族自治县': '沧源佤族自治县',
  '三江侗族自治县': '三江侗族自治县',
  '龙胜各族自治县': '龙胜各族自治县',
  '恭城瑶族自治县': '恭城瑶族自治县',
  '隆林各族自治县': '隆林各族自治县',
  '迪庆藏族自治州': '迪庆藏族自治州',
  '富川瑶族自治县': '富川瑶族自治县',
  '大理白族自治州': '大理白族自治州',
  '漾濞彝族自治县': '漾濞彝族自治县',
  '南涧彝族自治县': '南涧彝族自治县',
  '都安瑶族自治县': '都安瑶族自治县',
  '楚雄彝族自治州': '楚雄彝族自治州',
  '察哈尔右翼后旗': '察哈尔右翼后旗',
  '巴马瑶族自治县': '巴马瑶族自治县',
  '河口瑶族自治县': '河口瑶族自治县',
  '屏边苗族自治县': '屏边苗族自治县',
  '岫岩满族自治县': '岫岩满族自治县',
  '大化瑶族自治县': '大化瑶族自治县',
  '金秀瑶族自治县': '金秀瑶族自治县',
  '清原满族自治县': '清原满族自治县',
  '新宾满族自治县': '新宾满族自治县',
  '天祝藏族自治县': '天祝藏族自治县',
  '白沙黎族自治县': '白沙黎族自治县',
  '青龙满族自治县': '青龙满族自治县',
  '乐东黎族自治县': '乐东黎族自治县',
  '临夏回族自治州': '临夏回族自治州',
  '陵水黎族自治县': '陵水黎族自治县',
  '本溪满族自治县': '本溪满族自治县',
  '甘南藏族自治州': '甘南藏族自治州',
  '桓仁满族自治县': '桓仁满族自治县',
  '北川羌族自治县': '北川羌族自治县',
  '东乡族自治县': '东乡族自治县',
  '圣安多尼堂区': '圣安多尼堂区',
  '圣方济各堂区': '圣方济各堂区',
  '大兴安岭辖区': '大兴安岭辖区',
  '大兴安岭地区': '大兴安岭地区',
  '鹰手营子矿区': '鹰手营子矿区',
  '东乌珠穆沁旗': '东乌珠穆沁旗',
  '新巴尔虎左旗': '新巴尔虎左旗',
  '新巴尔虎右旗': '新巴尔虎右旗',
  '鄂伦春自治旗': '鄂伦春自治旗',
  '阿鲁科尔沁旗': '阿鲁科尔沁旗',
  '西乌珠穆沁旗': '西乌珠穆沁旗',
  '乌兰察布盟': '乌兰察布盟',
  '五大连池市': '五大连池市',
  '阿克苏地区': '阿克苏地区',
  '呼和浩特市': '呼和浩特市',
  '陈巴尔虎旗': '陈巴尔虎旗',
  '鄂托克前旗': '鄂托克前旗',
  '伊金霍洛旗': '伊金霍洛旗',
  '花地玛堂区': '花地玛堂区',
  '管城回族区': '管城回族区',
  '顺河回族区': '顺河回族区',
  '瀍河回族区': '瀍河回族区',
  '堆龙德庆县': '堆龙德庆县',
  '墨竹工卡县': '墨竹工卡县',
  '工布江达县': '工布江达县',
  '日喀则地区': '日喀则地区',
  '阿勒泰地区': '阿勒泰地区',
  '巴彦淖尔盟': '巴彦淖尔盟',
  '乌拉特前旗': '乌拉特前旗',
  '乌拉特中旗': '乌拉特中旗',
  '吉木萨尔县': '吉木萨尔县',
  '乌拉特后旗': '乌拉特后旗',
  '神农架林区': '神农架林区',
  '阿拉善左旗': '阿拉善左旗',
  '阿拉善右旗': '阿拉善右旗',
  '乌兰浩特市': '乌兰浩特市',
  '克什克腾旗': '克什克腾旗',
  '呼伦贝尔市': '呼伦贝尔市',
  '霍林郭勒市': '霍林郭勒市',
  '额尔古纳市': '额尔古纳市',
  '土默特左旗': '土默特左旗',
  '锡林郭勒盟': '锡林郭勒盟',
  '二连浩特市': '二连浩特市',
  '锡林浩特市': '锡林浩特市',
  '苏尼特左旗': '苏尼特左旗',
  '苏尼特右旗': '苏尼特右旗',
  '和林格尔县': '和林格尔县',
  '齐齐哈尔市': '齐齐哈尔市',
  '富拉尔基区': '富拉尔基区',
  '香格里拉县': '香格里拉县',
  '乌鲁木齐市': '乌鲁木齐市',
  '沙依巴克区': '沙依巴克区',
  '乌鲁木齐县': '乌鲁木齐县',
  '克拉玛依市': '克拉玛依市',
  '克拉玛依区': '克拉玛依区',
  '吐鲁番地区': '吐鲁番地区',
  '土默特右旗': '土默特右旗',
  '丹江口市': '丹江口市',
  '翁牛特旗': '翁牛特旗',
  '禹王台区': '禹王台区',
  '喀喇沁旗': '喀喇沁旗',
  '平顶山市': '平顶山市',
  '三门峡市': '三门峡市',
  '驻马店市': '驻马店市',
  '东西湖区': '东西湖区',
  '黄石港区': '黄石港区',
  '西塞山区': '西塞山区',
  '石景山区': '石景山区',
  '涉  县': '涉  县',
  '伍家岗区': '伍家岗区',
  '海拉尔市': '海拉尔市',
  '满洲里市': '满洲里市',
  '老河口市': '老河口市',
  '梁子湖区': '梁子湖区',
  '扎兰屯市': '扎兰屯市',
  '塔城地区': '塔城地区',
  '牙克石市': '牙克石市',
  '磁  县': '磁  县',
  '邱  县': '邱  县',
  '岳阳楼区': '岳阳楼区',
  '张家界市': '张家界市',
  '武陵源区': '武陵源区',
  '冷水滩区': '冷水滩区',
  '尼勒克县': '尼勒克县',
  '魏  县': '魏  县',
  '任  县': '任  县',
  '威  县': '威  县',
  '唐  县': '唐  县',
  '易  县': '易  县',
  '蠡  县': '蠡  县',
  '冷水江市': '冷水江市',
  '阿尔山市': '阿尔山市',
  '特克斯县': '特克斯县',
  '高碑店市': '高碑店市',
  '下花园区': '下花园区',
  '扎赉特旗': '扎赉特旗',
  '科尔沁区': '科尔沁区',
  '图木舒克': '图木舒克',
  '西乡塘区': '西乡塘区',
  '蔚  县': '蔚  县',
  '门头沟区': '门头沟区',
  '蓟  县': '蓟  县',
  '扎鲁特旗': '扎鲁特旗',
  '铁山港区': '铁山港区',
  '防城港市': '防城港市',
  '石家庄市': '石家庄市',
  '郊  区': '郊  区',
  '金城江区': '金城江区',
  '沧  县': '沧  县',
  '阿巴嘎旗': '阿巴嘎旗',
  '青  县': '青  县',
  '献  县': '献  县',
  '井陉矿区': '井陉矿区',
  '赵  县': '赵  县',
  '五指山市': '五指山市',
  '太仆寺旗': '太仆寺旗',
  '正镶白旗': '正镶白旗',
  '景  县': '景  县',
  '杏花岭区': '杏花岭区',
  '尖草坪区': '尖草坪区',
  '万柏林区': '万柏林区',
  '四子王旗': '四子王旗',
  '伊克昭盟': '伊克昭盟',
  '大渡口区': '大渡口区',
  '沙坪坝区': '沙坪坝区',
  '九龙坡区': '九龙坡区',
  '呼图壁县': '呼图壁县',
  '达拉特旗': '达拉特旗',
  '准格尔旗': '准格尔旗',
  '城  区': '城  区',
  '鄂托克旗': '鄂托克旗',
  '矿  区': '矿  区',
  '龙泉驿区': '龙泉驿区',
  '青白江区': '青白江区',
  '都江堰市': '都江堰市',
  '玛纳斯县': '玛纳斯县',
  '自流井区': '自流井区',
  '攀枝花市': '攀枝花市',
  '龙马潭区': '龙马潭区',
  '盂  县': '盂  县',
  '沁  县': '沁  县',
  '应  县': '应  县',
  '五通桥区': '五通桥区',
  '金口河区': '金口河区',
  '峨眉山市': '峨眉山市',
  '代  县': '代  县',
  '杭锦后旗': '杭锦后旗',
  '阿拉善盟': '阿拉善盟',
  '马尔康县': '马尔康县',
  '九寨沟县': '九寨沟县',
  '若尔盖县': '若尔盖县',
  '兴  县': '兴  县',
  '临  县': '临  县',
  '额济纳旗': '额济纳旗',
  '六盘水市': '六盘水市',
  '库尔勒市': '库尔勒市',
  '六枝特区': '六枝特区',
  '红花岗区': '红花岗区',
  '苏家屯区': '苏家屯区',
  '新城子区': '新城子区',
  '沙河口区': '沙河口区',
  '甘井子区': '甘井子区',
  '旅顺口区': '旅顺口区',
  '铜仁地区': '铜仁地区',
  '瓦房店市': '瓦房店市',
  '普兰店市': '普兰店市',
  '岚  县': '岚  县',
  '祁  县': '祁  县',
  '万山特区': '万山特区',
  '毕节地区': '毕节地区',
  '古  县': '古  县',
  '吉  县': '吉  县',
  '蒲  县': '蒲  县',
  '隰  县': '隰  县',
  '鲅鱼圈区': '鲅鱼圈区',
  '大石桥市': '大石桥市',
  '清河门区': '清河门区',
  '夏  县': '夏  县',
  '太子河区': '太子河区',
  '弓长岭区': '弓长岭区',
  '双台子区': '双台子区',
  '兴隆台区': '兴隆台区',
  '调兵山市': '调兵山市',
  '绛  县': '绛  县',
  '葫芦岛市': '葫芦岛市',
  '公主岭市': '公主岭市',
  '新  区': '新  区',
  '二道江区': '二道江区',
  '梅河口市': '梅河口市',
  '八道江区': '八道江区',
  '滦  县': '滦  县',
  '托克托县': '托克托县',
  '秦皇岛市': '秦皇岛市',
  '黑龙江省': '黑龙江省',
  '哈尔滨市': '哈尔滨市',
  '清水河县': '清水河县',
  '昂昂溪区': '昂昂溪区',
  '昆都伦区': '昆都伦区',
  '碾子山区': '碾子山区',
  '石拐矿区': '石拐矿区',
  '四方台区': '四方台区',
  '城子河区': '城子河区',
  '萨尔图区': '萨尔图区',
  '让胡路区': '让胡路区',
  '白云矿区': '白云矿区',
  '金山屯区': '金山屯区',
  '乌马河区': '乌马河区',
  '上甘岭区': '上甘岭区',
  '汤旺河区': '汤旺河区',
  '乌伊岭区': '乌伊岭区',
  '牡丹江市': '牡丹江市',
  '绥芬河市': '绥芬河市',
  '佳木斯市': '佳木斯市',
  '麻栗坡县': '麻栗坡县',
  '七台河市': '七台河市',
  '阿克陶县': '阿克陶县',
  '茄子河区': '茄子河区',
  '山海关区': '山海关区',
  '那曲地区': '那曲地区',
  '昌都地区': '昌都地区',
  '类乌齐县': '类乌齐县',
  '林芝地区': '林芝地区',
  '北戴河区': '北戴河区',
  '阿合奇县': '阿合奇县',
  '山南地区': '山南地区',
  '浪卡子县': '浪卡子县',
  '海勃湾区': '海勃湾区',
  '日喀则市': '日喀则市',
  '南木林县': '南木林县',
  '谢通门县': '谢通门县',
  '聂拉木县': '聂拉木县',
  '阿里地区': '阿里地区',
  '阿图什市': '阿图什市',
  '浦东新区': '浦东新区',
  '雨花台区': '雨花台区',
  '英吉沙县': '英吉沙县',
  '麦盖提县': '麦盖提县',
  '岳普湖县': '岳普湖县',
  '七里河区': '七里河区',
  '嘉峪关市': '嘉峪关市',
  '张家港市': '张家港市',
  '戚墅堰区': '戚墅堰区',
  '连云港市': '连云港市',
  '元宝山区': '元宝山区',
  '龙子湖区': '龙子湖区',
  '喀什地区': '喀什地区',
  '阿瓦提县': '阿瓦提县',
  '田家庵区': '田家庵区',
  '谢家集区': '谢家集区',
  '八公山区': '八公山区',
  '马鞍山市': '马鞍山市',
  '金家庄区': '金家庄区',
  '海东地区': '海东地区',
  '铜官山区': '铜官山区',
  '狮子山区': '狮子山区',
  '黄大仙区': '黄大仙区',
  '九龙城区': '九龙城区',
  '油尖旺区': '油尖旺区',
  '深水埗区': '深水埗区',
  '阿克苏市': '阿克苏市',
  '嘉模堂区': '嘉模堂区',
  '风顺堂区': '风顺堂区',
  '武夷山市': '武夷山市',
  '青云谱区': '青云谱区',
  '曲麻莱县': '曲麻莱县',
  '青山湖区': '青山湖区',
  '德令哈市': '德令哈市',
  '格尔木市': '格尔木市',
  '石嘴山市': '石嘴山市',
  '大武口区': '大武口区',
  '青铜峡市': '青铜峡市',
  '沙坡头区': '沙坡头区',
  '景德镇市': '景德镇市',
  '望德堂区': '望德堂区',
  '水磨沟区': '水磨沟区',
  '头屯河区': '头屯河区',
  '达坂城区': '达坂城区',
  '井冈山市': '井冈山市',
  '台儿庄区': '台儿庄区',
  '巴林左旗': '巴林左旗',
  '独山子区': '独山子区',
  '白碱滩区': '白碱滩区',
  '乌尔禾区': '乌尔禾区',
  '巴林右旗': '巴林右旗',
  '吐鲁番市': '吐鲁番市',
  '托克逊县': '托克逊县',
  '哈密地区': '哈密地区',
  '东昌府区': '东昌府区',
  '和田地区': '和田地区',
  '峰峰矿区': '峰峰矿区',
  '桃城区': '桃城区',
  '临西县': '临西县',
  '南宫市': '南宫市',
  '沙河市': '沙河市',
  '保定市': '保定市',
  '辽宁省': '辽宁省',
  '沈阳市': '沈阳市',
  '沈河区': '沈河区',
  '皇姑区': '皇姑区',
  '大东区': '大东区',
  '铁西区': '铁西区',
  '新市区': '新市区',
  '东陵区': '东陵区',
  '于洪区': '于洪区',
  '新民市': '新民市',
  '法库县': '法库县',
  '辽中县': '辽中县',
  '康平县': '康平县',
  '北市区': '北市区',
  '大连市': '大连市',
  '西岗区': '西岗区',
  '中山区': '中山区',
  '南市区': '南市区',
  '满城县': '满城县',
  '清苑县': '清苑县',
  '金州区': '金州区',
  '涞水县': '涞水县',
  '阜平县': '阜平县',
  '庄河市': '庄河市',
  '长海县': '长海县',
  '鞍山市': '鞍山市',
  '铁东区': '铁东区',
  '立山区': '立山区',
  '千山区': '千山区',
  '海城市': '海城市',
  '台安县': '台安县',
  '徐水县': '徐水县',
  '抚顺市': '抚顺市',
  '顺城区': '顺城区',
  '新抚区': '新抚区',
  '东洲区': '东洲区',
  '望花区': '望花区',
  '抚顺县': '抚顺县',
  '定兴县': '定兴县',
  '河东区': '河东区',
  '本溪市': '本溪市',
  '平山区': '平山区',
  '明山区': '明山区',
  '溪湖区': '溪湖区',
  '南芬区': '南芬区',
  '高阳县': '高阳县',
  '容城县': '容城县',
  '丹东市': '丹东市',
  '振兴区': '振兴区',
  '元宝区': '元宝区',
  '振安区': '振安区',
  '东港市': '东港市',
  '凤城市': '凤城市',
  '涞源县': '涞源县',
  '锦州市': '锦州市',
  '太和区': '太和区',
  '古塔区': '古塔区',
  '凌河区': '凌河区',
  '凌海市': '凌海市',
  '黑山县': '黑山县',
  '葵青区': '葵青区',
  '北宁市': '北宁市',
  '营口市': '营口市',
  '站前区': '站前区',
  '西市区': '西市区',
  '望都县': '望都县',
  '老边区': '老边区',
  '安新县': '安新县',
  '盖州市': '盖州市',
  '阜新市': '阜新市',
  '海州区': '海州区',
  '新邱区': '新邱区',
  '太平区': '太平区',
  '河西区': '河西区',
  '细河区': '细河区',
  '彰武县': '彰武县',
  '曲阳县': '曲阳县',
  '辽阳市': '辽阳市',
  '白塔区': '白塔区',
  '文圣区': '文圣区',
  '宏伟区': '宏伟区',
  '南开区': '南开区',
  '顺平县': '顺平县',
  '灯塔市': '灯塔市',
  '辽阳县': '辽阳县',
  '荃湾区': '荃湾区',
  '中西区': '中西区',
  '离岛区': '离岛区',
  '盘山县': '盘山县',
  '大洼县': '大洼县',
  '铁岭市': '铁岭市',
  '银州区': '银州区',
  '清河区': '清河区',
  '涿州市': '涿州市',
  '开原市': '开原市',
  '铁岭县': '铁岭县',
  '昌图县': '昌图县',
  '西丰县': '西丰县',
  '朝阳市': '朝阳市',
  '双塔区': '双塔区',
  '龙城区': '龙城区',
  '凌源市': '凌源市',
  '北票市': '北票市',
  '朝阳县': '朝阳县',
  '建平县': '建平县',
  '定州市': '定州市',
  '安国市': '安国市',
  '龙港区': '龙港区',
  '南票区': '南票区',
  '连山区': '连山区',
  '兴城市': '兴城市',
  '绥中县': '绥中县',
  '建昌县': '建昌县',
  '吉林省': '吉林省',
  '长春市': '长春市',
  '宽城区': '宽城区',
  '二道区': '二道区',
  '南关区': '南关区',
  '绿园区': '绿园区',
  '双阳区': '双阳区',
  '九台市': '九台市',
  '榆树市': '榆树市',
  '德惠市': '德惠市',
  '农安县': '农安县',
  '吉林市': '吉林市',
  '船营区': '船营区',
  '昌邑区': '昌邑区',
  '龙潭区': '龙潭区',
  '丰满区': '丰满区',
  '舒兰市': '舒兰市',
  '桦甸市': '桦甸市',
  '蛟河市': '蛟河市',
  '磐石市': '磐石市',
  '永吉县': '永吉县',
  '屯门区': '屯门区',
  '河北区': '河北区',
  '双辽市': '双辽市',
  '梨树县': '梨树县',
  '张家口': '张家口',
  '辽源市': '辽源市',
  '龙山区': '龙山区',
  '西安区': '西安区',
  '东辽县': '东辽县',
  '东丰县': '东丰县',
  '通化市': '通化市',
  '东昌区': '东昌区',
  '宣化区': '宣化区',
  '红桥区': '红桥区',
  '集安市': '集安市',
  '通化县': '通化县',
  '辉南县': '辉南县',
  '柳河县': '柳河县',
  '白山市': '白山市',
  '宣化县': '宣化县',
  '江源区': '江源区',
  '临江市': '临江市',
  '靖宇县': '靖宇县',
  '抚松县': '抚松县',
  '张北县': '张北县',
  '松原市': '松原市',
  '宁江区': '宁江区',
  '乾安县': '乾安县',
  '长岭县': '长岭县',
  '扶余县': '扶余县',
  '康保县': '康保县',
  '白城市': '白城市',
  '洮北区': '洮北区',
  '大安市': '大安市',
  '洮南市': '洮南市',
  '镇赉县': '镇赉县',
  '通榆县': '通榆县',
  '沽源县': '沽源县',
  '延吉市': '延吉市',
  '图们市': '图们市',
  '敦化市': '敦化市',
  '龙井市': '龙井市',
  '珲春市': '珲春市',
  '和龙市': '和龙市',
  '安图县': '安图县',
  '汪清县': '汪清县',
  '尚义县': '尚义县',
  '塘沽区': '塘沽区',
  '松北区': '松北区',
  '道里区': '道里区',
  '南岗区': '南岗区',
  '平房区': '平房区',
  '香坊区': '香坊区',
  '道外区': '道外区',
  '呼兰区': '呼兰区',
  '阿城区': '阿城区',
  '双城市': '双城市',
  '尚志市': '尚志市',
  '五常市': '五常市',
  '元朗区': '元朗区',
  '方正县': '方正县',
  '通河县': '通河县',
  '巴彦县': '巴彦县',
  '延寿县': '延寿县',
  '木兰县': '木兰县',
  '依兰县': '依兰县',
  '阳原县': '阳原县',
  '龙沙区': '龙沙区',
  '怀安县': '怀安县',
  '铁锋区': '铁锋区',
  '建华区': '建华区',
  '万全县': '万全县',
  '怀来县': '怀来县',
  '涿鹿县': '涿鹿县',
  '讷河市': '讷河市',
  '富裕县': '富裕县',
  '拜泉县': '拜泉县',
  '甘南县': '甘南县',
  '依安县': '依安县',
  '克山县': '克山县',
  '泰来县': '泰来县',
  '克东县': '克东县',
  '龙江县': '龙江县',
  '鹤岗市': '鹤岗市',
  '兴山区': '兴山区',
  '工农区': '工农区',
  '南山区': '南山区',
  '兴安区': '兴安区',
  '向阳区': '向阳区',
  '东山区': '东山区',
  '萝北县': '萝北县',
  '绥滨县': '绥滨县',
  '双鸭山': '双鸭山',
  '尖山区': '尖山区',
  '岭东区': '岭东区',
  '赤城县': '赤城县',
  '宝山区': '宝山区',
  '集贤县': '集贤县',
  '宝清县': '宝清县',
  '友谊县': '友谊县',
  '饶河县': '饶河县',
  '鸡西市': '鸡西市',
  '鸡冠区': '鸡冠区',
  '恒山区': '恒山区',
  '崇礼县': '崇礼县',
  '滴道区': '滴道区',
  '梨树区': '梨树区',
  '麻山区': '麻山区',
  '密山市': '密山市',
  '虎林市': '虎林市',
  '鸡东县': '鸡东县',
  '大庆市': '大庆市',
  '承德市': '承德市',
  '红岗区': '红岗区',
  '龙凤区': '龙凤区',
  '双桥区': '双桥区',
  '大同区': '大同区',
  '林甸县': '林甸县',
  '肇州县': '肇州县',
  '肇源县': '肇源县',
  '双滦区': '双滦区',
  '伊春市': '伊春市',
  '伊春区': '伊春区',
  '带岭区': '带岭区',
  '南岔区': '南岔区',
  '汉沽区': '汉沽区',
  '西林区': '西林区',
  '美溪区': '美溪区',
  '承德县': '承德县',
  '翠峦区': '翠峦区',
  '友好区': '友好区',
  '兴隆县': '兴隆县',
  '五营区': '五营区',
  '红星区': '红星区',
  '新青区': '新青区',
  '平泉县': '平泉县',
  '滦平县': '滦平县',
  '铁力市': '铁力市',
  '嘉荫县': '嘉荫县',
  '隆化县': '隆化县',
  '爱民区': '爱民区',
  '东安区': '东安区',
  '阳明区': '阳明区',
  '大港区': '大港区',
  '宁安市': '宁安市',
  '海林市': '海林市',
  '穆棱市': '穆棱市',
  '林口县': '林口县',
  '东宁县': '东宁县',
  '东丽区': '东丽区',
  '前进区': '前进区',
  '东风区': '东风区',
  '西贡区': '西贡区',
  '同江市': '同江市',
  '富锦市': '富锦市',
  '桦川县': '桦川县',
  '抚远县': '抚远县',
  '桦南县': '桦南县',
  '汤原县': '汤原县',
  '西青区': '西青区',
  '桃山区': '桃山区',
  '新兴区': '新兴区',
  '沧州市': '沧州市',
  '勃利县': '勃利县',
  '黑河市': '黑河市',
  '爱辉区': '爱辉区',
  '北安市': '北安市',
  '运河区': '运河区',
  '逊克县': '逊克县',
  '嫩江县': '嫩江县',
  '孙吴县': '孙吴县',
  '绥化市': '绥化市',
  '北林区': '北林区',
  '安达市': '安达市',
  '肇东市': '肇东市',
  '海伦市': '海伦市',
  '绥棱县': '绥棱县',
  '兰西县': '兰西县',
  '明水县': '明水县',
  '青冈县': '青冈县',
  '庆安县': '庆安县',
  '望奎县': '望奎县',
  '津南区': '津南区',
  '呼玛县': '呼玛县',
  '塔河县': '塔河县',
  '漠河县': '漠河县',
  '北辰区': '北辰区',
  '上海市': '上海市',
  '黄浦区': '黄浦区',
  '卢湾区': '卢湾区',
  '徐汇区': '徐汇区',
  '长宁区': '长宁区',
  '静安区': '静安区',
  '普陀区': '普陀区',
  '闸北区': '闸北区',
  '虹口区': '虹口区',
  '杨浦区': '杨浦区',
  '闵行区': '闵行区',
  '嘉定区': '嘉定区',
  '松江区': '松江区',
  '金山区': '金山区',
  '青浦区': '青浦区',
  '南汇区': '南汇区',
  '奉贤区': '奉贤区',
  '东光县': '东光县',
  '崇明县': '崇明县',
  '江苏省': '江苏省',
  '南京市': '南京市',
  '玄武区': '玄武区',
  '白下区': '白下区',
  '秦淮区': '秦淮区',
  '建邺区': '建邺区',
  '鼓楼区': '鼓楼区',
  '下关区': '下关区',
  '栖霞区': '栖霞区',
  '海兴县': '海兴县',
  '浦口区': '浦口区',
  '江宁区': '江宁区',
  '六合区': '六合区',
  '溧水县': '溧水县',
  '高淳县': '高淳县',
  '苏州市': '苏州市',
  '金阊区': '金阊区',
  '平江区': '平江区',
  '沧浪区': '沧浪区',
  '虎丘区': '虎丘区',
  '吴中区': '吴中区',
  '相城区': '相城区',
  '常熟市': '常熟市',
  '盐山县': '盐山县',
  '昆山市': '昆山市',
  '吴江市': '吴江市',
  '太仓市': '太仓市',
  '无锡市': '无锡市',
  '崇安区': '崇安区',
  '南长区': '南长区',
  '北塘区': '北塘区',
  '滨湖区': '滨湖区',
  '锡山区': '锡山区',
  '惠山区': '惠山区',
  '江阴市': '江阴市',
  '宜兴市': '宜兴市',
  '常州市': '常州市',
  '钟楼区': '钟楼区',
  '天宁区': '天宁区',
  '肃宁县': '肃宁县',
  '新北区': '新北区',
  '武进区': '武进区',
  '金坛市': '金坛市',
  '溧阳市': '溧阳市',
  '镇江市': '镇江市',
  '京口区': '京口区',
  '润州区': '润州区',
  '丹徒区': '丹徒区',
  '丹阳市': '丹阳市',
  '扬中市': '扬中市',
  '句容市': '句容市',
  '南通市': '南通市',
  '崇川区': '崇川区',
  '港闸区': '港闸区',
  '通州市': '通州市',
  '如皋市': '如皋市',
  '海门市': '海门市',
  '启东市': '启东市',
  '海安县': '海安县',
  '如东县': '如东县',
  '泰州市': '泰州市',
  '海陵区': '海陵区',
  '高港区': '高港区',
  '姜堰市': '姜堰市',
  '泰兴市': '泰兴市',
  '靖江市': '靖江市',
  '兴化市': '兴化市',
  '扬州市': '扬州市',
  '广陵区': '广陵区',
  '维扬区': '维扬区',
  '邗江区': '邗江区',
  '江都市': '江都市',
  '仪征市': '仪征市',
  '高邮市': '高邮市',
  '宝应县': '宝应县',
  '盐城市': '盐城市',
  '亭湖区': '亭湖区',
  '盐都区': '盐都区',
  '大丰市': '大丰市',
  '东台市': '东台市',
  '建湖县': '建湖县',
  '射阳县': '射阳县',
  '阜宁县': '阜宁县',
  '滨海县': '滨海县',
  '响水县': '响水县',
  '南皮县': '南皮县',
  '新浦区': '新浦区',
  '连云区': '连云区',
  '东海县': '东海县',
  '灌云县': '灌云县',
  '赣榆县': '赣榆县',
  '灌南县': '灌南县',
  '徐州市': '徐州市',
  '云龙区': '云龙区',
  '九里区': '九里区',
  '泉山区': '泉山区',
  '贾汪区': '贾汪区',
  '邳州市': '邳州市',
  '新沂市': '新沂市',
  '铜山县': '铜山县',
  '睢宁县': '睢宁县',
  '沙田区': '沙田区',
  '大埔区': '大埔区',
  '淮安市': '淮安市',
  '清浦区': '清浦区',
  '楚州区': '楚州区',
  '淮阴区': '淮阴区',
  '涟水县': '涟水县',
  '洪泽县': '洪泽县',
  '金湖县': '金湖县',
  '盱眙县': '盱眙县',
  '宿迁市': '宿迁市',
  '宿城区': '宿城区',
  '宿豫区': '宿豫区',
  '沭阳县': '沭阳县',
  '泗阳县': '泗阳县',
  '泗洪县': '泗洪县',
  '浙江省': '浙江省',
  '杭州市': '杭州市',
  '拱墅区': '拱墅区',
  '西湖区': '西湖区',
  '上城区': '上城区',
  '下城区': '下城区',
  '江干区': '江干区',
  '滨江区': '滨江区',
  '余杭区': '余杭区',
  '萧山区': '萧山区',
  '建德市': '建德市',
  '富阳市': '富阳市',
  '临安市': '临安市',
  '桐庐县': '桐庐县',
  '淳安县': '淳安县',
  '宁波市': '宁波市',
  '海曙区': '海曙区',
  '江东区': '江东区',
  '江北区': '江北区',
  '镇海区': '镇海区',
  '北仑区': '北仑区',
  '鄞州区': '鄞州区',
  '余姚市': '余姚市',
  '慈溪市': '慈溪市',
  '奉化市': '奉化市',
  '宁海县': '宁海县',
  '象山县': '象山县',
  '温州市': '温州市',
  '鹿城区': '鹿城区',
  '龙湾区': '龙湾区',
  '瓯海区': '瓯海区',
  '瑞安市': '瑞安市',
  '乐清市': '乐清市',
  '永嘉县': '永嘉县',
  '洞头县': '洞头县',
  '平阳县': '平阳县',
  '苍南县': '苍南县',
  '文成县': '文成县',
  '泰顺县': '泰顺县',
  '嘉兴市': '嘉兴市',
  '秀城区': '秀城区',
  '秀洲区': '秀洲区',
  '海宁市': '海宁市',
  '平湖市': '平湖市',
  '桐乡市': '桐乡市',
  '嘉善县': '嘉善县',
  '海盐县': '海盐县',
  '湖州市': '湖州市',
  '吴兴区': '吴兴区',
  '南浔区': '南浔区',
  '长兴县': '长兴县',
  '德清县': '德清县',
  '安吉县': '安吉县',
  '绍兴市': '绍兴市',
  '越城区': '越城区',
  '诸暨市': '诸暨市',
  '上虞市': '上虞市',
  '嵊州市': '嵊州市',
  '绍兴县': '绍兴县',
  '新昌县': '新昌县',
  '金华市': '金华市',
  '婺城区': '婺城区',
  '金东区': '金东区',
  '兰溪市': '兰溪市',
  '义乌市': '义乌市',
  '东阳市': '东阳市',
  '永康市': '永康市',
  '武义县': '武义县',
  '浦江县': '浦江县',
  '磐安县': '磐安县',
  '衢州市': '衢州市',
  '柯城区': '柯城区',
  '衢江区': '衢江区',
  '江山市': '江山市',
  '龙游县': '龙游县',
  '常山县': '常山县',
  '开化县': '开化县',
  '舟山市': '舟山市',
  '定海区': '定海区',
  '岱山县': '岱山县',
  '嵊泗县': '嵊泗县',
  '台州市': '台州市',
  '椒江区': '椒江区',
  '黄岩区': '黄岩区',
  '路桥区': '路桥区',
  '临海市': '临海市',
  '温岭市': '温岭市',
  '玉环县': '玉环县',
  '天台县': '天台县',
  '仙居县': '仙居县',
  '三门县': '三门县',
  '丽水市': '丽水市',
  '莲都区': '莲都区',
  '龙泉市': '龙泉市',
  '缙云县': '缙云县',
  '青田县': '青田县',
  '云和县': '云和县',
  '遂昌县': '遂昌县',
  '松阳县': '松阳县',
  '庆元县': '庆元县',
  '吴桥县': '吴桥县',
  '安徽省': '安徽省',
  '合肥市': '合肥市',
  '庐阳区': '庐阳区',
  '瑶海区': '瑶海区',
  '蜀山区': '蜀山区',
  '包河区': '包河区',
  '长丰县': '长丰县',
  '肥东县': '肥东县',
  '肥西县': '肥西县',
  '芜湖市': '芜湖市',
  '镜湖区': '镜湖区',
  '弋江区': '弋江区',
  '鸠江区': '鸠江区',
  '三山区': '三山区',
  '芜湖县': '芜湖县',
  '南陵县': '南陵县',
  '繁昌县': '繁昌县',
  '蚌埠市': '蚌埠市',
  '蚌山区': '蚌山区',
  '武清区': '武清区',
  '禹会区': '禹会区',
  '淮上区': '淮上区',
  '怀远县': '怀远县',
  '固镇县': '固镇县',
  '五河县': '五河县',
  '淮南市': '淮南市',
  '宝坻区': '宝坻区',
  '大通区': '大通区',
  '泊头市': '泊头市',
  '任丘市': '任丘市',
  '潘集区': '潘集区',
  '凤台县': '凤台县',
  '黄骅市': '黄骅市',
  '雨山区': '雨山区',
  '花山区': '花山区',
  '河间市': '河间市',
  '当涂县': '当涂县',
  '淮北市': '淮北市',
  '相山区': '相山区',
  '杜集区': '杜集区',
  '烈山区': '烈山区',
  '濉溪县': '濉溪县',
  '铜陵市': '铜陵市',
  '廊坊市': '廊坊市',
  '安次区': '安次区',
  '铜陵县': '铜陵县',
  '安庆市': '安庆市',
  '迎江区': '迎江区',
  '大观区': '大观区',
  '宜秀区': '宜秀区',
  '桐城市': '桐城市',
  '宿松县': '宿松县',
  '枞阳县': '枞阳县',
  '太湖县': '太湖县',
  '怀宁县': '怀宁县',
  '岳西县': '岳西县',
  '望江县': '望江县',
  '潜山县': '潜山县',
  '黄山市': '黄山市',
  '屯溪区': '屯溪区',
  '黄山区': '黄山区',
  '徽州区': '徽州区',
  '休宁县': '休宁县',
  '观塘区': '观塘区',
  '祁门县': '祁门县',
  '固安县': '固安县',
  '滁州市': '滁州市',
  '琅琊区': '琅琊区',
  '南谯区': '南谯区',
  '天长市': '天长市',
  '明光市': '明光市',
  '全椒县': '全椒县',
  '来安县': '来安县',
  '定远县': '定远县',
  '凤阳县': '凤阳县',
  '阜阳市': '阜阳市',
  '颍州区': '颍州区',
  '颍东区': '颍东区',
  '颍泉区': '颍泉区',
  '界首市': '界首市',
  '临泉县': '临泉县',
  '颍上县': '颍上县',
  '阜南县': '阜南县',
  '太和县': '太和县',
  '宿州市': '宿州市',
  '埇桥区': '埇桥区',
  '永清县': '永清县',
  '香河县': '香河县',
  '砀山县': '砀山县',
  '灵璧县': '灵璧县',
  '巢湖市': '巢湖市',
  '居巢区': '居巢区',
  '含山县': '含山县',
  '无为县': '无为县',
  '庐江县': '庐江县',
  '大城县': '大城县',
  '六安市': '六安市',
  '金安区': '金安区',
  '裕安区': '裕安区',
  '文安县': '文安县',
  '霍山县': '霍山县',
  '霍邱县': '霍邱县',
  '舒城县': '舒城县',
  '金寨县': '金寨县',
  '亳州市': '亳州市',
  '谯城区': '谯城区',
  '利辛县': '利辛县',
  '涡阳县': '涡阳县',
  '蒙城县': '蒙城县',
  '池州市': '池州市',
  '贵池区': '贵池区',
  '东至县': '东至县',
  '石台县': '石台县',
  '青阳县': '青阳县',
  '宣城市': '宣城市',
  '宣州区': '宣州区',
  '宁国市': '宁国市',
  '广德县': '广德县',
  '郎溪县': '郎溪县',
  '宁河县': '宁河县',
  '旌德县': '旌德县',
  '绩溪县': '绩溪县',
  '福建省': '福建省',
  '福州市': '福州市',
  '台江区': '台江区',
  '仓山区': '仓山区',
  '马尾区': '马尾区',
  '晋安区': '晋安区',
  '福清市': '福清市',
  '长乐市': '长乐市',
  '闽侯县': '闽侯县',
  '闽清县': '闽清县',
  '永泰县': '永泰县',
  '连江县': '连江县',
  '罗源县': '罗源县',
  '平潭县': '平潭县',
  '厦门市': '厦门市',
  '思明区': '思明区',
  '海沧区': '海沧区',
  '湖里区': '湖里区',
  '集美区': '集美区',
  '同安区': '同安区',
  '翔安区': '翔安区',
  '莆田市': '莆田市',
  '城厢区': '城厢区',
  '涵江区': '涵江区',
  '荔城区': '荔城区',
  '秀屿区': '秀屿区',
  '仙游县': '仙游县',
  '三明市': '三明市',
  '梅列区': '梅列区',
  '三元区': '三元区',
  '永安市': '永安市',
  '明溪县': '明溪县',
  '将乐县': '将乐县',
  '大田县': '大田县',
  '宁化县': '宁化县',
  '建宁县': '建宁县',
  '霸州市': '霸州市',
  '尤溪县': '尤溪县',
  '清流县': '清流县',
  '泰宁县': '泰宁县',
  '泉州市': '泉州市',
  '鲤城区': '鲤城区',
  '丰泽区': '丰泽区',
  '洛江区': '洛江区',
  '泉港区': '泉港区',
  '石狮市': '石狮市',
  '晋江市': '晋江市',
  '南安市': '南安市',
  '惠安县': '惠安县',
  '永春县': '永春县',
  '安溪县': '安溪县',
  '德化县': '德化县',
  '金门县': '金门县',
  '漳州市': '漳州市',
  '芗城区': '芗城区',
  '龙文区': '龙文区',
  '龙海市': '龙海市',
  '平和县': '平和县',
  '南靖县': '南靖县',
  '诏安县': '诏安县',
  '漳浦县': '漳浦县',
  '华安县': '华安县',
  '东山县': '东山县',
  '长泰县': '长泰县',
  '云霄县': '云霄县',
  '南平市': '南平市',
  '延平区': '延平区',
  '建瓯市': '建瓯市',
  '邵武市': '邵武市',
  '三河市': '三河市',
  '建阳市': '建阳市',
  '松溪县': '松溪县',
  '光泽县': '光泽县',
  '顺昌县': '顺昌县',
  '浦城县': '浦城县',
  '政和县': '政和县',
  '龙岩市': '龙岩市',
  '新罗区': '新罗区',
  '漳平市': '漳平市',
  '长汀县': '长汀县',
  '武平县': '武平县',
  '上杭县': '上杭县',
  '永定县': '永定县',
  '连城县': '连城县',
  '宁德市': '宁德市',
  '蕉城区': '蕉城区',
  '福安市': '福安市',
  '福鼎市': '福鼎市',
  '寿宁县': '寿宁县',
  '霞浦县': '霞浦县',
  '柘荣县': '柘荣县',
  '屏南县': '屏南县',
  '古田县': '古田县',
  '周宁县': '周宁县',
  '江西省': '江西省',
  '南昌市': '南昌市',
  '东湖区': '东湖区',
  '衡水市': '衡水市',
  '湾里区': '湾里区',
  '东城区': '东城区',
  '新建县': '新建县',
  '南昌县': '南昌县',
  '进贤县': '进贤县',
  '安义县': '安义县',
  '枣强县': '枣强县',
  '珠山区': '珠山区',
  '昌江区': '昌江区',
  '乐平市': '乐平市',
  '浮梁县': '浮梁县',
  '萍乡市': '萍乡市',
  '安源区': '安源区',
  '湘东区': '湘东区',
  '莲花县': '莲花县',
  '上栗县': '上栗县',
  '芦溪县': '芦溪县',
  '九江市': '九江市',
  '浔阳区': '浔阳区',
  '庐山区': '庐山区',
  '瑞昌市': '瑞昌市',
  '九江县': '九江县',
  '星子县': '星子县',
  '武宁县': '武宁县',
  '彭泽县': '彭泽县',
  '永修县': '永修县',
  '修水县': '修水县',
  '湖口县': '湖口县',
  '德安县': '德安县',
  '都昌县': '都昌县',
  '新余市': '新余市',
  '渝水区': '渝水区',
  '分宜县': '分宜县',
  '鹰潭市': '鹰潭市',
  '月湖区': '月湖区',
  '贵溪市': '贵溪市',
  '余江县': '余江县',
  '赣州市': '赣州市',
  '章贡区': '章贡区',
  '瑞金市': '瑞金市',
  '南康市': '南康市',
  '石城县': '石城县',
  '安远县': '安远县',
  '武邑县': '武邑县',
  '宁都县': '宁都县',
  '寻乌县': '寻乌县',
  '兴国县': '兴国县',
  '定南县': '定南县',
  '上犹县': '上犹县',
  '于都县': '于都县',
  '龙南县': '龙南县',
  '崇义县': '崇义县',
  '信丰县': '信丰县',
  '全南县': '全南县',
  '大余县': '大余县',
  '会昌县': '会昌县',
  '吉安市': '吉安市',
  '吉州区': '吉州区',
  '青原区': '青原区',
  '武强县': '武强县',
  '吉安县': '吉安县',
  '永丰县': '永丰县',
  '永新县': '永新县',
  '新干县': '新干县',
  '泰和县': '泰和县',
  '峡江县': '峡江县',
  '遂川县': '遂川县',
  '安福县': '安福县',
  '吉水县': '吉水县',
  '万安县': '万安县',
  '宜春市': '宜春市',
  '袁州区': '袁州区',
  '丰城市': '丰城市',
  '樟树市': '樟树市',
  '高安市': '高安市',
  '铜鼓县': '铜鼓县',
  '靖安县': '靖安县',
  '宜丰县': '宜丰县',
  '奉新县': '奉新县',
  '万载县': '万载县',
  '上高县': '上高县',
  '抚州市': '抚州市',
  '临川区': '临川区',
  '南丰县': '南丰县',
  '乐安县': '乐安县',
  '金溪县': '金溪县',
  '南城县': '南城县',
  '东乡县': '东乡县',
  '资溪县': '资溪县',
  '宜黄县': '宜黄县',
  '广昌县': '广昌县',
  '黎川县': '黎川县',
  '崇仁县': '崇仁县',
  '上饶市': '上饶市',
  '信州区': '信州区',
  '德兴市': '德兴市',
  '上饶县': '上饶县',
  '广丰县': '广丰县',
  '鄱阳县': '鄱阳县',
  '婺源县': '婺源县',
  '铅山县': '铅山县',
  '余干县': '余干县',
  '横峰县': '横峰县',
  '弋阳县': '弋阳县',
  '玉山县': '玉山县',
  '万年县': '万年县',
  '山东省': '山东省',
  '济南市': '济南市',
  '市中区': '市中区',
  '历下区': '历下区',
  '天桥区': '天桥区',
  '槐荫区': '槐荫区',
  '历城区': '历城区',
  '长清区': '长清区',
  '章丘市': '章丘市',
  '平阴县': '平阴县',
  '济阳县': '济阳县',
  '商河县': '商河县',
  '青岛市': '青岛市',
  '市南区': '市南区',
  '市北区': '市北区',
  '城阳区': '城阳区',
  '四方区': '四方区',
  '李沧区': '李沧区',
  '黄岛区': '黄岛区',
  '崂山区': '崂山区',
  '胶南市': '胶南市',
  '胶州市': '胶州市',
  '平度市': '平度市',
  '莱西市': '莱西市',
  '即墨市': '即墨市',
  '淄博市': '淄博市',
  '张店区': '张店区',
  '临淄区': '临淄区',
  '淄川区': '淄川区',
  '博山区': '博山区',
  '周村区': '周村区',
  '桓台县': '桓台县',
  '高青县': '高青县',
  '沂源县': '沂源县',
  '枣庄市': '枣庄市',
  '山亭区': '山亭区',
  '峄城区': '峄城区',
  '饶阳县': '饶阳县',
  '薛城区': '薛城区',
  '滕州市': '滕州市',
  '东营市': '东营市',
  '东营区': '东营区',
  '河口区': '河口区',
  '垦利县': '垦利县',
  '广饶县': '广饶县',
  '利津县': '利津县',
  '烟台市': '烟台市',
  '芝罘区': '芝罘区',
  '福山区': '福山区',
  '牟平区': '牟平区',
  '莱山区': '莱山区',
  '龙口市': '龙口市',
  '莱阳市': '莱阳市',
  '莱州市': '莱州市',
  '招远市': '招远市',
  '蓬莱市': '蓬莱市',
  '栖霞市': '栖霞市',
  '海阳市': '海阳市',
  '长岛县': '长岛县',
  '潍坊市': '潍坊市',
  '潍城区': '潍城区',
  '寒亭区': '寒亭区',
  '坊子区': '坊子区',
  '奎文区': '奎文区',
  '青州市': '青州市',
  '诸城市': '诸城市',
  '寿光市': '寿光市',
  '安丘市': '安丘市',
  '高密市': '高密市',
  '昌邑市': '昌邑市',
  '昌乐县': '昌乐县',
  '临朐县': '临朐县',
  '济宁市': '济宁市',
  '任城区': '任城区',
  '曲阜市': '曲阜市',
  '兖州市': '兖州市',
  '邹城市': '邹城市',
  '鱼台县': '鱼台县',
  '金乡县': '金乡县',
  '嘉祥县': '嘉祥县',
  '微山县': '微山县',
  '汶上县': '汶上县',
  '泗水县': '泗水县',
  '梁山县': '梁山县',
  '泰安市': '泰安市',
  '泰山区': '泰山区',
  '岱岳区': '岱岳区',
  '新泰市': '新泰市',
  '肥城市': '肥城市',
  '宁阳县': '宁阳县',
  '东平县': '东平县',
  '威海市': '威海市',
  '环翠区': '环翠区',
  '乳山市': '乳山市',
  '文登市': '文登市',
  '荣成市': '荣成市',
  '日照市': '日照市',
  '东港区': '东港区',
  '岚山区': '岚山区',
  '五莲县': '五莲县',
  '大堂区': '大堂区',
  '莱芜市': '莱芜市',
  '莱城区': '莱城区',
  '钢城区': '钢城区',
  '临沂市': '临沂市',
  '兰山区': '兰山区',
  '罗庄区': '罗庄区',
  '沂南县': '沂南县',
  '郯城县': '郯城县',
  '沂水县': '沂水县',
  '苍山县': '苍山县',
  '安平县': '安平县',
  '平邑县': '平邑县',
  '莒南县': '莒南县',
  '蒙阴县': '蒙阴县',
  '临沭县': '临沭县',
  '德州市': '德州市',
  '德城区': '德城区',
  '乐陵市': '乐陵市',
  '禹城市': '禹城市',
  '故城县': '故城县',
  '宁津县': '宁津县',
  '齐河县': '齐河县',
  '武城县': '武城县',
  '庆云县': '庆云县',
  '平原县': '平原县',
  '夏津县': '夏津县',
  '临邑县': '临邑县',
  '聊城市': '聊城市',
  '静海县': '静海县',
  '临清市': '临清市',
  '高唐县': '高唐县',
  '阳谷县': '阳谷县',
  '茌平县': '茌平县',
  '高雄市': '高雄市',
  '东阿县': '东阿县',
  '台南市': '台南市',
  '滨州市': '滨州市',
  '滨城区': '滨城区',
  '邹平县': '邹平县',
  '沾化县': '沾化县',
  '惠民县': '惠民县',
  '博兴县': '博兴县',
  '阳信县': '阳信县',
  '无棣县': '无棣县',
  '菏泽市': '菏泽市',
  '牡丹区': '牡丹区',
  '鄄城县': '鄄城县',
  '台中市': '台中市',
  '郓城县': '郓城县',
  '桃园市': '桃园市',
  '定陶县': '定陶县',
  '巨野县': '巨野县',
  '东明县': '东明县',
  '成武县': '成武县',
  '河南省': '河南省',
  '郑州市': '郑州市',
  '中原区': '中原区',
  '金水区': '金水区',
  '二七区': '二七区',
  '阜城县': '阜城县',
  '上街区': '上街区',
  '惠济区': '惠济区',
  '巩义市': '巩义市',
  '新郑市': '新郑市',
  '新密市': '新密市',
  '登封市': '登封市',
  '荥阳市': '荥阳市',
  '中牟县': '中牟县',
  '开封市': '开封市',
  '龙亭区': '龙亭区',
  '冀州市': '冀州市',
  '深州市': '深州市',
  '金明区': '金明区',
  '开封县': '开封县',
  '尉氏县': '尉氏县',
  '兰考县': '兰考县',
  '新店区': '新店区',
  '通许县': '通许县',
  '洛阳市': '洛阳市',
  '西工区': '西工区',
  '老城区': '老城区',
  '涧西区': '涧西区',
  '山西省': '山西省',
  '洛龙区': '洛龙区',
  '吉利区': '吉利区',
  '偃师市': '偃师市',
  '孟津县': '孟津县',
  '汝阳县': '汝阳县',
  '伊川县': '伊川县',
  '洛宁县': '洛宁县',
  '汐止区': '汐止区',
  '宜阳县': '宜阳县',
  '新安县': '新安县',
  '栾川县': '栾川县',
  '太原市': '太原市',
  '卫东区': '卫东区',
  '湛河区': '湛河区',
  '石龙区': '石龙区',
  '汝州市': '汝州市',
  '舞钢市': '舞钢市',
  '宝丰县': '宝丰县',
  '板桥区': '板桥区',
  '新北市': '新北市',
  '鲁山县': '鲁山县',
  '安阳市': '安阳市',
  '北关区': '北关区',
  '文峰区': '文峰区',
  '殷都区': '殷都区',
  '龙安区': '龙安区',
  '林州市': '林州市',
  '安阳县': '安阳县',
  '北投区': '北投区',
  '内黄县': '内黄县',
  '汤阴县': '汤阴县',
  '鹤壁市': '鹤壁市',
  '淇滨区': '淇滨区',
  '山城区': '山城区',
  '鹤山区': '鹤山区',
  '士林区': '士林区',
  '文山区': '文山区',
  '新乡市': '新乡市',
  '卫滨区': '卫滨区',
  '红旗区': '红旗区',
  '凤泉区': '凤泉区',
  '牧野区': '牧野区',
  '卫辉市': '卫辉市',
  '辉县市': '辉县市',
  '新乡县': '新乡县',
  '获嘉县': '获嘉县',
  '原阳县': '原阳县',
  '长垣县': '长垣县',
  '封丘县': '封丘县',
  '延津县': '延津县',
  '焦作市': '焦作市',
  '解放区': '解放区',
  '中站区': '中站区',
  '马村区': '马村区',
  '山阳区': '山阳区',
  '沁阳市': '沁阳市',
  '孟州市': '孟州市',
  '修武县': '修武县',
  '信义区': '信义区',
  '武陟县': '武陟县',
  '博爱县': '博爱县',
  '濮阳市': '濮阳市',
  '华龙区': '华龙区',
  '濮阳县': '濮阳县',
  '南乐县': '南乐县',
  '台前县': '台前县',
  '清丰县': '清丰县',
  '万华区': '万华区',
  '许昌市': '许昌市',
  '魏都区': '魏都区',
  '禹州市': '禹州市',
  '长葛市': '长葛市',
  '许昌县': '许昌县',
  '鄢陵县': '鄢陵县',
  '襄城县': '襄城县',
  '漯河市': '漯河市',
  '源汇区': '源汇区',
  '郾城区': '郾城区',
  '召陵区': '召陵区',
  '临颍县': '临颍县',
  '舞阳县': '舞阳县',
  '小店区': '小店区',
  '湖滨区': '湖滨区',
  '义马市': '义马市',
  '灵宝市': '灵宝市',
  '渑池县': '渑池县',
  '卢氏县': '卢氏县',
  '中正区': '中正区',
  '南阳市': '南阳市',
  '卧龙区': '卧龙区',
  '宛城区': '宛城区',
  '邓州市': '邓州市',
  '桐柏县': '桐柏县',
  '方城县': '方城县',
  '淅川县': '淅川县',
  '镇平县': '镇平县',
  '唐河县': '唐河县',
  '南召县': '南召县',
  '内乡县': '内乡县',
  '新野县': '新野县',
  '社旗县': '社旗县',
  '西峡县': '西峡县',
  '商丘市': '商丘市',
  '梁园区': '梁园区',
  '睢阳区': '睢阳区',
  '永城市': '永城市',
  '宁陵县': '宁陵县',
  '虞城县': '虞城县',
  '民权县': '民权县',
  '夏邑县': '夏邑县',
  '柘城县': '柘城县',
  '南港区': '南港区',
  '信阳市': '信阳市',
  '浉河区': '浉河区',
  '平桥区': '平桥区',
  '潢川县': '潢川县',
  '淮滨县': '淮滨县',
  '内湖区': '内湖区',
  '台北市': '台北市',
  '商城县': '商城县',
  '固始县': '固始县',
  '罗山县': '罗山县',
  '光山县': '光山县',
  '周口市': '周口市',
  '川汇区': '川汇区',
  '项城市': '项城市',
  '商水县': '商水县',
  '淮阳县': '淮阳县',
  '太康县': '太康县',
  '鹿邑县': '鹿邑县',
  '西华县': '西华县',
  '扶沟县': '扶沟县',
  '沈丘县': '沈丘县',
  '郸城县': '郸城县',
  '迎泽区': '迎泽区',
  '驿城区': '驿城区',
  '确山县': '确山县',
  '新蔡县': '新蔡县',
  '上蔡县': '上蔡县',
  '西平县': '西平县',
  '泌阳县': '泌阳县',
  '平舆县': '平舆县',
  '汝南县': '汝南县',
  '遂平县': '遂平县',
  '正阳县': '正阳县',
  '济源市': '济源市',
  '湖北省': '湖北省',
  '武汉市': '武汉市',
  '江岸区': '江岸区',
  '武昌区': '武昌区',
  '江汉区': '江汉区',
  '硚口区': '硚口区',
  '汉阳区': '汉阳区',
  '洪山区': '洪山区',
  '崇文区': '崇文区',
  '汉南区': '汉南区',
  '蔡甸区': '蔡甸区',
  '江夏区': '江夏区',
  '黄陂区': '黄陂区',
  '新洲区': '新洲区',
  '黄石市': '黄石市',
  '河北省': '河北省',
  '宣武区': '宣武区',
  '下陆区': '下陆区',
  '铁山区': '铁山区',
  '大冶市': '大冶市',
  '阳新县': '阳新县',
  '十堰市': '十堰市',
  '张湾区': '张湾区',
  '茅箭区': '茅箭区',
  '晋源区': '晋源区',
  '台湾省': '台湾省',
  '竹山县': '竹山县',
  '清徐县': '清徐县',
  '郧西县': '郧西县',
  '竹溪县': '竹溪县',
  '荆州市': '荆州市',
  '沙市区': '沙市区',
  '荆州区': '荆州区',
  '洪湖市': '洪湖市',
  '石首市': '石首市',
  '松滋市': '松滋市',
  '监利县': '监利县',
  '公安县': '公安县',
  '江陵县': '江陵县',
  '宜昌市': '宜昌市',
  '西陵区': '西陵区',
  '阳曲县': '阳曲县',
  '点军区': '点军区',
  '猇亭区': '猇亭区',
  '夷陵区': '夷陵区',
  '宜都市': '宜都市',
  '当阳市': '当阳市',
  '枝江市': '枝江市',
  '秭归县': '秭归县',
  '远安县': '远安县',
  '兴山县': '兴山县',
  '娄烦县': '娄烦县',
  '古交市': '古交市',
  '襄樊市': '襄樊市',
  '襄城区': '襄城区',
  '樊城区': '樊城区',
  '襄阳区': '襄阳区',
  '大同市': '大同市',
  '枣阳市': '枣阳市',
  '宜城市': '宜城市',
  '南漳县': '南漳县',
  '谷城县': '谷城县',
  '保康县': '保康县',
  '鄂州市': '鄂州市',
  '鄂城区': '鄂城区',
  '华容区': '华容区',
  '长安区': '长安区',
  '荆门市': '荆门市',
  '东宝区': '东宝区',
  '掇刀区': '掇刀区',
  '钟祥市': '钟祥市',
  '京山县': '京山县',
  '沙洋县': '沙洋县',
  '孝感市': '孝感市',
  '孝南区': '孝南区',
  '应城市': '应城市',
  '安陆市': '安陆市',
  '汉川市': '汉川市',
  '云梦县': '云梦县',
  '大悟县': '大悟县',
  '孝昌县': '孝昌县',
  '黄冈市': '黄冈市',
  '黄州区': '黄州区',
  '麻城市': '麻城市',
  '武穴市': '武穴市',
  '红安县': '红安县',
  '罗田县': '罗田县',
  '浠水县': '浠水县',
  '蕲春县': '蕲春县',
  '黄梅县': '黄梅县',
  '英山县': '英山县',
  '团风县': '团风县',
  '咸宁市': '咸宁市',
  '咸安区': '咸安区',
  '赤壁市': '赤壁市',
  '嘉鱼县': '嘉鱼县',
  '通山县': '通山县',
  '崇阳县': '崇阳县',
  '通城县': '通城县',
  '随州市': '随州市',
  '曾都区': '曾都区',
  '广水市': '广水市',
  '桥东区': '桥东区',
  '恩施市': '恩施市',
  '利川市': '利川市',
  '建始县': '建始县',
  '来凤县': '来凤县',
  '巴东县': '巴东县',
  '鹤峰县': '鹤峰县',
  '宣恩县': '宣恩县',
  '咸丰县': '咸丰县',
  '仙桃市': '仙桃市',
  '南郊区': '南郊区',
  '天门市': '天门市',
  '新荣区': '新荣区',
  '潜江市': '潜江市',
  '巩留县': '巩留县',
  '阳高县': '阳高县',
  '湖南省': '湖南省',
  '长沙市': '长沙市',
  '岳麓区': '岳麓区',
  '芙蓉区': '芙蓉区',
  '天心区': '天心区',
  '开福区': '开福区',
  '雨花区': '雨花区',
  '浏阳市': '浏阳市',
  '长沙县': '长沙县',
  '望城县': '望城县',
  '宁乡县': '宁乡县',
  '株洲市': '株洲市',
  '天元区': '天元区',
  '荷塘区': '荷塘区',
  '芦淞区': '芦淞区',
  '石峰区': '石峰区',
  '醴陵市': '醴陵市',
  '株洲县': '株洲县',
  '炎陵县': '炎陵县',
  '茶陵县': '茶陵县',
  '霍城县': '霍城县',
  '湘潭市': '湘潭市',
  '岳塘区': '岳塘区',
  '雨湖区': '雨湖区',
  '湘乡市': '湘乡市',
  '韶山市': '韶山市',
  '湘潭县': '湘潭县',
  '衡阳市': '衡阳市',
  '雁峰区': '雁峰区',
  '珠晖区': '珠晖区',
  '石鼓区': '石鼓区',
  '蒸湘区': '蒸湘区',
  '南岳区': '南岳区',
  '耒阳市': '耒阳市',
  '常宁市': '常宁市',
  '衡阳县': '衡阳县',
  '衡东县': '衡东县',
  '衡山县': '衡山县',
  '衡南县': '衡南县',
  '祁东县': '祁东县',
  '邵阳市': '邵阳市',
  '双清区': '双清区',
  '大祥区': '大祥区',
  '北塔区': '北塔区',
  '武冈市': '武冈市',
  '邵东县': '邵东县',
  '洞口县': '洞口县',
  '新邵县': '新邵县',
  '绥宁县': '绥宁县',
  '新宁县': '新宁县',
  '邵阳县': '邵阳县',
  '隆回县': '隆回县',
  '天镇县': '天镇县',
  '岳阳市': '岳阳市',
  '广灵县': '广灵县',
  '云溪区': '云溪区',
  '君山区': '君山区',
  '临湘市': '临湘市',
  '汨罗市': '汨罗市',
  '岳阳县': '岳阳县',
  '湘阴县': '湘阴县',
  '平江县': '平江县',
  '华容县': '华容县',
  '常德市': '常德市',
  '武陵区': '武陵区',
  '鼎城区': '鼎城区',
  '津市市': '津市市',
  '新源县': '新源县',
  '临澧县': '临澧县',
  '桃源县': '桃源县',
  '汉寿县': '汉寿县',
  '安乡县': '安乡县',
  '石门县': '石门县',
  '灵丘县': '灵丘县',
  '永定区': '永定区',
  '浑源县': '浑源县',
  '慈利县': '慈利县',
  '桑植县': '桑植县',
  '益阳市': '益阳市',
  '赫山区': '赫山区',
  '资阳区': '资阳区',
  '沅江市': '沅江市',
  '桃江县': '桃江县',
  '昭苏县': '昭苏县',
  '安化县': '安化县',
  '郴州市': '郴州市',
  '北湖区': '北湖区',
  '苏仙区': '苏仙区',
  '资兴市': '资兴市',
  '宜章县': '宜章县',
  '汝城县': '汝城县',
  '安仁县': '安仁县',
  '嘉禾县': '嘉禾县',
  '临武县': '临武县',
  '桂东县': '桂东县',
  '永兴县': '永兴县',
  '桂阳县': '桂阳县',
  '永州市': '永州市',
  '左云县': '左云县',
  '零陵区': '零陵区',
  '祁阳县': '祁阳县',
  '蓝山县': '蓝山县',
  '宁远县': '宁远县',
  '新田县': '新田县',
  '东安县': '东安县',
  '江永县': '江永县',
  '大同县': '大同县',
  '双牌县': '双牌县',
  '阳泉市': '阳泉市',
  '怀化市': '怀化市',
  '鹤城区': '鹤城区',
  '洪江市': '洪江市',
  '会同县': '会同县',
  '沅陵县': '沅陵县',
  '辰溪县': '辰溪县',
  '溆浦县': '溆浦县',
  '中方县': '中方县',
  '平定县': '平定县',
  '桥西区': '桥西区',
  '长治市': '长治市',
  '长治县': '长治县',
  '襄垣县': '襄垣县',
  '娄底市': '娄底市',
  '娄星区': '娄星区',
  '屯留县': '屯留县',
  '涟源市': '涟源市',
  '新化县': '新化县',
  '双峰县': '双峰县',
  '平顺县': '平顺县',
  '吉首市': '吉首市',
  '古丈县': '古丈县',
  '龙山县': '龙山县',
  '永顺县': '永顺县',
  '凤凰县': '凤凰县',
  '泸溪县': '泸溪县',
  '保靖县': '保靖县',
  '花垣县': '花垣县',
  '广东省': '广东省',
  '广州市': '广州市',
  '越秀区': '越秀区',
  '荔湾区': '荔湾区',
  '海珠区': '海珠区',
  '天河区': '天河区',
  '白云区': '白云区',
  '黄埔区': '黄埔区',
  '番禺区': '番禺区',
  '花都区': '花都区',
  '南沙区': '南沙区',
  '萝岗区': '萝岗区',
  '增城市': '增城市',
  '从化市': '从化市',
  '深圳市': '深圳市',
  '福田区': '福田区',
  '罗湖区': '罗湖区',
  '宝安区': '宝安区',
  '龙岗区': '龙岗区',
  '盐田区': '盐田区',
  '东莞市': '东莞市',
  '黎城县': '黎城县',
  '伊宁县': '伊宁县',
  '奎屯市': '奎屯市',
  '中山市': '中山市',
  '伊宁市': '伊宁市',
  '潮州市': '潮州市',
  '湘桥区': '湘桥区',
  '潮安县': '潮安县',
  '饶平县': '饶平县',
  '揭阳市': '揭阳市',
  '榕城区': '榕城区',
  '揭东县': '揭东县',
  '揭西县': '揭西县',
  '惠来县': '惠来县',
  '普宁市': '普宁市',
  '云浮市': '云浮市',
  '云城区': '云城区',
  '新兴县': '新兴县',
  '郁南县': '郁南县',
  '云安县': '云安县',
  '罗定市': '罗定市',
  '珠海市': '珠海市',
  '香洲区': '香洲区',
  '斗门区': '斗门区',
  '金湾区': '金湾区',
  '汕头市': '汕头市',
  '金平区': '金平区',
  '濠江区': '濠江区',
  '龙湖区': '龙湖区',
  '潮阳区': '潮阳区',
  '潮南区': '潮南区',
  '澄海区': '澄海区',
  '南澳县': '南澳县',
  '韶关市': '韶关市',
  '浈江区': '浈江区',
  '武江区': '武江区',
  '曲江区': '曲江区',
  '乐昌市': '乐昌市',
  '南雄市': '南雄市',
  '始兴县': '始兴县',
  '仁化县': '仁化县',
  '翁源县': '翁源县',
  '新丰县': '新丰县',
  '壶关县': '壶关县',
  '佛山市': '佛山市',
  '禅城区': '禅城区',
  '南海区': '南海区',
  '顺德区': '顺德区',
  '三水区': '三水区',
  '高明区': '高明区',
  '江门市': '江门市',
  '蓬江区': '蓬江区',
  '江海区': '江海区',
  '新会区': '新会区',
  '恩平市': '恩平市',
  '台山市': '台山市',
  '开平市': '开平市',
  '鹤山市': '鹤山市',
  '湛江市': '湛江市',
  '赤坎区': '赤坎区',
  '霞山区': '霞山区',
  '坡头区': '坡头区',
  '麻章区': '麻章区',
  '吴川市': '吴川市',
  '廉江市': '廉江市',
  '雷州市': '雷州市',
  '遂溪县': '遂溪县',
  '徐闻县': '徐闻县',
  '茂名市': '茂名市',
  '茂南区': '茂南区',
  '茂港区': '茂港区',
  '化州市': '化州市',
  '信宜市': '信宜市',
  '高州市': '高州市',
  '电白县': '电白县',
  '肇庆市': '肇庆市',
  '端州区': '端州区',
  '鼎湖区': '鼎湖区',
  '高要市': '高要市',
  '四会市': '四会市',
  '广宁县': '广宁县',
  '怀集县': '怀集县',
  '封开县': '封开县',
  '德庆县': '德庆县',
  '惠州市': '惠州市',
  '惠城区': '惠城区',
  '惠阳区': '惠阳区',
  '博罗县': '博罗县',
  '惠东县': '惠东县',
  '龙门县': '龙门县',
  '梅州市': '梅州市',
  '梅江区': '梅江区',
  '兴宁市': '兴宁市',
  '长子县': '长子县',
  '大埔县': '大埔县',
  '丰顺县': '丰顺县',
  '五华县': '五华县',
  '平远县': '平远县',
  '蕉岭县': '蕉岭县',
  '汕尾市': '汕尾市',
  '五家渠': '五家渠',
  '陆丰市': '陆丰市',
  '海丰县': '海丰县',
  '陆河县': '陆河县',
  '河源市': '河源市',
  '源城区': '源城区',
  '紫金县': '紫金县',
  '龙川县': '龙川县',
  '连平县': '连平县',
  '和平县': '和平县',
  '东源县': '东源县',
  '阳江市': '阳江市',
  '江城区': '江城区',
  '阳春市': '阳春市',
  '阳西县': '阳西县',
  '阳东县': '阳东县',
  '清远市': '清远市',
  '清城区': '清城区',
  '英德市': '英德市',
  '连州市': '连州市',
  '佛冈县': '佛冈县',
  '阳山县': '阳山县',
  '清新县': '清新县',
  '武乡县': '武乡县',
  '新华区': '新华区',
  '沁源县': '沁源县',
  '南宁市': '南宁市',
  '青秀区': '青秀区',
  '兴宁区': '兴宁区',
  '潞城市': '潞城市',
  '良庆区': '良庆区',
  '江南区': '江南区',
  '邕宁区': '邕宁区',
  '武鸣县': '武鸣县',
  '隆安县': '隆安县',
  '马山县': '马山县',
  '上林县': '上林县',
  '宾阳县': '宾阳县',
  '阿拉尔': '阿拉尔',
  '柳州市': '柳州市',
  '城中区': '城中区',
  '鱼峰区': '鱼峰区',
  '柳北区': '柳北区',
  '柳南区': '柳南区',
  '柳江县': '柳江县',
  '柳城县': '柳城县',
  '鹿寨县': '鹿寨县',
  '融安县': '融安县',
  '晋城市': '晋城市',
  '沁水县': '沁水县',
  '桂林市': '桂林市',
  '象山区': '象山区',
  '秀峰区': '秀峰区',
  '叠彩区': '叠彩区',
  '七星区': '七星区',
  '雁山区': '雁山区',
  '阳朔县': '阳朔县',
  '临桂县': '临桂县',
  '灵川县': '灵川县',
  '全州县': '全州县',
  '平乐县': '平乐县',
  '兴安县': '兴安县',
  '灌阳县': '灌阳县',
  '荔浦县': '荔浦县',
  '资源县': '资源县',
  '永福县': '永福县',
  '阳城县': '阳城县',
  '陵川县': '陵川县',
  '梧州市': '梧州市',
  '万秀区': '万秀区',
  '蝶山区': '蝶山区',
  '长洲区': '长洲区',
  '岑溪市': '岑溪市',
  '苍梧县': '苍梧县',
  '石河子': '石河子',
  '蒙山县': '蒙山县',
  '北海市': '北海市',
  '海城区': '海城区',
  '银海区': '银海区',
  '泽州县': '泽州县',
  '合浦县': '合浦县',
  '高平市': '高平市',
  '港口区': '港口区',
  '防城区': '防城区',
  '东兴市': '东兴市',
  '上思县': '上思县',
  '钦州市': '钦州市',
  '钦南区': '钦南区',
  '钦北区': '钦北区',
  '灵山县': '灵山县',
  '浦北县': '浦北县',
  '贵港市': '贵港市',
  '港北区': '港北区',
  '港南区': '港南区',
  '覃塘区': '覃塘区',
  '桂平市': '桂平市',
  '平南县': '平南县',
  '玉林市': '玉林市',
  '玉州区': '玉州区',
  '北流市': '北流市',
  '温泉县': '温泉县',
  '陆川县': '陆川县',
  '博白县': '博白县',
  '兴业县': '兴业县',
  '百色市': '百色市',
  '右江区': '右江区',
  '凌云县': '凌云县',
  '平果县': '平果县',
  '西林县': '西林县',
  '乐业县': '乐业县',
  '德保县': '德保县',
  '田林县': '田林县',
  '田阳县': '田阳县',
  '靖西县': '靖西县',
  '田东县': '田东县',
  '那坡县': '那坡县',
  '朔州市': '朔州市',
  '贺州市': '贺州市',
  '八步区': '八步区',
  '钟山县': '钟山县',
  '昭平县': '昭平县',
  '朔城区': '朔城区',
  '河池市': '河池市',
  '平鲁区': '平鲁区',
  '宜州市': '宜州市',
  '天峨县': '天峨县',
  '凤山县': '凤山县',
  '南丹县': '南丹县',
  '东兰县': '东兰县',
  '山阴县': '山阴县',
  '朝阳区': '朝阳区',
  '右玉县': '右玉县',
  '怀仁县': '怀仁县',
  '忻州市': '忻州市',
  '来宾市': '来宾市',
  '兴宾区': '兴宾区',
  '合山市': '合山市',
  '象州县': '象州县',
  '武宣县': '武宣县',
  '忻城县': '忻城县',
  '忻府区': '忻府区',
  '崇左市': '崇左市',
  '江州区': '江州区',
  '凭祥市': '凭祥市',
  '宁明县': '宁明县',
  '扶绥县': '扶绥县',
  '龙州县': '龙州县',
  '大新县': '大新县',
  '天等县': '天等县',
  '海南省': '海南省',
  '海口市': '海口市',
  '龙华区': '龙华区',
  '秀英区': '秀英区',
  '琼山区': '琼山区',
  '美兰区': '美兰区',
  '三亚市': '三亚市',
  '原平市': '原平市',
  '五指山': '五指山',
  '琼海市': '琼海市',
  '精河县': '精河县',
  '儋州市': '儋州市',
  '博乐市': '博乐市',
  '文昌市': '文昌市',
  '定襄县': '定襄县',
  '万宁市': '万宁市',
  '米泉市': '米泉市',
  '东方市': '东方市',
  '五台县': '五台县',
  '澄迈县': '澄迈县',
  '定安县': '定安县',
  '屯昌县': '屯昌县',
  '临高县': '临高县',
  '丰台区': '丰台区',
  '繁峙县': '繁峙县',
  '宁武县': '宁武县',
  '静乐县': '静乐县',
  '神池县': '神池县',
  '五寨县': '五寨县',
  '重庆市': '重庆市',
  '渝中区': '渝中区',
  '岢岚县': '岢岚县',
  '南岸区': '南岸区',
  '北碚区': '北碚区',
  '渝北区': '渝北区',
  '巴南区': '巴南区',
  '长寿区': '长寿区',
  '河曲县': '河曲县',
  '万盛区': '万盛区',
  '万州区': '万州区',
  '涪陵区': '涪陵区',
  '黔江区': '黔江区',
  '永川区': '永川区',
  '合川区': '合川区',
  '江津区': '江津区',
  '保德县': '保德县',
  '南川区': '南川区',
  '綦江县': '綦江县',
  '潼南县': '潼南县',
  '荣昌县': '荣昌县',
  '璧山县': '璧山县',
  '大足县': '大足县',
  '铜梁县': '铜梁县',
  '梁平县': '梁平县',
  '偏关县': '偏关县',
  '吕梁市': '吕梁市',
  '城口县': '城口县',
  '垫江县': '垫江县',
  '武隆县': '武隆县',
  '丰都县': '丰都县',
  '奉节县': '奉节县',
  '云阳县': '云阳县',
  '巫溪县': '巫溪县',
  '巫山县': '巫山县',
  '离石区': '离石区',
  '孝义市': '孝义市',
  '汾阳市': '汾阳市',
  '文水县': '文水县',
  '四川省': '四川省',
  '成都市': '成都市',
  '青羊区': '青羊区',
  '锦江区': '锦江区',
  '金牛区': '金牛区',
  '武侯区': '武侯区',
  '成华区': '成华区',
  '交城县': '交城县',
  '井陉县': '井陉县',
  '新都区': '新都区',
  '温江区': '温江区',
  '正定县': '正定县',
  '彭州市': '彭州市',
  '邛崃市': '邛崃市',
  '崇州市': '崇州市',
  '金堂县': '金堂县',
  '柳林县': '柳林县',
  '新津县': '新津县',
  '双流县': '双流县',
  '蒲江县': '蒲江县',
  '大邑县': '大邑县',
  '自贡市': '自贡市',
  '大安区': '大安区',
  '石楼县': '石楼县',
  '贡井区': '贡井区',
  '沿滩区': '沿滩区',
  '奇台县': '奇台县',
  '富顺县': '富顺县',
  '栾城县': '栾城县',
  '仁和区': '仁和区',
  '米易县': '米易县',
  '盐边县': '盐边县',
  '阜康市': '阜康市',
  '昌吉市': '昌吉市',
  '泸州市': '泸州市',
  '江阳区': '江阳区',
  '纳溪区': '纳溪区',
  '方山县': '方山县',
  '中阳县': '中阳县',
  '合江县': '合江县',
  '叙永县': '叙永县',
  '古蔺县': '古蔺县',
  '德阳市': '德阳市',
  '旌阳区': '旌阳区',
  '广汉市': '广汉市',
  '什邡市': '什邡市',
  '绵竹市': '绵竹市',
  '罗江县': '罗江县',
  '中江县': '中江县',
  '绵阳市': '绵阳市',
  '涪城区': '涪城区',
  '游仙区': '游仙区',
  '江油市': '江油市',
  '盐亭县': '盐亭县',
  '三台县': '三台县',
  '平武县': '平武县',
  '交口县': '交口县',
  '梓潼县': '梓潼县',
  '晋中市': '晋中市',
  '广元市': '广元市',
  '元坝区': '元坝区',
  '朝天区': '朝天区',
  '青川县': '青川县',
  '旺苍县': '旺苍县',
  '剑阁县': '剑阁县',
  '苍溪县': '苍溪县',
  '遂宁市': '遂宁市',
  '船山区': '船山区',
  '安居区': '安居区',
  '射洪县': '射洪县',
  '蓬溪县': '蓬溪县',
  '大英县': '大英县',
  '内江市': '内江市',
  '东兴区': '东兴区',
  '资中县': '资中县',
  '隆昌县': '隆昌县',
  '威远县': '威远县',
  '乐山市': '乐山市',
  '榆次市': '榆次市',
  '沙湾区': '沙湾区',
  '介休市': '介休市',
  '榆社县': '榆社县',
  '夹江县': '夹江县',
  '井研县': '井研县',
  '犍为县': '犍为县',
  '沐川县': '沐川县',
  '左权县': '左权县',
  '和顺县': '和顺县',
  '若羌县': '若羌县',
  '顺庆区': '顺庆区',
  '高坪区': '高坪区',
  '嘉陵区': '嘉陵区',
  '阆中市': '阆中市',
  '营山县': '营山县',
  '蓬安县': '蓬安县',
  '仪陇县': '仪陇县',
  '南部县': '南部县',
  '西充县': '西充县',
  '眉山市': '眉山市',
  '东坡区': '东坡区',
  '仁寿县': '仁寿县',
  '彭山县': '彭山县',
  '洪雅县': '洪雅县',
  '丹棱县': '丹棱县',
  '青神县': '青神县',
  '宜宾市': '宜宾市',
  '翠屏区': '翠屏区',
  '宜宾县': '宜宾县',
  '兴文县': '兴文县',
  '南溪县': '南溪县',
  '轮台县': '轮台县',
  '长宁县': '长宁县',
  '博湖县': '博湖县',
  '江安县': '江安县',
  '筠连县': '筠连县',
  '屏山县': '屏山县',
  '广安市': '广安市',
  '广安区': '广安区',
  '华蓥市': '华蓥市',
  '岳池县': '岳池县',
  '邻水县': '邻水县',
  '武胜县': '武胜县',
  '达州市': '达州市',
  '通川区': '通川区',
  '万源市': '万源市',
  '且末县': '且末县',
  '和硕县': '和硕县',
  '宣汉县': '宣汉县',
  '开江县': '开江县',
  '大竹县': '大竹县',
  '雅安市': '雅安市',
  '雨城区': '雨城区',
  '芦山县': '芦山县',
  '石棉县': '石棉县',
  '名山县': '名山县',
  '天全县': '天全县',
  '荥经县': '荥经县',
  '宝兴县': '宝兴县',
  '汉源县': '汉源县',
  '巴中市': '巴中市',
  '巴州区': '巴州区',
  '南江县': '南江县',
  '平昌县': '平昌县',
  '通江县': '通江县',
  '资阳市': '资阳市',
  '雁江区': '雁江区',
  '简阳市': '简阳市',
  '安岳县': '安岳县',
  '乐至县': '乐至县',
  '昔阳县': '昔阳县',
  '寿阳县': '寿阳县',
  '太谷县': '太谷县',
  '红原县': '红原县',
  '汶川县': '汶川县',
  '阿坝县': '阿坝县',
  '尉犁县': '尉犁县',
  '行唐县': '行唐县',
  '小金县': '小金县',
  '黑水县': '黑水县',
  '金川县': '金川县',
  '松潘县': '松潘县',
  '壤塘县': '壤塘县',
  '和静县': '和静县',
  '平遥县': '平遥县',
  '康定县': '康定县',
  '丹巴县': '丹巴县',
  '炉霍县': '炉霍县',
  '九龙县': '九龙县',
  '甘孜县': '甘孜县',
  '雅江县': '雅江县',
  '新龙县': '新龙县',
  '道孚县': '道孚县',
  '白玉县': '白玉县',
  '理塘县': '理塘县',
  '德格县': '德格县',
  '乡城县': '乡城县',
  '石渠县': '石渠县',
  '稻城县': '稻城县',
  '色达县': '色达县',
  '巴塘县': '巴塘县',
  '泸定县': '泸定县',
  '得荣县': '得荣县',
  '灵石县': '灵石县',
  '西昌市': '西昌市',
  '美姑县': '美姑县',
  '昭觉县': '昭觉县',
  '金阳县': '金阳县',
  '甘洛县': '甘洛县',
  '布拖县': '布拖县',
  '雷波县': '雷波县',
  '普格县': '普格县',
  '宁南县': '宁南县',
  '喜德县': '喜德县',
  '会东县': '会东县',
  '越西县': '越西县',
  '会理县': '会理县',
  '盐源县': '盐源县',
  '德昌县': '德昌县',
  '冕宁县': '冕宁县',
  '临汾市': '临汾市',
  '贵州省': '贵州省',
  '贵阳市': '贵阳市',
  '南明区': '南明区',
  '云岩区': '云岩区',
  '花溪区': '花溪区',
  '乌当区': '乌当区',
  '小河区': '小河区',
  '清镇市': '清镇市',
  '开阳县': '开阳县',
  '修文县': '修文县',
  '息烽县': '息烽县',
  '侯马市': '侯马市',
  '钟山区': '钟山区',
  '水城县': '水城县',
  '霍州市': '霍州市',
  '曲沃县': '曲沃县',
  '遵义市': '遵义市',
  '翼城县': '翼城县',
  '汇川区': '汇川区',
  '赤水市': '赤水市',
  '仁怀市': '仁怀市',
  '遵义县': '遵义县',
  '绥阳县': '绥阳县',
  '桐梓县': '桐梓县',
  '习水县': '习水县',
  '凤冈县': '凤冈县',
  '正安县': '正安县',
  '余庆县': '余庆县',
  '湄潭县': '湄潭县',
  '襄汾县': '襄汾县',
  '洪洞县': '洪洞县',
  '安顺市': '安顺市',
  '西秀区': '西秀区',
  '普定县': '普定县',
  '平坝县': '平坝县',
  '灵寿县': '灵寿县',
  '安泽县': '安泽县',
  '浮山县': '浮山县',
  '高邑县': '高邑县',
  '铜仁市': '铜仁市',
  '德江县': '德江县',
  '江口县': '江口县',
  '思南县': '思南县',
  '石阡县': '石阡县',
  '乡宁县': '乡宁县',
  '深泽县': '深泽县',
  '大宁县': '大宁县',
  '永和县': '永和县',
  '赞皇县': '赞皇县',
  '汾西县': '汾西县',
  '毕节市': '毕节市',
  '黔西县': '黔西县',
  '大方县': '大方县',
  '织金县': '织金县',
  '金沙县': '金沙县',
  '赫章县': '赫章县',
  '纳雍县': '纳雍县',
  '运城市': '运城市',
  '永济市': '永济市',
  '兴义市': '兴义市',
  '望谟县': '望谟县',
  '兴仁县': '兴仁县',
  '普安县': '普安县',
  '册亨县': '册亨县',
  '晴隆县': '晴隆县',
  '贞丰县': '贞丰县',
  '安龙县': '安龙县',
  '河津市': '河津市',
  '凯里市': '凯里市',
  '施秉县': '施秉县',
  '从江县': '从江县',
  '锦屏县': '锦屏县',
  '镇远县': '镇远县',
  '麻江县': '麻江县',
  '台江县': '台江县',
  '天柱县': '天柱县',
  '黄平县': '黄平县',
  '榕江县': '榕江县',
  '剑河县': '剑河县',
  '三穗县': '三穗县',
  '雷山县': '雷山县',
  '黎平县': '黎平县',
  '岑巩县': '岑巩县',
  '丹寨县': '丹寨县',
  '芮城县': '芮城县',
  '都匀市': '都匀市',
  '福泉市': '福泉市',
  '贵定县': '贵定县',
  '惠水县': '惠水县',
  '罗甸县': '罗甸县',
  '瓮安县': '瓮安县',
  '荔波县': '荔波县',
  '龙里县': '龙里县',
  '平塘县': '平塘县',
  '长顺县': '长顺县',
  '独山县': '独山县',
  '临猗县': '临猗县',
  '云南省': '云南省',
  '昆明市': '昆明市',
  '盘龙区': '盘龙区',
  '五华区': '五华区',
  '官渡区': '官渡区',
  '西山区': '西山区',
  '东川区': '东川区',
  '安宁市': '安宁市',
  '呈贡县': '呈贡县',
  '晋宁县': '晋宁县',
  '富民县': '富民县',
  '宜良县': '宜良县',
  '嵩明县': '嵩明县',
  '万荣县': '万荣县',
  '新绛县': '新绛县',
  '稷山县': '稷山县',
  '曲靖市': '曲靖市',
  '麒麟区': '麒麟区',
  '宣威市': '宣威市',
  '马龙县': '马龙县',
  '沾益县': '沾益县',
  '富源县': '富源县',
  '罗平县': '罗平县',
  '师宗县': '师宗县',
  '陆良县': '陆良县',
  '会泽县': '会泽县',
  '玉溪市': '玉溪市',
  '红塔区': '红塔区',
  '江川县': '江川县',
  '澄江县': '澄江县',
  '通海县': '通海县',
  '华宁县': '华宁县',
  '易门县': '易门县',
  '闻喜县': '闻喜县',
  '无极县': '无极县',
  '平山县': '平山县',
  '保山市': '保山市',
  '隆阳区': '隆阳区',
  '施甸县': '施甸县',
  '腾冲县': '腾冲县',
  '龙陵县': '龙陵县',
  '昌宁县': '昌宁县',
  '昭通市': '昭通市',
  '昭阳区': '昭阳区',
  '鲁甸县': '鲁甸县',
  '巧家县': '巧家县',
  '盐津县': '盐津县',
  '大关县': '大关县',
  '永善县': '永善县',
  '绥江县': '绥江县',
  '镇雄县': '镇雄县',
  '彝良县': '彝良县',
  '威信县': '威信县',
  '水富县': '水富县',
  '丽江市': '丽江市',
  '古城区': '古城区',
  '永胜县': '永胜县',
  '华坪县': '华坪县',
  '平陆县': '平陆县',
  '垣曲县': '垣曲县',
  '普洱市': '普洱市',
  '思茅区': '思茅区',
  '内蒙古': '内蒙古',
  '元氏县': '元氏县',
  '新城区': '新城区',
  '回民区': '回民区',
  '玉泉区': '玉泉区',
  '北京市': '北京市',
  '辛集市': '辛集市',
  '湾仔区': '湾仔区',
  '晋州市': '晋州市',
  '临沧市': '临沧市',
  '临翔区': '临翔区',
  '凤庆县': '凤庆县',
  '武川县': '武川县',
  '永德县': '永德县',
  '镇康县': '镇康县',
  '包头市': '包头市',
  '东河区': '东河区',
  '新乐市': '新乐市',
  '青山区': '青山区',
  '潞西市': '潞西市',
  '瑞丽市': '瑞丽市',
  '梁河县': '梁河县',
  '盈江县': '盈江县',
  '陇川县': '陇川县',
  '鹿泉市': '鹿泉市',
  '泸水县': '泸水县',
  '福贡县': '福贡县',
  '唐山市': '唐山市',
  '路南区': '路南区',
  '固阳县': '固阳县',
  '路北区': '路北区',
  '德钦县': '德钦县',
  '乌海市': '乌海市',
  '古冶区': '古冶区',
  '大理市': '大理市',
  '祥云县': '祥云县',
  '宾川县': '宾川县',
  '弥渡县': '弥渡县',
  '永平县': '永平县',
  '云龙县': '云龙县',
  '洱源县': '洱源县',
  '剑川县': '剑川县',
  '鹤庆县': '鹤庆县',
  '海南区': '海南区',
  '乌达区': '乌达区',
  '赤峰市': '赤峰市',
  '红山区': '红山区',
  '楚雄市': '楚雄市',
  '双柏县': '双柏县',
  '牟定县': '牟定县',
  '南华县': '南华县',
  '姚安县': '姚安县',
  '大姚县': '大姚县',
  '永仁县': '永仁县',
  '元谋县': '元谋县',
  '武定县': '武定县',
  '禄丰县': '禄丰县',
  '开平区': '开平区',
  '蒙自县': '蒙自县',
  '个旧市': '个旧市',
  '开远市': '开远市',
  '绿春县': '绿春县',
  '建水县': '建水县',
  '石屏县': '石屏县',
  '弥勒县': '弥勒县',
  '泸西县': '泸西县',
  '元阳县': '元阳县',
  '红河县': '红河县',
  '松山区': '松山区',
  '海淀区': '海淀区',
  '丰润县': '丰润县',
  '西城区': '西城区',
  '文山县': '文山县',
  '砚山县': '砚山县',
  '西畴县': '西畴县',
  '林西县': '林西县',
  '马关县': '马关县',
  '丘北县': '丘北县',
  '广南县': '广南县',
  '富宁县': '富宁县',
  '滦南县': '滦南县',
  '景洪市': '景洪市',
  '勐海县': '勐海县',
  '勐腊县': '勐腊县',
  '乐亭县': '乐亭县',
  '拉萨市': '拉萨市',
  '城关区': '城关区',
  '林周县': '林周县',
  '当雄县': '当雄县',
  '尼木县': '尼木县',
  '曲水县': '曲水县',
  '迁西县': '迁西县',
  '达孜县': '达孜县',
  '宁城县': '宁城县',
  '敖汉旗': '敖汉旗',
  '那曲县': '那曲县',
  '嘉黎县': '嘉黎县',
  '比如县': '比如县',
  '聂荣县': '聂荣县',
  '安多县': '安多县',
  '申扎县': '申扎县',
  '乌恰县': '乌恰县',
  '班戈县': '班戈县',
  '巴青县': '巴青县',
  '尼玛县': '尼玛县',
  '玉田县': '玉田县',
  '昌都县': '昌都县',
  '江达县': '江达县',
  '贡觉县': '贡觉县',
  '唐海县': '唐海县',
  '丁青县': '丁青县',
  '察雅县': '察雅县',
  '八宿县': '八宿县',
  '左贡县': '左贡县',
  '芒康县': '芒康县',
  '洛隆县': '洛隆县',
  '边坝县': '边坝县',
  '遵化市': '遵化市',
  '林芝县': '林芝县',
  '丰南市': '丰南市',
  '米林县': '米林县',
  '墨脱县': '墨脱县',
  '波密县': '波密县',
  '察隅县': '察隅县',
  '迁安市': '迁安市',
  '根河市': '根河市',
  '乃东县': '乃东县',
  '扎囊县': '扎囊县',
  '贡嘎县': '贡嘎县',
  '桑日县': '桑日县',
  '琼结县': '琼结县',
  '曲松县': '曲松县',
  '措美县': '措美县',
  '洛扎县': '洛扎县',
  '加查县': '加查县',
  '隆子县': '隆子县',
  '错那县': '错那县',
  '房山区': '房山区',
  '阿荣旗': '阿荣旗',
  '海港区': '海港区',
  '通州区': '通州区',
  '江孜县': '江孜县',
  '定日县': '定日县',
  '萨迦县': '萨迦县',
  '拉孜县': '拉孜县',
  '昂仁县': '昂仁县',
  '顺义区': '顺义区',
  '白朗县': '白朗县',
  '仁布县': '仁布县',
  '康马县': '康马县',
  '定结县': '定结县',
  '仲巴县': '仲巴县',
  '亚东县': '亚东县',
  '吉隆县': '吉隆县',
  '昌平区': '昌平区',
  '萨嘎县': '萨嘎县',
  '岗巴县': '岗巴县',
  '昌黎县': '昌黎县',
  '噶尔县': '噶尔县',
  '普兰县': '普兰县',
  '札达县': '札达县',
  '日土县': '日土县',
  '革吉县': '革吉县',
  '改则县': '改则县',
  '措勤县': '措勤县',
  '陕西省': '陕西省',
  '西安市': '西安市',
  '莲湖区': '莲湖区',
  '碑林区': '碑林区',
  '雁塔区': '雁塔区',
  '灞桥区': '灞桥区',
  '未央区': '未央区',
  '阎良区': '阎良区',
  '临潼区': '临潼区',
  '高陵县': '高陵县',
  '蓝田县': '蓝田县',
  '抚宁县': '抚宁县',
  '周至县': '周至县',
  '铜川市': '铜川市',
  '耀州区': '耀州区',
  '王益区': '王益区',
  '印台区': '印台区',
  '宜君县': '宜君县',
  '宝鸡市': '宝鸡市',
  '渭滨区': '渭滨区',
  '金台区': '金台区',
  '陈仓区': '陈仓区',
  '岐山县': '岐山县',
  '凤翔县': '凤翔县',
  '兴安盟': '兴安盟',
  '太白县': '太白县',
  '麟游县': '麟游县',
  '扶风县': '扶风县',
  '千阳县': '千阳县',
  '卢龙县': '卢龙县',
  '疏附县': '疏附县',
  '咸阳市': '咸阳市',
  '秦都区': '秦都区',
  '渭城区': '渭城区',
  '杨陵区': '杨陵区',
  '兴平市': '兴平市',
  '礼泉县': '礼泉县',
  '泾阳县': '泾阳县',
  '永寿县': '永寿县',
  '三原县': '三原县',
  '莎车县': '莎车县',
  '旬邑县': '旬邑县',
  '长武县': '长武县',
  '邯郸市': '邯郸市',
  '武功县': '武功县',
  '淳化县': '淳化县',
  '渭南市': '渭南市',
  '临渭区': '临渭区',
  '韩城市': '韩城市',
  '华阴市': '华阴市',
  '蒲城县': '蒲城县',
  '潼关县': '潼关县',
  '白水县': '白水县',
  '澄城县': '澄城县',
  '邯山区': '邯山区',
  '合阳县': '合阳县',
  '富平县': '富平县',
  '大荔县': '大荔县',
  '延安市': '延安市',
  '宝塔区': '宝塔区',
  '安塞县': '安塞县',
  '洛川县': '洛川县',
  '子长县': '子长县',
  '黄陵县': '黄陵县',
  '延川县': '延川县',
  '疏勒县': '疏勒县',
  '延长县': '延长县',
  '甘泉县': '甘泉县',
  '宜川县': '宜川县',
  '志丹县': '志丹县',
  '黄龙县': '黄龙县',
  '吴起县': '吴起县',
  '汉中市': '汉中市',
  '汉台区': '汉台区',
  '留坝县': '留坝县',
  '镇巴县': '镇巴县',
  '城固县': '城固县',
  '南郑县': '南郑县',
  '丛台区': '丛台区',
  '宁强县': '宁强县',
  '佛坪县': '佛坪县',
  '叶城县': '叶城县',
  '西乡县': '西乡县',
  '略阳县': '略阳县',
  '榆林市': '榆林市',
  '榆阳区': '榆阳区',
  '清涧县': '清涧县',
  '绥德县': '绥德县',
  '神木县': '神木县',
  '伽师县': '伽师县',
  '府谷县': '府谷县',
  '子洲县': '子洲县',
  '靖边县': '靖边县',
  '横山县': '横山县',
  '米脂县': '米脂县',
  '吴堡县': '吴堡县',
  '定边县': '定边县',
  '安康市': '安康市',
  '汉滨区': '汉滨区',
  '紫阳县': '紫阳县',
  '岚皋县': '岚皋县',
  '旬阳县': '旬阳县',
  '镇坪县': '镇坪县',
  '平利县': '平利县',
  '石泉县': '石泉县',
  '宁陕县': '宁陕县',
  '白河县': '白河县',
  '汉阴县': '汉阴县',
  '商洛市': '商洛市',
  '商州区': '商州区',
  '镇安县': '镇安县',
  '山阳县': '山阳县',
  '洛南县': '洛南县',
  '商南县': '商南县',
  '丹凤县': '丹凤县',
  '柞水县': '柞水县',
  '甘肃省': '甘肃省',
  '兰州市': '兰州市',
  '复兴区': '复兴区',
  '西固区': '西固区',
  '安宁区': '安宁区',
  '红古区': '红古区',
  '永登县': '永登县',
  '皋兰县': '皋兰县',
  '榆中县': '榆中县',
  '突泉县': '突泉县',
  '金昌市': '金昌市',
  '金川区': '金川区',
  '永昌县': '永昌县',
  '白银市': '白银市',
  '白银区': '白银区',
  '平川区': '平川区',
  '靖远县': '靖远县',
  '会宁县': '会宁县',
  '景泰县': '景泰县',
  '天水市': '天水市',
  '清水县': '清水县',
  '秦安县': '秦安县',
  '甘谷县': '甘谷县',
  '武山县': '武山县',
  '通辽市': '通辽市',
  '北道区': '北道区',
  '秦城区': '秦城区',
  '武威市': '武威市',
  '凉州区': '凉州区',
  '民勤县': '民勤县',
  '古浪县': '古浪县',
  '大兴区': '大兴区',
  '酒泉市': '酒泉市',
  '肃州区': '肃州区',
  '玉门市': '玉门市',
  '敦煌市': '敦煌市',
  '金塔县': '金塔县',
  '邯郸县': '邯郸县',
  '临漳县': '临漳县',
  '安西县': '安西县',
  '张掖市': '张掖市',
  '甘州区': '甘州区',
  '民乐县': '民乐县',
  '临泽县': '临泽县',
  '高台县': '高台县',
  '山丹县': '山丹县',
  '成安县': '成安县',
  '庆阳市': '庆阳市',
  '西峰区': '西峰区',
  '庆城县': '庆城县',
  '泽普县': '泽普县',
  '华池县': '华池县',
  '合水县': '合水县',
  '正宁县': '正宁县',
  '巴楚县': '巴楚县',
  '镇原县': '镇原县',
  '平凉市': '平凉市',
  '崆峒区': '崆峒区',
  '泾川县': '泾川县',
  '灵台县': '灵台县',
  '崇信县': '崇信县',
  '华亭县': '华亭县',
  '庄浪县': '庄浪县',
  '静宁县': '静宁县',
  '定西市': '定西市',
  '安定区': '安定区',
  '通渭县': '通渭县',
  '临洮县': '临洮县',
  '喀什市': '喀什市',
  '开鲁县': '开鲁县',
  '渭源县': '渭源县',
  '陇西县': '陇西县',
  '陇南市': '陇南市',
  '武都区': '武都区',
  '乌什县': '乌什县',
  '宕昌县': '宕昌县',
  '新和县': '新和县',
  '柯坪县': '柯坪县',
  '西和县': '西和县',
  '库车县': '库车县',
  '两当县': '两当县',
  '库伦旗': '库伦旗',
  '奈曼旗': '奈曼旗',
  '临夏市': '临夏市',
  '临夏县': '临夏县',
  '康乐县': '康乐县',
  '永靖县': '永靖县',
  '广河县': '广河县',
  '和政县': '和政县',
  '大名县': '大名县',
  '平谷区': '平谷区',
  '怀柔区': '怀柔区',
  '合作市': '合作市',
  '临潭县': '临潭县',
  '卓尼县': '卓尼县',
  '舟曲县': '舟曲县',
  '迭部县': '迭部县',
  '玛曲县': '玛曲县',
  '碌曲县': '碌曲县',
  '夏河县': '夏河县',
  '青海省': '青海省',
  '西宁市': '西宁市',
  '城东区': '城东区',
  '城西区': '城西区',
  '城北区': '城北区',
  '湟源县': '湟源县',
  '湟中县': '湟中县',
  '肥乡县': '肥乡县',
  '永年县': '永年县',
  '平安县': '平安县',
  '乐都县': '乐都县',
  '密云县': '密云县',
  '鸡泽县': '鸡泽县',
  '广平县': '广平县',
  '馆陶县': '馆陶县',
  '延庆县': '延庆县',
  '海晏县': '海晏县',
  '祁连县': '祁连县',
  '刚察县': '刚察县',
  '镶黄旗': '镶黄旗',
  '曲周县': '曲周县',
  '共和县': '共和县',
  '同德县': '同德县',
  '贵德县': '贵德县',
  '兴海县': '兴海县',
  '贵南县': '贵南县',
  '正蓝旗': '正蓝旗',
  '同仁县': '同仁县',
  '尖扎县': '尖扎县',
  '泽库县': '泽库县',
  '多伦县': '多伦县',
  '武安市': '武安市',
  '玛沁县': '玛沁县',
  '班玛县': '班玛县',
  '甘德县': '甘德县',
  '达日县': '达日县',
  '久治县': '久治县',
  '玛多县': '玛多县',
  '集宁市': '集宁市',
  '玉树县': '玉树县',
  '杂多县': '杂多县',
  '称多县': '称多县',
  '治多县': '治多县',
  '囊谦县': '囊谦县',
  '丰镇市': '丰镇市',
  '卓资县': '卓资县',
  '化德县': '化德县',
  '商都县': '商都县',
  '乌兰县': '乌兰县',
  '都兰县': '都兰县',
  '天峻县': '天峻县',
  '拜城县': '拜城县',
  '银川市': '银川市',
  '兴庆区': '兴庆区',
  '西夏区': '西夏区',
  '金凤区': '金凤区',
  '灵武市': '灵武市',
  '永宁县': '永宁县',
  '贺兰县': '贺兰县',
  '兴和县': '兴和县',
  '凉城县': '凉城县',
  '惠农区': '惠农区',
  '平罗县': '平罗县',
  '吴忠市': '吴忠市',
  '利通区': '利通区',
  '邢台市': '邢台市',
  '盐池县': '盐池县',
  '同心县': '同心县',
  '固原市': '固原市',
  '原州区': '原州区',
  '西吉县': '西吉县',
  '隆德县': '隆德县',
  '泾源县': '泾源县',
  '彭阳县': '彭阳县',
  '中卫市': '中卫市',
  '邢台县': '邢台县',
  '中宁县': '中宁县',
  '海原县': '海原县',
  '沙雅县': '沙雅县',
  '临城县': '临城县',
  '天山区': '天山区',
  '内丘县': '内丘县',
  '柏乡县': '柏乡县',
  '东胜市': '东胜市',
  '隆尧县': '隆尧县',
  '天津市': '天津市',
  '南和县': '南和县',
  '宁晋县': '宁晋县',
  '杭锦旗': '杭锦旗',
  '乌审旗': '乌审旗',
  '巨鹿县': '巨鹿县',
  '新河县': '新河县',
  '临河市': '临河市',
  '五原县': '五原县',
  '鄯善县': '鄯善县',
  '磴口县': '磴口县',
  '哈密市': '哈密市',
  '伊吾县': '伊吾县',
  '广宗县': '广宗县',
  '平乡县': '平乡县',
  '和田市': '和田市',
  '和田县': '和田县',
  '洛浦县': '洛浦县',
  '民丰县': '民丰县',
  '皮山县': '皮山县',
  '策勒县': '策勒县',
  '于田县': '于田县',
  '墨玉县': '墨玉县',
  '和平区': '和平区',
  '清河县': '清河县',
  '温宿县': '温宿县',
  '常平': '常平',
  '新疆': '新疆',
  '徽县': '徽县',
  '礼县': '礼县',
  '文县': '文县',
  '康县': '康县',
  '成县': '成县',
  '岷县': '岷县',
  '漳县': '漳县',
  '宁县': '宁县',
  '环县': '环县',
  '佳县': '佳县',
  '勉县': '勉县',
  '洋县': '洋县',
  '富县': '富县',
  '华县': '华县',
  '乾县': '乾县',
  '彬县': '彬县',
  '凤县': '凤县',
  '眉县': '眉县',
  '陇县': '陇县',
  '户县': '户县',
  '朗县': '朗县',
  '索县': '索县',
  '西藏': '西藏',
  '云县': '云县',
  '盘县': '盘县',
  '茂县': '茂县',
  '理县': '理县',
  '渠县': '渠县',
  '达县': '达县',
  '高县': '高县',
  '珙县': '珙县',
  '南充': '南充',
  '安县': '安县',
  '泸县': '泸县',
  '西区': '西区',
  '东区': '东区',
  '荣县': '荣县',
  '郫县': '郫县',
  '忠县': '忠县',
  '开县': '开县',
  '东方': '东方',
  '万宁': '万宁',
  '文昌': '文昌',
  '儋州': '儋州',
  '琼海': '琼海',
  '容县': '容县',
  '藤县': '藤县',
  '横县': '横县',
  '广西': '广西',
  '城区': '城区',
  '梅县': '梅县',
  '中山': '中山',
  '塘厦': '塘厦',
  '宁夏': '宁夏',
  '莞城': '莞城',
  '道县': '道县',
  '南县': '南县',
  '澧县': '澧县',
  '攸县': '攸县',
  '潜江': '潜江',
  '天门': '天门',
  '仙桃': '仙桃',
  '房县': '房县',
  '郧县': '郧县',
  '新县': '新县',
  '息县': '息县',
  '睢县': '睢县',
  '陕县': '陕县',
  '范县': '范县',
  '温县': '温县',
  '淇县': '淇县',
  '浚县': '浚县',
  '滑县': '滑县',
  '郏县': '郏县',
  '叶县': '叶县',
  '嵩县': '嵩县',
  '杞县': '杞县',
  '曹县': '曹县',
  '单县': '单县',
  '冠县': '冠县',
  '莘县': '莘县',
  '澳门': '澳门',
  '陵县': '陵县',
  '费县': '费县',
  '莒县': '莒县',
  '赣县': '赣县',
  '沙县': '沙县',
  '泾县': '泾县',
  '寿县': '寿县',
  '路凼': '路凼',
  '香港': '香港',
  '和县': '和县',
  '泗县': '泗县',
  '萧县': '萧县',
  '黟县': '黟县',
  '歙县': '歙县',
  '北区': '北区',
  '丰县': '丰县',
  '沛县': '沛县',
  '郊区': '郊区',
  '宾县': '宾县',
  '四平': '四平',
  '盘锦': '盘锦',
  '义县': '义县',
  '雄县': '雄县',
  '博野': '博野',
  '南区': '南区',
  '其他': '其他',
  '藁': '藁',
  '云数据库 RDS SQL Server': '云数据库 RDS SQL Server',
  '云数据库 RDS PostgreSQL': '云数据库 RDS PostgreSQL',
  '云数据库 RDS Oracle': '云数据库 RDS Oracle',
  '云数据库 RDS MySQL': '云数据库 RDS MySQL',
  '云数据库 MongoDB': '云数据库 MongoDB',
  '云原生运行时基础与设施': '云原生运行时基础与设施',
  '一键服务One Key': '一键服务One Key',
  '云数据库 Redis': '云数据库 Redis',
  '数据传输 DTS': '数据传输 DTS',
  '端到端 COSMOS': '端到端 COSMOS',
  '综合金融移动展业平台': '综合金融移动展业平台',
  '数据迁移 DTS': '数据迁移 DTS',
  '专有宿主机 CDH': '专有宿主机 CDH',
  '容器服务 Caas': '容器服务 Caas',
  '物理服务器 BMS': '物理服务器 BMS',
  '多域云解析 DNS': '多域云解析 DNS',
  '对象存储 OSS': '对象存储 OSS',
  '文件存储 NAS': '文件存储 NAS',
  'DevOps平台': 'DevOps平台',
  'IT服务管理系统': 'IT服务管理系统',
  '研发敏捷流程平台': '研发敏捷流程平台',
  '保险上云解决方案': '保险上云解决方案',
  '用户行为分析平台': '用户行为分析平台',
  '专有网络 VPC': '专有网络 VPC',
  '负载均衡 SLB': '负载均衡 SLB',
  'CDN': 'CDN',
  '弹性伸缩 AS': '弹性伸缩 AS',
  '新保险公司开业': '新保险公司开业',
  '自动化测试平台': '自动化测试平台',
  '全站加速CDN': '全站加速CDN',
  '云裸机 BMS': '云裸机 BMS',
  '公共组件与服务': '公共组件与服务',
  '云计算基础服务': '云计算基础服务',
  '云硬盘 CBS': '云硬盘 CBS',
  '云主机 ECS': '云主机 ECS',
  '桌面安全服务': '桌面安全服务',
  '防火墙 FW': '防火墙 FW',
  '网络安全服务': '网络安全服务',
  '快速原型平台': '快速原型平台',
  '应用安全服务': '应用安全服务',
  '安全专家服务': '安全专家服务',
  '消息推送中心': '消息推送中心',
  '企业通用服务': '企业通用服务',
  '任务调度平台': '任务调度平台',
  '保险移动展业': '保险移动展业',
  '自然语言处理': '自然语言处理',
  '智能语音交互': '智能语音交互',
  '移动开发平台': '移动开发平台',
  '邮件推送服务': '邮件推送服务',
  '热门产品:': '热门产品:',
  'NAT网关': 'NAT网关',
  '互联网金融': '互联网金融',
  '云备份': '云备份',
  '微服务平台': '微服务平台',
  'API网关': 'API网关',
  '互联网医疗': '互联网医疗',
  '数据库备份': '数据库备份',
  '大数据行业': '大数据行业',
  '音视频服务': '音视频服务',
  '金融大数据': '金融大数据',
  '新保险展业': '新保险展业',
  '新保险中介': '新保险中介',
  '自动化运维': '自动化运维',
  '软件正版化': '软件正版化',
  '供应链金融': '供应链金融',
  '可用性运维': '可用性运维',
  '小安机器人': '小安机器人',
  '金橙展业宝': '金橙展业宝',
  '微服务支撑': '微服务支撑',
  '帮助与支持': '帮助与支持',
  '视频软电话': '视频软电话',
  '运维服务': '运维服务',
  '用户接触': '用户接触',
  '容器服务': '容器服务',
  '版本发布': '版本发布',
  '研发支持': '研发支持',
  '数据采集': '数据采集',
  '数据调整': '数据调整',
  '精益敏捷': '精益敏捷',
  '已登出!': '已登出!',
  '办公服务': '办公服务',
  '医疗行业': '医疗行业',
  '代码管理': '代码管理',
  '服务公告': '服务公告',
  '工单支持': '工单支持',
  '文档中心': '文档中心',
  '客户案例': '客户案例',
  '容器平台': '容器平台',
  '上云迁移': '上云迁移',
  '日志平台': '日志平台',
  '人工智能': '人工智能',
  '用户中心': '用户中心',
  '影像平台': '影像平台',
  '立即注册': '立即注册',
  '免费注册': '免费注册',
  '数据集成': '数据集成',
  '合作伙伴': '合作伙伴',
  '招商云播': '招商云播',
  '弹性计算': '弹性计算',
  '帮助支持': '帮助支持',
  '星云数据': '星云数据',
  '欧拉图谱': '欧拉图谱',
  '金融行业': '金融行业',
  '智能投资': '智能投资',
  '友情链接': '友情链接',
  '归档存储': '归档存储',
  '机器学习': '机器学习',
  '数字化社区': '数字化社区',
  '智能客服': '智能客服',
  '人脸识别': '人脸识别',
  '解决方案': '解决方案',
  '图像搜索': '图像搜索',
  '短信服务': '短信服务',
  '智能联络': '智能联络',
  '平台服务': '平台服务',
  '指尖办公': '指尖办公',
  '电子发票': '电子发票',
  '电子签名': '电子签名',
  '集成协作': '集成协作',
  '保险行业': '保险行业',
  '云视讯': '云视讯',
  '招商云': '招商云',
  '数据库': '数据库',
  '流计算': '流计算',
  '平安脑': '平安脑',
  '云打印': '云打印',
  '微表情': '微表情',
  '云桌面': '云桌面',
  '云硬盘': '云硬盘',
  '控制台': '控制台',
  '大数据': '大数据',
  '云咨询': '云咨询',
  '知鸟': '知鸟',
  '银行': '银行',
  '投资': '投资',
  '安全': '安全',
  '网络': '网络',
  '云通': '云通',
  '存储': '存储',
  '登录': '登录',
  '金融': '金融',
  '退出': '退出',
  '产品': '产品',
  '网盘': '网盘',
  '迁移': '迁移',
  '正在根据权限进行跳转，请稍等': '正在根据权限进行跳转，请稍等',
  '云数据库 RDS': '云数据库 RDS',
  '租户账单概览': '租户账单概览',
  '项目账单明细': '项目账单明细',
  '可视化编辑器': '可视化编辑器',
  '操作日志查询': '操作日志查询',
  '租户账单明细': '租户账单明细',
  '项目账单概览': '项目账单概览',
  '堡垒机 TS': '堡垒机 TS',
  '资源栈管理': '资源栈管理',
  'ECS备份': 'ECS备份',
  '策略组管理': '策略组管理',
  '云主机管理': '云主机管理',
  '云主机镜像': '云主机镜像',
  'ISP备案': 'ISP备案',
  '云硬盘快照': '云硬盘快照',
  '云主机快照': '云主机快照',
  '授权管理': '授权管理',
  '反馈建议': '反馈建议',
  '运营服务': '运营服务',
  '安全服务': '安全服务',
  '消息设置': '消息设置',
  '提交工单': '提交工单',
  '标签管理': '标签管理',
  '项目管理': '项目管理',
  '服务目录': '服务目录',
  '目录设置': '目录设置',
  '资源编排': '资源编排',
  '企业认证': '企业认证',
  '模板管理': '模板管理',
  '部署单元': '部署单元',
  '资源配置': '资源配置',
  '费用中心': '费用中心',
  '订单管理': '订单管理',
  '工单列表': '工单列表',
  '工单管理': '工单管理',
  '用户信息': '用户信息',
  '账号信息': '账号信息',
  '认证授权': '认证授权',
  '证书服务': '证书服务',
  'VIP': 'VIP',
  'EIP': 'EIP',
  '云管理': '云管理',
  '站内信': '站内信',
  '服务': '服务',
  '子网': '子网',
  '建议': '建议',
  '日志': '日志',
  '计算': '计算',
  '返回首页': '返回首页',
  '对象存储OSS 操作指南': '对象存储OSS 操作指南',
  '互联网访问DNAT': '互联网访问DNAT',
  '出互联网SNAT': '出互联网SNAT',
  '文档型数据库': '文档型数据库',
  '对象存储详情': '对象存储详情',
  '数据库管理': '数据库管理',
  '缓存数据库': '缓存数据库',
  '自定义镜像': '自定义镜像',
  '备份管理': '备份管理',
  '恢复记录': '恢复记录',
  '备份记录': '备份记录',
  '账户管理': '账户管理',
  '同步管理': '同步管理',
  '基本信息': '基本信息',
  '备份策略': '备份策略',
  '恢复任务': '恢复任务',
  '文件管理': '文件管理',
  '同步策略': '同步策略',
  '参数设置': '参数设置',
  '未读消息': '未读消息',
  '公共镜像': '公共镜像',
  '云数据库': '云数据库',
  '域名管理': '域名管理',
  '监控查询': '监控查询',
  '快照链': '快照链',
  '存储桶': '存储桶',
  '容量包': '容量包',
  '快照': '快照',
  '全部': '全部',
  '密钥': '密钥',
  '概览': '概览',
  '请先选择参数，再填入相应值！': '请先选择参数，再填入相应值！',
  '请选择资源属性进行过滤': '请选择资源属性进行过滤',
  '当前选项下暂无可用区，请修改配置': '当前选项下暂无可用区，请修改配置',
  '计费模式': '计费模式',
  '计价时长': '计价时长',
  '5个月': '5个月',
  '可用区': '可用区',
  '2个月': '2个月',
  '1个月': '1个月',
  '6个月': '6个月',
  '3个月': '3个月',
  '4个月': '4个月',
  '1年': '1年',
  '2年': '2年',
  '3年': '3年',
  '公': '公',
  '取消': '取消',
  '确定': '确定',
  '联 系 我 们': '联 系 我 们',
  '一键意见反馈': '一键意见反馈',
  '电话': '电话',
  '邮箱': '邮箱',
  '反馈': '反馈',
  '确定删除资源吗': '确定删除资源吗',
  '确定删除资源': '确定删除资源',
  '数据删除成功 !':'数据删除成功 !',
  '关闭': '关闭',
  '吗': '吗',
  '当前查询条件尚无数据,您可以': '当前查询条件尚无数据,您可以',
  '列数据已复制至剪切板！': '列数据已复制至剪切板！',
  '当前查询条件尚无数据': '当前查询条件尚无数据',
  '该数据无可用操作！': '该数据无可用操作！',
  '无可用操作': '无可用操作',
  '复制列': '复制列',
  '请搜索': '请搜索',
  '操作': '操作',
  '更多': '更多',
  '批量操作': '批量操作',
  '每月最后一天': '每月最后一天',
  ',最后一天': ',最后一天',
  '请选择日期': '请选择日期',
  '增量备份': '增量备份',
  '开始时间': '开始时间',
  '计划名称': '计划名称',
  '备份周期': '备份周期',
  '全量备份': '全量备份',
  '最后一天': '最后一天',
  '备份类型': '备份类型',
  '保留时间': '保留时间',
  '15年': '15年',
  '星期一': '星期一',
  '星期二': '星期二',
  '星期三': '星期三',
  '星期四': '星期四',
  '星期五': '星期五',
  '星期六': '星期六',
  '星期日': '星期日',
  '请选择': '请选择',
  '20年': '20年',
  '10年': '10年',
  '周二': '周二',
  '5年': '5年',
  '每月': '每月',
  '永久': '永久',
  '日期': '日期',
  '全量': '全量',
  '增量': '增量',
  '周一': '周一',
  '周三': '周三',
  '周四': '周四',
  '周五': '周五',
  '周六': '周六',
  '周日': '周日',
  '日': '日',
  '月': '月',
  '周': '周',
  '暂无数据': '暂无数据',
  '删除': '删除',
  '该套配置仅支持线下询价': '该套配置仅支持线下询价',
  '正在计算价格': '正在计算价格',
  '查看优惠': '查看优惠',
  '元/年': '元/年',
  '费用': '费用',
  '省': '省',
  '至': '至',
  '计费模式:': '计费模式:',
  '计价时长:': '计价时长:',
  '不能为空': '不能为空',
  '不能少于2字符': '不能少于2字符',
  '不能超出60字符':'不能超出60字符',
  '新增': '新增',
  '编辑': '编辑',
  '保存': '保存',
  '设置不符合要求，请重新设置': '设置不符合要求，请重新设置',
  '设置不符合要求，请重新输入': '设置不符合要求，请重新输入',
  '两次输入的密码不一致': '两次输入的密码不一致',
  '密码安全程度：中': '密码安全程度：中',
  '请再次输入密码': '请再次输入密码',
  '请重新输入密码': '请重新输入密码',
  '请输入密码': '请输入密码',
  '安全程度:': '安全程度:',
  '确认密码': '确认密码',
  '值可包含大小写字母、数字、点、-、_、汉字，长度不超过60个字符！': '值可包含大小写字母、数字、点、-、_、汉字，长度不超过60个字符！',
  '键可包含大小写字母、数字、点，长度不超过32个字符！': '键可包含大小写字母、数字、点，长度不超过32个字符！',
  '编辑标签 --': '编辑标签 --',
  '请检查书写格式': '请检查书写格式',
  '标签修改成功！': '标签修改成功！',
  '请先填写键！': '请先填写键！',
  '新建标签': '新建标签',
  '标签键:': '标签键:',
  '暂无标签': '暂无标签',
  '编辑标签': '编辑标签',
  '取消标签': '取消标签',
  '添加标签': '添加标签',
  '已选中': '已选中',
  '待选择': '待选择',
  '值:': '值:',
  '该操作需要验证手机号码，请您立即验证': '该操作需要验证手机号码，请您立即验证',
  '验证码已发送至:': '验证码已发送至:',
  '请先获取验证码': '请先获取验证码',
  '请先输入验证码': '请先输入验证码',
  '验证码已发送': '验证码已发送',
  '获取验证码': '获取验证码',
  '输入验证码': '输入验证码',
  '删除成功': '删除成功',
  '验证码：': '验证码：',
  '删除资源': '删除资源',
  '立即验证': '立即验证',
  '重新获取': '重新获取',
  '成功': '成功',
  '返回上一级': '返回上一级',
  '表格生成预计需要20-60s,请耐心等待！': '表格生成预计需要20-60s,请耐心等待！',
  '自定义列表字段': '自定义列表字段',
  '列表刷新入口': '列表刷新入口',
  '列管理入口': '列管理入口',
  '表格生成中': '表格生成中',
  '筛选': '筛选',
  '刷新': '刷新',
  '导出': '导出',
  '重置': '重置',
  '租户': '租户',
  '项目': '项目',
  '升级后价格': '升级后价格',
  '升级前价格:': '升级前价格:',
  '请输入xxx-xxx-xxx格式，且不输入数字。eg. VMS-VMS-example': '请输入xxx-xxx-xxx格式，且不输入数字。eg. VMS-VMS-example',
  '请输入xxx-xxx格式，且不输入数字。eg. VMS-example': '请输入xxx-xxx格式，且不输入数字。eg. VMS-example',
  '主备模式开启时，后端服务器最多可以添加7台!': '主备模式开启时，后端服务器最多可以添加7台!',
  '请配置监听端口范围在1-65535整数!': '请配置监听端口范围在1-65535整数!',
  '请配置端口范围在1-65535整数!': '请配置端口范围在1-65535整数!',
  '请先填写正确格式的发布单元!': '请先填写正确格式的发布单元!',
  '请选择租户、项目信息 !': '请选择租户、项目信息 !',
  '请选择有效的区域信息 !': '请选择有效的区域信息 !',
  '请先填写正确格式的名称!': '请先填写正确格式的名称!',
  '请先配置健康检查协议!': '请先配置健康检查协议!',
  '填写正确格式的ip地址': '填写正确格式的ip地址',
  '请先配置后端服务器!': '请先配置后端服务器!',
  '不允许同IP同端口：': '不允许同IP同端口：',
  '请先配置服务器端口!': '请先配置服务器端口!',
  '请选择VPC信息 !': '请选择VPC信息 !',
  '请先配置SSL证书!': '请先配置SSL证书!',
  '请先配置发布单元!': '请先配置发布单元!',
  '请先填写发布单元!': '请先填写发布单元!',
  '请先配置监听端口!': '请先配置监听端口!',
  '请先选择会话保持!': '请先选择会话保持!',
  '请先选择带宽峰值!': '请先选择带宽峰值!',
  '请选择主服务器！': '请选择主服务器！',
  '请先选择服务器!': '请先选择服务器!',
  '请先填写名称!': '请先填写名称!',
  '请先配置名称!': '请先配置名称!',
  '选择区域与配置': '选择区域与配置',
  '后端服务器端口': '后端服务器端口',
  '添加配置项成功': '添加配置项成功',
  '请先配置协议!': '请先配置协议!',
  '连接超时时间': '连接超时时间',
  '添加配置向导': '添加配置向导',
  '健康检查端口': '健康检查端口',
  '负载均衡购买': '负载均衡购买',
  '健康检查协议': '健康检查协议',
  '响应超时时间': '响应超时时间',
  '获取真实IP': '获取真实IP',
  '云主机IP:': '云主机IP:',
  '后端服务器': '后端服务器',
  '区域与配置': '区域与配置',
  '是否ftp': '是否ftp',
  '是否重定向': '是否重定向',
  'SSL证书': 'SSL证书',
  '自定义名称': '自定义名称',
  '协议&监听': '协议&监听',
  '请检查配置': '请检查配置',
  '云主机IP': '云主机IP',
  '被配置在第': '被配置在第',
  '发布单元': '发布单元',
  '配置校验': '配置校验',
  '调度算法': '调度算法',
  '带宽峰值': '带宽峰值',
  '新增成功': '新增成功',
  '立即购买': '立即购买',
  '会话保持': '会话保持',
  '高级配置': '高级配置',
  '返回列表': '返回列表',
  '配置审核': '配置审核',
  '间隔时间': '间隔时间',
  '备服务器': '备服务器',
  '健康检查': '健康检查',
  '监听端口': '监听端口',
  '主服务器': '主服务器',
  '机器类型': '机器类型',
  '主备模式': '主备模式',
  '端口:': '端口:',
  '下一步': '下一步',
  '上一步': '上一步',
  '轮询': '轮询',
  '收起': '收起',
  '添加': '添加',
  '开启': '开启',
  '展开': '展开',
  '端口': '端口',
  '名称': '名称',
  '启用': '启用',
  '协议': '协议',
  '行': '行',
  '否': '否',
  '是': '是',
  '秒': '秒',
  '当前状态不允许禁启用!': '当前状态不允许禁启用!',
  '启/禁用状态修改成功 !': '启/禁用状态修改成功 !',
  '当前状态不允许删除!': '当前状态不允许删除!',
  '当前状态不允许编辑!': '当前状态不允许编辑!',
  '当前状态不允新增!': '当前状态不允新增!',
  '响应超时时间(s)': '响应超时时间(s)',
  '连接超时时间(s)': '连接超时时间(s)',
  '宽带峰值(M)': '宽带峰值(M)',
  '新增后端服务器': '新增后端服务器',
  '间隔时间(s)': '间隔时间(s)',
  'http重定向': 'http重定向',
  '负载均衡详情': '负载均衡详情',
  '编辑健康检查': '编辑健康检查',
  '所属可用区': '所属可用区',
  '所属VPC': '所属VPC',
  '是否FTP': '是否FTP',
  '所属租户': '所属租户',
  '创建时间': '创建时间',
  '更新时间': '更新时间',
  '初始状态': '初始状态',
  '编辑协议': '编辑协议',
  '所属项目': '所属项目',
  '申请人': '申请人',
  '创建中': '创建中',
  '16秒': '16秒',
  '状态': '状态',
  '概要': '概要',
  '禁用': '禁用',
  '监听': '监听',
  '5秒': '5秒',
  '失败': '失败',
  '负载均衡SLB 操作指南': '负载均衡SLB 操作指南',
  '禁用指令已发出！': '禁用指令已发出！',
  '配置项列表': '配置项列表',
  '确定要禁用': '确定要禁用',
  '添加配置': '添加配置',
  '启用成功': '启用成功',
  '负载均衡': '负载均衡',
  '删 除': '删 除',
  '禁 用': '禁 用',
  '启 用': '启 用',
  '搜索': '搜索',
  '购买': '购买',
  '标签': '标签',
  'HBA卡的类型和数量需要同时配置!': 'HBA卡的类型和数量需要同时配置!',
  '请选择有效的pool类型信息 !': '请选择有效的pool类型信息 !',
  '请选择有效的VPC及子网信息 !': '请选择有效的VPC及子网信息 !',
  '申请请求已发送成功 !': '申请请求已发送成功 !',
  '两次密码输入不一致 !': '两次密码输入不一致 !',
  '密码中不能包含中文 !': '密码中不能包含中文 !',
  '请选择有效的区域信息!': '请选择有效的区域信息!',
  '请先选择租户和项目!': '请先选择租户和项目!',
  '请再次输入主机密码': '请再次输入主机密码',
  '没有可选HBA卡': '没有可选HBA卡',
  '请先选择机型!': '请先选择机型!',
  '可用ip数为0,无法购买 !': '可用ip数为0,无法购买 !',
  '请先选择镜像!': '请先选择镜像!',
  '请输入主机密码': '请输入主机密码',
  '选择存储与网络': '选择存储与网络',
  '选择镜像与机型': '选择镜像与机型',
  '选择区域与项目': '选择区域与项目',
  'HBA卡数量': 'HBA卡数量',
  '没有可选机型': '没有可选机型',
  '磁盘(GB)': '磁盘(GB)',
  '没有可选镜像': '没有可选镜像',
  '内存(GB)': '内存(GB)',
  'pool类型': 'pool类型',
  'HBA卡类型': 'HBA卡类型',
  '可用IP数': '可用IP数',
  '云裸机购买': '云裸机购买',
  '已选配置': '已选配置',
  '设置信息': '设置信息',
  '镜像': '镜像',
  '备注': '备注',
  '数量': '数量',
  '密码': '密码',
  '内存': '内存',
  '磁盘': '磁盘',
  '机型': '机型',
  '核': '核',
  '云裸机详情': '云裸机详情',
  '主IP': '主IP',
  '安装中': '安装中',
  '开机中': '开机中',
  '重启中': '重启中',
  '创建人': '创建人',
  '主机名': '主机名',
  '运行': '运行',
  '隔离中': '隔離中',
  '用途': '用途',
  '配置': '配置',
  '核-': '核-',
  '关机': '关机',
  '云裸机BMS 操作指南': '云裸机BMS 操作指南',
  '密码已复制至剪切板！': '密码已复制至剪切板！',
  '请先选择账户！': '请先选择账户！',
  '指令已发出！': '指令已发出！',
  '已取消纳管！': '已取消纳管！',
  '修改成功!': '修改成功!',
  '纳管成功！': '纳管成功！',
  '过期时间': '过期时间',
  '启动主机': '启动主机',
  '查询密码': '查询密码',
  '重启主机': '重启主机',
  '关闭主机': '关闭主机',
  '取消纳管': '取消纳管',
  '未纳管': '未纳管',
  '云裸机': '云裸机',
  '监控图': '监控图',
  '堡垒机': '堡垒机',
  '云堡垒机': '云堡垒机',
  '已纳管': '已纳管',
  '开机': '开机',
  '纳管': '纳管',
  '账号': '账号',
  '通用': '通用',
  '重启': '重启',
  '查询': '查询',
  '复制': '复制',
  'cpu使用率': 'cpu使用率',
  '内存使用率': '内存使用率',
  '云裸机信息': '云裸机信息',
  '监控图表': '监控图表',
  '系统负载': '系统负载',
  '监控视图': '监控视图',
  '12小时': '12小时',
  '3小时': '3小时',
  '6小时': '6小时',
  '近一月': '近一月',
  '近1天': '近1天',
  '近3天': '近3天',
  '近一周': '近一周',
  '1小时': '1小时',
  '基础': '基础',
  '重启实例会造成连接中断，重启前请做好业务安排，谨慎操作。': '重启实例会造成连接中断，重启前请做好业务安排，谨慎操作。',
  '大小写字母、数字、特殊字符!@#$%^&*()_+=': '大小写字母、数字、特殊字符!@#$%^&*()_+=',
  '缓存数据库 操作指南': '缓存数据库 操作指南',
  '请填写数据库描述！': '请填写数据库描述！',
  '编辑应用环境成功！': '编辑应用环境成功！',
  '保存成功': '保存成功',
  'Flavor规格': 'Flavor规格',
  '数据库规格ID': '数据库规格ID',
  '8-32位字符': '8-32位字符',
  '12-32位字符': '12-32位字符',
  '数据库实例名': '数据库实例名',
  '数据库描述': '数据库描述',
  '数据库端口': '数据库端口',
  '请检查密码': '请检查密码',
  '重置成功！': '重置成功！',
  '特殊字符为': '特殊字符为',
  '主机ID': '主机ID',
  'IP地址': 'IP地址',
  '高可用版': '高可用版',
  '应用环境': '应用环境',
  '重置密码': '重置密码',
  '指令发送': '指令发送',
  '基础版': '基础版',
  '金融版': '金融版',
  '虚拟机': '虚拟机',
  '物理机': '物理机',
  '初始化': '初始化',
  '删除中': '删除中',
  '更新中': '更新中',
  '停止中': '停止中',
  '启动中': '启动中',
  '等待中': '等待中',
  '未知': '未知',
  '错误': '错误',
  '停止': '停止',
  '管理': '管理',
  '启动': '启动',
  '您订购的云数据库正在努力创建中，一般需要1-15分钟，请您耐心等待！': '您订购的云数据库正在努力创建中，一般需要1-15分钟，请您耐心等待！',
  '云数据库暂不支持外网直接访问，外网访问需搭配云主机使用': '云数据库暂不支持外网直接访问，外网访问需搭配云主机使用',
  '请选择有效的数据库规格 !': '请选择有效的数据库规格 !',
  '根分区大小(GB)': '根分区大小(GB)',
  '请先填写实例描述！': '请先填写实例描述！',
  '请选择可用区 !': '请选择可用区 !',
  '请先填写实例名！': '请先填写实例名！',
  '请先选择租户！': '请先选择租户！',
  '请输入实例描述': '请输入实例描述',
  'G根分区大小': 'G根分区大小',
  '内存(MB)': '内存(MB)',
  '新增云数据库': '新增云数据库',
  '数据库创建中': '数据库创建中',
  '请输入实例名': '请输入实例名',
  '开启持久化': '开启持久化',
  '核CPU、': '核CPU、',
  '选择数据库': '选择数据库',
  '数据库类型': '数据库类型',
  '主机类型': '主机类型',
  'M内存、': 'M内存、',
  '实例描述': '实例描述',
  '下一步：': '下一步：',
  '实例名': '实例名',
  '版本': '版本',
  '系列': '系列',
  '故障自动迁移开关打开后，专属宿主机发生故障时会自动迁移至其它可用的宿主机或者是共享宿主机': '故障自动迁移开关打开后，专属宿主机发生故障时会自动迁移至其它可用的宿主机或者是共享宿主机',
  '密码必须包含数字、大小写字母，且长度为8到64位 !': '密码必须包含数字、大小写字母，且长度为8到64位 !',
  '可购买数量不足，请咨询后台管理员！': '可购买数量不足，请咨询后台管理员！',
  '部署单元名称长度范围为2-32！': '部署单元名称长度范围为2-32！',
  'qos限制在公有云区域不生效': 'qos限制在公有云区域不生效',
  '部署单元名称不能为空！': '部署单元名称不能为空！',
  '请选择有效的规格 !': '请选择有效的规格 !',
  '请选择有效的机型!': '请选择有效的机型!',
  '无可用主机规格': '无可用主机规格',
  '专有宿主机购买': '专有宿主机购买',
  '故障自动迁移': '故障自动迁移',
  '-1为不限！': '-1为不限！',
  'cpu超分比': 'cpu超分比',
  '根分区大小': '根分区大小',
  '云主机规格': '云主机规格',
  '可用数量': '可用数量',
  '选择机型': '选择机型',
  '内存、': '内存、',
  '关': '关',
  '开': '开',
  '此宿主机上所有的云主机都进行关机操作': '此宿主机上所有的云主机都进行关机操作',
  '请在专业宿主机关机前备份所有数据': '请在专业宿主机关机前备份所有数据',
  '-保存用户新增、编辑时数据': '-保存用户新增、编辑时数据',
  '超分比设置成功！': '超分比设置成功！',
  '专有宿主机名称': '专有宿主机名称',
  '专有宿主机详情': '专有宿主机详情',
  'cpu超分比:': 'cpu超分比:',
  '443端口:': '443端口:',
  '重启宿主机': '重启宿主机',
  '80端口:': '80端口:',
  'ECS实例': 'ECS实例',
  '关闭宿主机': '关闭宿主机',
  '设置超分比': '设置超分比',
  '启动宿主机': '启动宿主机',
  '已过期:': '已过期:',
  '已开启:': '已开启:',
  '申请中:': '申请中:',
  '新建实例': '新建实例',
  '重置状态': '重置状态',
  '未开启:': '未开启:',
  '释放成功': '释放成功',
  '正常:': '正常:',
  'IP:': 'IP:',
  '域名:': '域名:',
  '关机中': '关机中',
  '超分比': '超分比',
  '已删除': '已删除',
  '运行中': '运行中',
  '备:': '备:',
  '主:': '主:',
  '释放': '释放',
  '请在释放前确认数据已备份，专有宿主机释放后您将无法再获得该台宿主机。': '请在释放前确认数据已备份，专有宿主机释放后您将无法再获得该台宿主机。',
  '专有宿主机CDH 操作指南': '专有宿主机CDH 操作指南',
  '您确定要释放专有宿主机吗': '您确定要释放专有宿主机吗',
  '重置状态修改成功！': '重置状态修改成功！',
  '故障自动迁移:': '故障自动迁移:',
  '专有宿主机': '专有宿主机',
  '编辑成功！': '编辑成功！',
  'ip地址': 'ip地址',
  '运行状态': '运行状态',
  '修改配置': '修改配置',
  '下线中': '下线中',
  '监控': '监控',
  '专有宿主机信息': '专有宿主机信息',
  '请输入单个域名，也支持添加泛域名：*.test.com': '请输入单个域名，也支持添加泛域名：*.test.com',
  '请正确填写记录值为域名，如“test.com” !': '请正确填写记录值为域名，如“test.com” !',
  '请输入单个域名，也支持添加泛域名：': '请输入单个域名，也支持添加泛域名：',
  '请正确填写记录值为IP地址 !': '请正确填写记录值为IP地址 !',
  '加速域名与源站域名不能相同 !': '加速域名与源站域名不能相同 !',
  '中国境外 (无需备案)': '中国境外 (无需备案)',
  '域名长度需1-63 !': '域名长度需1-63 !',
  '全球加速 (需备案)': '全球加速 (需备案)',
  'IP地址不能相同 !': 'IP地址不能相同 !',
  '中国大陆 (需备案)': '中国大陆 (需备案)',
  '请填写加速域名 !': '请填写加速域名 !',
  '请求已发送成功 !': '请求已发送成功 !',
  '请正确填写记录值': '请正确填写记录值',
  '大文件下载': '大文件下载',
  '视音频点播': '视音频点播',
  '图片小文件': '图片小文件',
  '请输入单个': '请输入单个',
  '443端口': '443端口',
  '添加域名': '添加域名',
  '业务类型': '业务类型',
  '加速域名': '加速域名',
  '关联证书': '关联证书',
  '源站信息': '源站信息',
  '创建证书': '创建证书',
  '加速区域': '加速区域',
  '80端口': '80端口',
  '确认添加': '确认添加',
  '优先级': '优先级',
  '域名': '域名',
  '类型': '类型',
  '修改': '修改',
  '主': '主',
  '备': '备',
  '请先关联证书！': '请先关联证书！',
  '供应商类型': '供应商类型',
  '免费证书': '免费证书',
  '域名详情': '域名详情',
  '正常运行': '正常运行',
  '证书名称': '证书名称',
  '证书类型': '证书类型',
  '证书状态': '证书状态',
  '自有证书': '自有证书',
  '中国境外': '中国境外',
  '中国大陆': '中国大陆',
  '已停止': '已停止',
  '腾讯云': '腾讯云',
  '阿里云': '阿里云',
  '已过期': '已过期',
  '未开启': '未开启',
  '申请中': '申请中',
  '审核中': '审核中',
  '配置中': '配置中',
  '未备案': '未备案',
  '已开启': '已开启',
  '证书': '证书',
  '正常': '正常',
  '全球': '全球',
  '地址': '地址',
  '全站加速CDN 操作指南': '全站加速CDN 操作指南',
  '禁用状态修改成功 !': '禁用状态修改成功 !',
  '启用状态修改成功 !': '启用状态修改成功 !',
  '无': '无',
  '请先选择时间范围!': '请先选择时间范围!',
  '没有符合条件域名!': '没有符合条件域名!',
  '请先选择域名!': '请先选择域名!',
  '带宽峰值 ': '带宽峰值 ',
  '统计粒度': '统计粒度',
  '结束时间': '结束时间',
  '流量总值': '流量总值',
  '流量带宽': '流量带宽',
  '近30天': '近30天',
  '自定义': '自定义',
  '5分钟': '5分钟',
  '近7天': '近7天',
  '流量': '流量',
  '带宽': '带宽',
  '带宽类型':'带宽类型',
  '1天': '1天',
  '昨天': '昨天',
  '今天': '今天',
  '温馨提示：申请免费证书只能关联一个域名': '温馨提示：申请免费证书只能关联一个域名',
  '请先配置公钥和私钥!': '请先配置公钥和私钥!',
  'pem编码参考样例': 'pem编码参考样例',
  '请先配置证书名称': '请先配置证书名称',
  '创建成功 !': '创建成功 !',
  '已关联域名': '已关联域名',
  '未关联域名': '未关联域名',
  '关联域名': '关联域名',
  '替换证书': '替换证书',
  '关联': '关联',
  '移除': '移除',
  '私钥': '私钥',
  '公钥': '公钥',
  '链接已复制至剪切板！': '链接已复制至剪切板！',
  '选择日期时间': '选择日期时间',
  '编辑成功 !': '编辑成功 !',
  '证书状态：': '证书状态：',
  '证书名称：': '证书名称：',
  '过期时间：': '过期时间：',
  '复制名称': '复制名称',
  '复制私钥': '复制私钥',
  '复制公钥': '复制公钥',
  '查看证书': '查看证书',
  '私钥：': '私钥：',
  '公钥：': '公钥：',
  '替换': '替换',
  '(根据已购买产品消费预估)': '(根据已购买产品消费预估)',
  '充值金额最多两位小数!': '充值金额最多两位小数!',
  '修改阈值最多两位小数!': '修改阈值最多两位小数!',
  '阈值预警修改成功!': '阈值预警修改成功!',
  '21元(共11个)': '21元(共11个)',
  '充值金额(元)：': '充值金额(元)：',
  '预估本月项目消费': '预估本月项目消费',
  '预估本月产品消费': '预估本月产品消费',
  '预测7天后账单：': '预测7天后账单：',
  '预警阈值(元)：': '预警阈值(元)：',
  '预测本月账单：': '预测本月账单：',
  '项目余额(元)': '项目余额(元)',
  '本月当前账单：': '本月当前账单：',
  '获取最新余额': '获取最新余额',
  '(单位:元)': '(单位:元)',
  '暂无充值记录': '暂无充值记录',
  '可用余额预警': '可用余额预警',
  '可用信用额度': '可用信用额度',
  '充值成功!': '充值成功!',
  '费用(元)': '费用(元)',
  '预警阈值：': '预警阈值：',
  '昨日账单：': '昨日账单：',
  '充值金额': '充值金额',
  '切换租户': '切换租户',
  '费用趋势': '费用趋势',
  '租户余额': '租户余额',
  '充值记录': '充值记录',
  '预警阈值': '预警阈值',
  '充值时间': '充值时间',
  '可用余额': '可用余额',
  '项目名称': '项目名称',
  '充值账号': '充值账号',
  '消费预测': '消费预测',
  '总费用': '总费用',
  '近一年': '近一年',
  '近半年': '近半年',
  '充值': '充值',
  '元': '元',
  '具有DML(增、删、改、查)可对库增、删、改、查、创建和删除表和索引、修改表结构、查看进程操作，默认用于数据库版本部署(版本发布)账号': '具有DML(增、删、改、查)可对库增、删、改、查、创建和删除表和索引、修改表结构、查看进程操作，默认用于数据库版本部署(版本发布)账号',
  '可对库增、删、改、查;表、索引、外键、视图、存储过程、触发器、临时表、锁表、进程、事件的DDL和DML操作': '可对库增、删、改、查;表、索引、外键、视图、存储过程、触发器、临时表、锁表、进程、事件的DDL和DML操作',
  '可对库增、删、改、查、创建和执行存储过程、创建临时表、锁表、查看视图和进程信息操作': '可对库增、删、改、查、创建和执行存储过程、创建临时表、锁表、查看视图和进程信息操作',
  '可对库增、删、改、查;表、索引、外键、视图、存储过程、触发器等DDL和DML操作': '可对库增、删、改、查;表、索引、外键、视图、存储过程、触发器等DDL和DML操作',
  '可对库增、删、改、查操作，默认用于应用系统配置数据源': '可对库增、删、改、查操作，默认用于应用系统配置数据源',
  '请输入关键字进行过滤': '请输入关键字进行过滤',
  '源库名':'源库名',
  '源表名':'源表名',
  '已选择对象':'已选择对象',
  '可对库查询操作': '可对库查询操作',
  '授权': '授权',
  '插入数据': '插入数据',
  '更新数据': '更新数据',
  '创建函数': '创建函数',
  '删除函数': '删除函数',
  '创建存储过程': '创建存储过程',
  '默认分配空间': '默认分配空间',
  '编辑存储过程': '编辑存储过程',
  '删除存储过程': '删除存储过程',
  '删除触发器': '删除触发器',
  '创建序列': '创建序列',
  '编辑序列': '编辑序列',
  '打开视图(SQL)': '打开视图(SQL)',
  '删除序列': '删除序列',
  '自定义空间': '自定义空间',
  '数据磁盘': '数据磁盘',
  '当前磁盘容量最大值为':'当前磁盘容量最大值为',
  '当前磁盘容量总和为':'当前磁盘容量总和为',
  '当前磁盘容量总和超过':'当前磁盘容量总和超过',
  '请重新分配！':'请重新分配！',
  '归档磁盘': '归档磁盘',
  '字符集': '字符集',
  '数据盘': '数据盘',
  '块大小': '块大小',
  '用户名由小写字母，数字、下划线组成、字母开头， 字母或数字结尾，最长16个字符': '用户名由小写字母，数字、下划线组成、字母开头， 字母或数字结尾，最长16个字符',
  '用户名由字母开头，小写字母，数字、下划线组成， 字母或数字结尾，最长19个字符': '用户名由字母开头，小写字母，数字、下划线组成， 字母或数字结尾，最长19个字符',
  '不能设置如下特殊字母welcome, database, account,  <br> user, password, oracle,computer, abcd': '不能设置如下特殊字母welcome, database, account,  <br> user, password, oracle,computer, abcd',
  '一个数据库实例中有且仅有一个数据备份策略，需要删除已创立的备份策略后执行': '一个数据库实例中有且仅有一个数据备份策略，需要删除已创立的备份策略后执行',
  '大小写字母、数字、特殊字符,特殊字符为!@#$%^&*()_+=': '大小写字母、数字、特殊字符,特殊字符为!@#$%^&*()_+=',
  '数据库名由小写字母、数字、下划线组成，字母开头，字母或数字结尾': '数据库名由小写字母、数字、下划线组成，字母开头，字母或数字结尾',
  'off状态下，系统将自动分配默认密码': 'off状态下，系统将自动分配默认密码',
  '属主用户密码不可以与用户名相同': '属主用户密码不可以与用户名相同',
  '应用用户密码不可以与用户名相同': '应用用户密码不可以与用户名相同',
  '数据库名长度为2-60个字符！': '数据库名长度为2-60个字符！',
  '数据库名长度为2-63个字符！': '数据库名长度为2-63个字符！',
  '用户名长度需为16个字符以内': '用户名长度需为16个字符以内',
  '用户名长度需2-19个字符': '用户名长度需2-19个字符',
  '用户名长度需2-16个字符': '用户名长度需2-16个字符',
  '小写字母、数字、下划线': '小写字母、数字、下划线',
  '关系型数据库 帮助文档': '关系型数据库 帮助文档',
  'Oracle 操作指南': 'Oracle 操作指南',
  '实例无可恢复时间点！': '实例无可恢复时间点！',
  'MySQL 操作指南': 'MySQL 操作指南',
  '排序规则 不能为空': '排序规则 不能为空',
  '字符分类 不能为空': '字符分类 不能为空',
  '请检查属主用户密码': '请检查属主用户密码',
  '请检查应用用户密码': '请检查应用用户密码',
  '数据库创建 --': '数据库创建 --',
  '请先选择字符集！': '请先选择字符集！',
  '字符集 不能为空': '字符集 不能为空',
  '创建数据库成功！': '创建数据库成功！',
  '账户创建 --': '账户创建 --',
  '请填写用户前缀': '请填写用户前缀',
  '8-30位字符': '8-30位字符',
  '12-30位字符': '12-30位字符',
  '用户名不能为空': '用户名不能为空',
  '创建用户成功！': '创建用户成功！',
  '创建备份失败': '创建备份失败',
  '未授权数据库': '未授权数据库',
  '已授权数据库': '已授权数据库',
  '授权用户账号': '授权用户账号',
  '数据库端口:': '数据库端口:',
  '数据库类型:': '数据库类型:',
  '查看更多数据': '查看更多数据',
  '关系型数据库': '关系型数据库',
  '数据库创建': '数据库创建',
  '授权数据库': '授权数据库',
  '数据库账号': '数据库账号',
  '未授权账户': '未授权账户',
  '已授权账户': '已授权账户',
  '排序规则': '排序规则',
  '数据库名': '数据库名',
  '字符分类': '字符分类',
  '属主用户': '属主用户',
  '应用用户': '应用用户',
  '用户权限': '用户权限',
  '账户创建': '账户创建',
  '创建备份': '创建备份',
  '备份恢复': '备份恢复',
  '用户前缀': '用户前缀',
  '设置密码': '设置密码',
  '升级中': '升级中',
  '必填': '必填',
  '创建': '创建',
  '只读': '只读',
  '实例ID 不能为空': '实例ID 不能为空',
  '请选择实例ID': '请选择实例ID',
  '确定移除资源': '确定移除资源',
  '部署单元详情': '部署单元详情',
  '实例ID:': '实例ID:',
  '添加成功！': '添加成功！',
  '添加云主机': '添加云主机',
  '云主机列表': '云主机列表',
  '云主机数量': '云主机数量',
  '实例ID': '实例ID',
  '移除成功': '移除成功',
  '宿主机': '宿主机',
  '挂起': '挂起',
  '区域': '区域',
  '策略': '策略',
  '描述': '描述',
  '暂停': '暂停',
  '部署单元是指控制一组云主机分布在指定项目及可用区内不同计算节点上的策略，以此保证业务的高可用性和底层容灾能力。欢迎大家使用并反馈建议！': '部署单元是指控制一组云主机分布在指定项目及可用区内不同计算节点上的策略，以此保证业务的高可用性和底层容灾能力。欢迎大家使用并反馈建议！',
  '请输入部署单元描述': '请输入部署单元描述',
  '请输入部署单元名称': '请输入部署单元名称',
  '可用区 不能为空': '可用区 不能为空',
  '创建部署单元': '创建部署单元',
  '部署单元名称': '部署单元名称',
  '修改成功！': '修改成功！',
  '新增成功！': '新增成功！',
  '可用区:': '可用区:',
  '请填a-z,0-9,-,@,*，或者单个@,*': '请填a-z,0-9,-,@,*，或者单个@,*',
  '请正确填写记录名，@或*只能单独存在': '请正确填写记录名，@或*只能单独存在',
  '请正确填写记录名，a-z,0-9,-': '请正确填写记录名，a-z,0-9,-',
  '请填写解析网络区域 !': '请填写解析网络区域 !',
  '请填写记录名称 !': '请填写记录名称 !',
  '请填写记录值 !': '请填写记录值 !',
  '请选择域名 !': '请选择域名 !',
  '请填写ip地址': '请填写ip地址',
  '解析网络环境': '解析网络环境',
  '解析网络区域': '解析网络区域',
  'DNS购买': 'DNS购买',
  '请填写域名': '请填写域名',
  '生存时间': '生存时间',
  '已选信息': '已选信息',
  '记录名称': '记录名称',
  '记录类型': '记录类型',
  '记录值': '记录值',
  '解析网络区域 不能为空': '解析网络区域 不能为空',
  '记录类型 不能为空': '记录类型 不能为空',
  '新增成功 !': '新增成功 !',
  '请输入记录值': '请输入记录值',
  'DNS详情': 'DNS详情',
  '添加记录': '添加记录',
  '新增记录': '新增记录',
  '解析设置': '解析设置',
  '多域云解析DNS 操作指南': '多域云解析DNS 操作指南',
  '请勿重复锁定！': '请勿重复锁定！',
  '确定解锁该': '确定解锁该',
  '点击可解锁': '点击可解锁',
  '锁定成功！': '锁定成功！',
  '解锁成功！': '解锁成功！',
  '确定锁定该': '确定锁定该',
  '记录列表': '记录列表',
  '增加记录': '增加记录',
  '锁定者': '锁定者',
  '锁定': '锁定',
  '解锁': '解锁',
  '数据盘(GB)': '数据盘(GB)',
  '云数据库购买': '云数据库购买',
  '修改成功 !': '修改成功 !',
  '用户名由小写字母，数字、下划线组成、字母开头， 字母或数字结尾，最长64个字符！': '用户名由小写字母，数字、下划线组成、字母开头， 字母或数字结尾，最长64个字符！',
  '数据库名由小写字母、数字、下划线、中划线组成，字母开头，字母或数字结尾': '数据库名由小写字母、数字、下划线、中划线组成，字母开头，字母或数字结尾',
  '由小写字母，数字、下划线组成，最长16个字符': '由小写字母，数字、下划线组成，最长16个字符',
  '小写字母、数字、下划线、中划线': '小写字母、数字、下划线、中划线',
  '用户名长度必须大于等于 2！': '用户名长度必须大于等于 2！',
  '用户名长度最长64个字符！': '用户名长度最长64个字符！',
  '大小写字母、数字、特殊字符': '大小写字母、数字、特殊字符',
  '文档型数据库 操作指南': '文档型数据库 操作指南',
  '账户创建 -- 新增': '账户创建 -- 新增',
  '请先选择目标库！': '请先选择目标库！',
  '目标库不能为空': '目标库不能为空',
  '修改权限 --': '修改权限 --',
  '请填写用户名！': '请填写用户名！',
  '其他库权限': '其他库权限',
  '当前库权限': '当前库权限',
  '请先选择第': '请先选择第',
  '目标库:': '目标库:',
  '用户名:': '用户名:',
  '用户管理': '用户管理',
  '权限类型': '权限类型',
  '条数据库': '条数据库',
  '用户名': '用户名',
  '条角色': '条角色',
  '新建': '新建',
  '角色': '角色',
  '用户': '用户',
  '2.全量数据迁移时，迁移的表需与源端表结构一致，且目标端表数据为空，不能存在外键约束。': '2.全量数据迁移时，迁移的表需与源端表结构一致，且目标端表数据为空，不能存在外键约束。',
  '注意: 1.结构迁移时：源端用户要有DML权限,目标端用户要有DDL、DML权限。\n': '注意: 1.结构迁移时：源端用户要有DML权限,目标端用户要有DDL、DML权限。\n',
  '1.全量数据迁移过程中，如果源库有数据更新，这部分更新数据不保证被迁移到目标实例；': '1.全量数据迁移过程中，如果源库有数据更新，这部分更新数据不保证被迁移到目标实例；',
  '检查目标端表结构是否适用于源端 （Oracle表列名必须大写）': '检查目标端表结构是否适用于源端 （Oracle表列名必须大写）',
  '2.全量数据迁移时：源端与目标端用户要有DML权限。': '2.全量数据迁移时：源端与目标端用户要有DML权限。',
  '检查目的库是否存在跟待迁移对象同名的结构对象': '检查目的库是否存在跟待迁移对象同名的结构对象',
  '提示：建议采用大写字母，小写字母默认转成大写字母。': '提示：建议采用大写字母，小写字母默认转成大写字母。',
  '检查目标端数据库的账号权限是否满足迁移要求': '检查目标端数据库的账号权限是否满足迁移要求',
  '已选择的目标端信息有误，连接数据库失败！': '已选择的目标端信息有误，连接数据库失败！',
  '检查数据迁移服务器是否能连通目的数据库': '检查数据迁移服务器是否能连通目的数据库',
  '检查数据迁移服务器是否能连通源数据库': '检查数据迁移服务器是否能连通源数据库',
  '结构迁移时：源端用户要有DML权限': '结构迁移时：源端用户要有DML权限',
  '目标库不存在相同表名，请重新编辑!': '目标库不存在相同表名，请重新编辑!',
  '目标库存在相同表名，请重新编辑!': '目标库存在相同表名，请重新编辑!',
  '检查源库是否存在待迁移的结构对象': '检查源库是否存在待迁移的结构对象',
  '目标数据湖连通性检查':'目标数据湖连通性检查',
  '检查目标端是否信任存储函数创建者': '检查目标端是否信任存储函数创建者',
  '源库实例与目标库实例不能相同！': '源库实例与目标库实例不能相同！',
  '目标端库名已存在，请重新编辑！': '目标端库名已存在，请重新编辑！',
  '预检查成功，不能返回上一步！': '预检查成功，不能返回上一步！',
  '目标端库对象数据存在性检查': '目标端库对象数据存在性检查',
  '预检查失败，不能启动迁移！': '预检查失败，不能启动迁移！',
  '检查目标端库中表是否为空': '检查目标端库中表是否为空',
  '源库目标库表结构适用检查': '源库目标库表结构适用检查',
  '任务名长度为2-64位！': '任务名长度为2-64位！',
  '请完整填写迁移对象信息！': '请完整填写迁移对象信息！',
  '目标端信任存储函数检查': '目标端信任存储函数检查',
  '目标库测试连接不通过!': '目标库测试连接不通过!',
  '迁移类型至少选择一个！': '迁移类型至少选择一个！',
  '新增目标端表空间成功！': '新增目标端表空间成功！',
  '目标端对象存在性检查': '目标端对象存在性检查',
  '源库测试连接不通过!': '源库测试连接不通过!',
  '新增目标端用户成功！': '新增目标端用户成功！',
  '目标端表空间已存在！': '目标端表空间已存在！',
  '不能存在同库同表名!': '不能存在同库同表名!',
  '任务名重复，请修改': '任务名重复，请修改',
  '请先选择迁移类型！': '请先选择迁移类型！',
  '请先选择迁移对象！': '请先选择迁移对象！',
  '新增目标端表成功！': '新增目标端表成功！',
  '目标端用户已存在！': '目标端用户已存在！',
  '源库对象存在性检查': '源库对象存在性检查',
  '请输入数据库账号': '请输入数据库账号',
  '请输入数据库密码': '请输入数据库密码',
  '目的库连接性检查': '目的库连接性检查',
  '目标端库权限检查': '目标端库权限检查',
  'ECS自建数据库': 'ECS自建数据库',
  '请先填写任务名！': '请先填写任务名！',
  '目标端表已存在！': '目标端表已存在！',
  '请输入任务名称': '请输入任务名称',
  '目标端表空间：': '目标端表空间：',
  '源库连接性检查': '源库连接性检查',
  '立即购买并启动': '立即购买并启动',
  '迁移类型及列表': '迁移类型及列表',
  '请先测试连接!': '请先测试连接!',
  '请先选择租户!': '请先选择租户!',
  '库账号与密码!': '库账号与密码!',
  '库实例列表!': '库实例列表!',
  '非RAC实例': '非RAC实例',
  '目标端用户：': '目标端用户：',
  '源库及目标库': '源库及目标库',
  'RDS数据库': 'RDS数据库',
  '全量数据迁移': '全量数据迁移',
  '库实例类型!': '库实例类型!',
  '启动成功 !': '启动成功 !',
  '库应用环境!': '库应用环境!',
  '库IP地址!': '库IP地址!',
  '目标端表空间': '目标端表空间',
  '目标库实例': '目标库实例',
  '温馨提示：': '温馨提示：',
  '数据库密码': '数据库密码',
  '目标库信息': '目标库信息',
  '源端用户：': '源端用户：',
  '任务名称:': '任务名称:',
  'RAC实例': 'RAC实例',
  '目标库IP': '目标库IP',
  '新增数据表': '新增数据表',
  '新增数据库': '新增数据库',
  '库的项目!': '库的项目!',
  '目标端用户': '目标端用户',
  '任务名称': '任务名称',
  '源库信息': '源库信息',
  '实例类型': '实例类型',
  '实例列表': '实例列表',
  '实例地区': '实例地区',
  '迁移级别': '迁移级别',
  '迁移类型': '迁移类型',
  '目标端：': '目标端：',
  '检测内容': '检测内容',
  '检测结果': '检测结果',
  '测试连接': '测试连接',
  '源库实例': '源库实例',
  '源库IP': '源库IP',
  '连接成功': '连接成功',
  '连接失败': '连接失败',
  '诊断内容': '诊断内容',
  '诊断结果': '诊断结果',
  '数据迁移': '数据迁移',
  '结构迁移': '结构迁移',
  '用户级别': '用户级别',
  '目标端表': '目标端表',
  '请先选择': '请先选择',
  '请先填写': '请先填写',
  '库端口!': '库端口!',
  '检测项': '检测项',
  '预检查': '预检查',
  '表级别': '表级别',
  '目标端': '目标端',
  '源端：': '源端：',
  '目标': '目标',
  '源': '源',
  '数据迁移详情': '数据迁移详情',
  '目标端迁移账号': '目标端迁移账号',
  '目标端项目名称': '目标端项目名称',
  '增量数据迁移': '增量数据迁移',
  '源端项目名称': '源端项目名称',
  '源端迁移账号': '源端迁移账号',
  '目标端库端口': '目标端库端口',
  '目标端库类型': '目标端库类型',
  '目标数据表': '目标数据表',
  '源端库类型': '源端库类型',
  '目标端IP': '目标端IP',
  '源端库端口': '源端库端口',
  '目标数据库': '目标数据库',
  '迁移对象': '迁移对象',
  '源数据库': '源数据库',
  '源数据表': '源数据表',
  '迁移完成': '迁移完成',
  '迁移失败': '迁移失败',
  '任务ID': '任务ID',
  '用户ID': '用户ID',
  '源端IP': '源端IP',
  '租户名称': '租户名称',
  '迁移中': '迁移中',
  '未迁移': '未迁移',
  '库级别': '库级别',
  '数据迁移DTS 操作指南': '数据迁移DTS 操作指南',
  '迁移中状态禁止删除!': '迁移中状态禁止删除!',
  '目标端数据库类型': '目标端数据库类型',
  '源端数据库类型': '源端数据库类型',
  '目标端可用区': '目标端可用区',
  '目标端项目': '目标端项目',
  '迁移任务名': '迁移任务名',
  '源端可用区': '源端可用区',
  '源端项目': '源端项目',
  '迁移任务': '迁移任务',
  '任务名': '任务名',
  '数据库名由小写字母、数字、中划线、下划线组成，字母开头，字母或数字结尾': '数据库名由小写字母、数字、中划线、下划线组成，字母开头，字母或数字结尾',
  '表名由小写字母、数字、中划线、下划线组成，字母开头，字母或数字结尾': '表名由小写字母、数字、中划线、下划线组成，字母开头，字母或数字结尾',
  '数据库binlog需设为ROW模式，默认从当前位点开始同步数据': '数据库binlog需设为ROW模式，默认从当前位点开始同步数据',
  '检查目的库是否存在跟待同步对象同名的结构对象': '检查目的库是否存在跟待同步对象同名的结构对象',
  '检查目的数据库的账号权限是否满足同步要求': '检查目的数据库的账号权限是否满足同步要求',
  '检查数据传输服务器是否能连通目的数据库': '检查数据传输服务器是否能连通目的数据库',
  '检查源数据库的binlog模式是否合法': '检查源数据库的binlog模式是否合法',
  '检查源数据库的账号权限是否满足同步要求': '检查源数据库的账号权限是否满足同步要求',
  '检查数据传输服务器是否能连通源数据库': '检查数据传输服务器是否能连通源数据库',
  '检查源数据库是否开启binlog': '检查源数据库是否开启binlog',
  '检查源数据库是否设置server_id大于1': '检查源数据库是否设置server_id大于1',
  '检查源表与目标表结构是否一致': '检查源表与目标表结构是否一致',
  '预检查失败，不能启动同步！': '预检查失败，不能启动同步！',
  '源库binlog模式检查': '源库binlog模式检查',
  '源和目标表是否有主键检查': '源和目标表是否有主键检查',
  '检查源和目标表是否有主键': '检查源和目标表是否有主键',
  '任务名长度为2-32位！': '任务名长度为2-32位！',
  '请完整填写同步对象信息！': '请完整填写同步对象信息！',
  '源库binlog开启检查': '源库binlog开启检查',
  '数据库名不能重复新增': '数据库名不能重复新增',
  '新增目标端表名成功！': '新增目标端表名成功！',
  '源与目标表结构检查': '源与目标表结构检查',
  '目标端表名已存在！': '目标端表名已存在！',
  '同步表必须有主键': '同步表必须有主键',
  '源库server_id检查': '源库server_id检查',
  '目的库权限检查': '目的库权限检查',
  '全量数据初始化': '全量数据初始化',
  '任务名已存在！': '任务名已存在！',
  '源库权限检查': '源库权限检查',
  '选择同步对象': '选择同步对象',
  '实例可用区': '实例可用区',
  '同步架构：': '同步架构：',
  '温馨提示:': '温馨提示:',
  '结构初始化': '结构初始化',
  '配置链路': '配置链路',
  '单向同步': '单向同步',
  '初始化：': '初始化：',
  '立即启动': '立即启动',
  '目标表': '目标表',
  '序号': '序号',
  'large规格的线上运行性能依赖于网络环境、源实例和目标实例的性能。': 'large规格的线上运行性能依赖于网络环境、源实例和目标实例的性能。',
  '源实例可用区:': '源实例可用区:',
  '目标可用区:': '目标可用区:',
  '目标数据库类型': '目标数据库类型',
  '源数据库类型': '源数据库类型',
  '目标实例:': '目标实例:',
  '同步拓扑:': '同步拓扑:',
  '链路规格:': '链路规格:',
  '购买数量:': '购买数量:',
  '目标实例': '目标实例',
  '同步拓扑': '同步拓扑',
  '链路规格': '链路规格',
  '购买数量': '购买数量',
  '源实例:': '源实例:',
  '创建任务': '创建任务',
  '源实例': '源实例',
  '无限制': '无限制',
  '数据传输详情': '数据传输详情',
  '增量数据同步': '增量数据同步',
  '初始化失败': '初始化失败',
  '连接信息': '连接信息',
  '同步对象': '同步对象',
  '初始化中': '初始化中',
  '双向同步': '双向同步',
  '同步类型': '同步类型',
  '同步账号': '同步账号',
  '同步中': '同步中',
  '未配置': '未配置',
  '类别': '类别',
  '源端': '源端',
  '异常': '异常',
  '数据传输DTS 操作指南': '数据传输DTS 操作指南',
  '同步中状态禁止删除!': '同步中状态禁止删除!',
  '停止成功 !': '停止成功 !',
  '传输任务名': '传输任务名',
  '购买链路': '购买链路',
  '同步任务': '同步任务',
  '最小磁盘(GB)': '最小磁盘(GB)',
  '最小内存(MB)': '最小内存(MB)',
  '大小(GB)': '大小(GB)',
  '云主机详情': '云主机详情',
  '磁盘列表': '磁盘列表',
  '磁盘类型': '磁盘类型',
  '硬盘类型':'硬盘类型',
  '快照列表': '快照列表',
  '系统版本': '系统版本',
  '已挂载': '已挂载',
  '磁盘名': '磁盘名',
  '快照名': '快照名',
  '格式': '格式',
  '空闲': '空闲',
  '云主机': '云主机',
  '备份策略ID': '备份策略ID',
  '备份计划ID': '备份计划ID',
  '备份计划名称': '备份计划名称',
  '主机实例名称': '主机实例名称',
  '备份策略名称': '备份策略名称',
  '备份部分成功': '备份部分成功',
  '备份主机名': '备份主机名',
  '备份进行中': '备份进行中',
  '策略类型': '策略类型',
  '暂停备份': '暂停备份',
  '备份成功': '备份成功',
  '策略名称': '策略名称',
  '备份失败': '备份失败',
  '数据量': '数据量',
  '恢复': '恢复',
  '周期': '周期',
  '单次': '单次',
  '文件系统和挂载点请同时配置，只配置其中一项无效!': '文件系统和挂载点请同时配置，只配置其中一项无效!',
  '目前仅支持输入10个以内数量的IP!': '目前仅支持输入10个以内数量的IP!',
  '/路径名称，如：/rh/data': '/路径名称，如：/rh/data',
  '所选子网可用ip数不足 !': '所选子网可用ip数不足 !',
  '请选择有效的云主机类型 !': '请选择有效的云主机类型 !',
  'IOPS读/写总(次s)': 'IOPS读/写总(次s)',
  '必填，请输入部署单元名称': '必填，请输入部署单元名称',
  '请选择有效的系统版本 !': '请选择有效的系统版本 !',
  '带宽读/写总(KBs)': '带宽读/写总(KBs)',
  '挂载路径填写不规范!': '挂载路径填写不规范!',
  '请选择云硬盘类型 !': '请选择云硬盘类型 !',
  '部署单元创建成功！': '部署单元创建成功！',
  '带宽(Mbps)': '带宽(Mbps)',
  '无可用主机机型': '无可用主机机型',
  '公网IP类型': '公网IP类型',
  '需要公网IP': '需要公网IP',
  '已被使用了！': '已被使用了！',
  'GPU数量': 'GPU数量',
  '专属宿主机': '专属宿主机',
  'MB内存、': 'MB内存、',
  '个IP和第': '个IP和第',
  '个IP相同': '个IP相同',
  '云主机购买': '云主机购买',
  '请先修改!': '请先修改!',
  '云主机类型': '云主机类型',
  '镜像提供方': '镜像提供方',
  '云硬盘类型': '云硬盘类型',
  '共享镜像': '共享镜像',
  '固定宽带': '固定宽带',
  '文件系统': '文件系统',
  '挂载路径': '挂载路径',
  '按流量': '按流量',
  '架构': '架构',
  '平台': '平台',
  '第': '第',
  '建议8位以上，包含大小写字母、数字、下划线': '建议8位以上，包含大小写字母、数字、下划线',
  '最小磁盘和最小内存只能填整数!': '最小磁盘和最小内存只能填整数!',
  '没有可以解除的可用区了！': '没有可以解除的可用区了！',
  '没有可以同步的可用区了！': '没有可以同步的可用区了！',
  '必填,2-32字符': '必填,2-32字符',
  '审核失败ailed': '审核失败ailed',
  '请先填写最小磁盘!': '请先填写最小磁盘!',
  '请先填写最小内存!': '请先填写最小内存!',
  '请先选择操作系统!': '请先选择操作系统!',
  '请先选择文件格式!': '请先选择文件格式!',
  '请先选择可用区!': '请先选择可用区!',
  '文件上传成功!': '文件上传成功!',
  '解除镜像成功！': '解除镜像成功！',
  '同步镜像成功！': '同步镜像成功！',
  '安全审核状态:': '安全审核状态:',
  '请先上传文件!': '请先上传文件!',
  '没有可选可用区': '没有可选可用区',
  '安全审批状态': '安全审批状态',
  '请选择可用区': '请选择可用区',
  '支持密码注入': '支持密码注入',
  '请提前在镜像中安装cloud-init软件':'请提前在镜像中安装cloud-init软件',
  '同步至可用区': '同步至可用区',
  '大小(MB)': '大小(MB)',
  '审核结果说明': '审核结果说明',
  'root密码': 'root密码',
  '可用区配置': '可用区配置',
  '操作系统:': '操作系统:',
  '文件格式:': '文件格式:',
  '解除可用区': '解除可用区',
  '单位:MB': '单位:MB',
  '审核成功': '审核成功',
  '审核失败': '审核失败',
  '上传成功': '上传成功',
  '上传失败': '上传失败',
  '新增镜像': '新增镜像',
  '镜像配置': '镜像配置',
  '最小内存': '最小内存',
  '最小磁盘': '最小磁盘',
  '单位:G': '单位:G',
  '待审核': '待审核',
  '文件:': '文件:',
  '上传中': '上传中',
  '排序值': '排序值',
  '公开': '公开',
  '数字': '数字',
  '先添加操作数据': '先添加操作数据',
  '公网IP': '公网IP',
  '操作用户': '操作用户',
  '操作IP': '操作IP',
  '操作类型': '操作类型',
  '操作日志': '操作日志',
  '挂载磁盘': '挂载磁盘',
  '操作时间': '操作时间',
  '设备': '设备',
  '必填,2-60字符': '必填,2-60字符',
  '必填,http地址': '必填,http地址',
  '排序值只能填整数!': '排序值只能填整数!',
  '请选择可用区!': '请选择可用区!',
  '操作系统类型': '操作系统类型',
  '文件URL': '文件URL',
  '必填,数字': '必填,数字',
  '发行版本': '发行版本',
  '勾选挂载的云硬盘后，删除云主机同时将删除云硬盘，请确认数据已备份': '勾选挂载的云硬盘后，删除云主机同时将删除云硬盘，请确认数据已备份',
  '此云硬盘中存在快照记录，请删除快照记录后删除云硬盘': '此云硬盘中存在快照记录，请删除快照记录后删除云硬盘',
  '操作指令已发出，请关注状态变化！': '操作指令已发出，请关注状态变化！',
  '描述字段长度为2-60个字符！': '描述字段长度为2-60个字符！',
  '请卸载云硬盘后再操作重建主机': '请卸载云硬盘后再操作重建主机',
  '主机该状态下无法打开控制台！': '主机该状态下无法打开控制台！',
  '购买硬盘请求已发送成功 !': '购买硬盘请求已发送成功 !',
  '磁盘挂载命令已发出 !': '磁盘挂载命令已发出 !',
  '云主机没有挂载磁盘 !': '云主机没有挂载磁盘 !',
  '云主机ECS 操作指南': '云主机ECS 操作指南',
  '该云主机已经解锁 !': '该云主机已经解锁 !',
  '该云主机系统已经挂载': '该云主机系统已经挂载',
  '当前状态不允许解绑！': '当前状态不允许解绑！',
  '该云主机已经锁定 !': '该云主机已经锁定 !',
  '重建命令已发送成功！': '重建命令已发送成功！',
  '没有可绑定的eip': '没有可绑定的eip',
  '磁盘类型 不能为空': '磁盘类型 不能为空',
  '迁移命令发送成功！': '迁移命令发送成功！',
  '重建后将无法启动': '重建后将无法启动',
  '磁盘列表获取为空': '磁盘列表获取为空',
  '确定锁定该云主机': '确定锁定该云主机',
  'ECS 帮助文档': 'ECS 帮助文档',
  '堡垒机 操作指南': '堡垒机 操作指南',
  '请选择专有宿主机': '请选择专有宿主机',
  '请先选择机器 !': '请先选择机器 !',
  '该云主机已经锁定,不允许销毁 !': '该云主机已经锁定,不允许销毁 !',
  '确定解锁该云主机': '确定解锁该云主机',
  '磁盘卸载成功 !': '磁盘卸载成功 !',
  '请先选择eip！': '请先选择eip！',
  '暂不支持快照服务': '暂不支持快照服务',
  '路径名称，如：': '路径名称，如：',
  '编辑修改成功！': '编辑修改成功！',
  '请选择配置 !': '请选择配置 !',
  '配置修改成功！': '配置修改成功！',
  '重建云主机失败': '重建云主机失败',
  '绑定申请成功！': '绑定申请成功！',
  '解绑申请成功！': '解绑申请成功！',
  '可绑定EIP': '可绑定EIP',
  '无法绑定 !': '无法绑定 !',
  '修改公网带宽': '修改公网带宽',
  '修改配置确认': '修改配置确认',
  '共享计算节点': '共享计算节点',
  '弹性网卡列表': '弹性网卡列表',
  '快速购买硬盘': '快速购买硬盘',
  '确定解绑该': '确定解绑该',
  '宿主机迁移': '宿主机迁移',
  '个云数据盘': '个云数据盘',
  '所在可用区': '所在可用区',
  '硬重启主机': '硬重启主机',
  '目标宿主机': '目标宿主机',
  '删除成功！': '删除成功！',
  '磁盘类型:': '磁盘类型:',
  '当前宿主机': '当前宿主机',
  '绑定eip': '绑定eip',
  '云主机迁移': '云主机迁移',
  '请选择配置': '请选择配置',
  '解绑eip': '解绑eip',
  'EIP绑定': 'EIP绑定',
  '确定进行': '确定进行',
  '购买磁盘': '购买磁盘',
  '当前配置': '当前配置',
  '卸载磁盘': '卸载磁盘',
  '创建快照': '创建快照',
  '重建确认': '重建确认',
  '迁移备注': '迁移备注',
  '磁盘挂载': '磁盘挂载',
  '硬重启': '硬重启',
  '(固-': '(固-',
  '重建': '重建',
  '名字': '名字',
  '全选': '全选',
  '数据统计来源不同：基础监控的统计数据来源于虚拟化层，操作系统监控的统计数据来源于虚拟机内部。': '数据统计来源不同：基础监控的统计数据来源于虚拟化层，操作系统监控的统计数据来源于虚拟机内部。',
  '操作系统统计频率是10秒，所以如果监控数据波动比较大时，数据被削峰填谷导致数据不一致。': '操作系统统计频率是10秒，所以如果监控数据波动比较大时，数据被削峰填谷导致数据不一致。',
  '统计频率不同:监控图表中提供的数据均为统计周期内的平均值，基础监控统计频率是1分钟，': '统计频率不同:监控图表中提供的数据均为统计周期内的平均值，基础监控统计频率是1分钟，',
  '您在查看基础监控和操作系统监控数据时，可能会存在数据不一致的情况，主要有以下原因：': '您在查看基础监控和操作系统监控数据时，可能会存在数据不一致的情况，主要有以下原因：',
  '所以会出现操作系统监控的数据和基础监控数据不一致的情况': '所以会出现操作系统监控的数据和基础监控数据不一致的情况',
  '（即插件采集的数据和虚拟化层采集的数据不同）。': '（即插件采集的数据和虚拟化层采集的数据不同）。',
  '网卡入口包速率': '网卡入口包速率',
  '网卡出口包速率': '网卡出口包速率',
  '网卡出口流量': '网卡出口流量',
  '网卡入口流量': '网卡入口流量',
  '卷IO利用率': '卷IO利用率',
  '操作系统监控': '操作系统监控',
  '卷写入速率': '卷写入速率',
  '卷读写延时': '卷读写延时',
  '云主机信息': '云主机信息',
  '卷读取速率': '卷读取速率',
  '基础监控': '基础监控',
  'C-Z任一字符加:\\开头，eg:D:\\Nextcloud\\工作': 'C-Z任一字符加:\\开头，eg:D:\\Nextcloud\\工作',
  'windows操作系统的云主机安装备份软件，安装流程参照': 'windows操作系统的云主机安装备份软件，安装流程参照',
  '工作，必须以C-Z任一字符加:\\开头\n格式2：': '工作，必须以C-Z任一字符加:\\开头\n格式2：',
  '多个文件路径支持以换行符分隔\n例如：\n格式1：': '多个文件路径支持以换行符分隔\n例如：\n格式1：',
  'windows操作系统的云主机安装备份软件，': 'windows操作系统的云主机安装备份软件，',
  '需要恢复目录或者多个文件，请输入如': '需要恢复目录或者多个文件，请输入如',
  '确定覆盖后将把同名文件进行覆盖，': '确定覆盖后将把同名文件进行覆盖，',
  '工作，必须以C-Z任一字符加:': '工作，必须以C-Z任一字符加:',
  '多个文件路径支持以换行符分隔': '多个文件路径支持以换行符分隔',
  '需要恢复单个文件，请输入如': '需要恢复单个文件，请输入如',
  '每一行一个路径，例如：': '每一行一个路径，例如：',
  '请先配置恢复路径!': '请先配置恢复路径!',
  '请先配置恢复记录!': '请先配置恢复记录!',
  'ECS备份帮助文档': 'ECS备份帮助文档',
  '请先配置恢复名称!': '请先配置恢复名称!',
  '请先选择恢复主机!': '请先选择恢复主机!',
  '已选恢复备份记录': '已选恢复备份记录',
  '请输入文件列表!': '请输入文件列表!',
  '备份-文件列表': '备份-文件列表',
  '创建ECS恢复': '创建ECS恢复',
  '请输入路径：如': '请输入路径：如',
  '请输入文件路径': '请输入文件路径',
  '无可选备份记录': '无可选备份记录',
  '恢复至其他主机': '恢复至其他主机',
  '覆盖同名文件': '覆盖同名文件',
  '包含下列文件': '包含下列文件',
  '请谨慎操作。': '请谨慎操作。',
  '包含所有文件': '包含所有文件',
  '输入文件列表': '输入文件列表',
  '恢复至源主机': '恢复至源主机',
  '格式1：D:': '格式1：D:',
  '配置恢复原则': '配置恢复原则',
  '源主机名称': '源主机名称',
  '点击下载。': '点击下载。',
  '恢复规则': '恢复规则',
  '备份时间': '备份时间',
  '恢复路径': '恢复路径',
  '云主机名': '云主机名',
  '操作系统': '操作系统',
  '格式2：': '格式2：',
  '目标主机': '目标主机',
  '确认恢复': '确认恢复',
  '目标路径': '目标路径',
  '恢复名称': '恢复名称',
  '原目录': '原目录',
  '查看': '查看',
  '开头': '开头',
  '恢复所选备份数据': '恢复所选备份数据',
  '源主机可用区': '源主机可用区',
  '目标主机IP': '目标主机IP',
  '源主机IP': '源主机IP',
  '恢复目录': '恢复目录',
  '恢复主机': '恢复主机',
  '恢复失败': '恢复失败',
  '部分成功': '部分成功',
  '源主机': '源主机',
  '恢复中': '恢复中',
  '云主机快照详情': '云主机快照详情',
  '源主机名': '源主机名',
  '排序': '排序',
  '云主机快照列表': '云主机快照列表',
  '多个文件路径支持以逗号/换行符分隔\n例如：\n格式1：aa.txt\n格式2：\\aaa': '多个文件路径支持以逗号/换行符分隔\n例如：\n格式1：aa.txt\n格式2：\\aaa',
  'windows操作系统的云主机安装备份软件': 'windows操作系统的云主机安装备份软件',
  '请输入文件路径\n每一行一个路径，例如：': '请输入文件路径\n每一行一个路径，例如：',
  '请选择需要备份的云主机实例': '请选择需要备份的云主机实例',
  '请先输入正确格式文件路径': '请先输入正确格式文件路径',
  '创建ECS策略备份': '创建ECS策略备份',
  'C-Z任一字符加:': 'C-Z任一字符加:',
  '备份周期具体天数': '备份周期具体天数',
  '请先配置保留时间': '请先配置保留时间',
  '添加增量备份计划': '添加增量备份计划',
  '无符合条件云主机': '无符合条件云主机',
  '请先输入文件列表': '请先输入文件列表',
  '选择备份的文件': '选择备份的文件',
  '备份保留时间': '备份保留时间',
  '配置备份策略': '配置备份策略',
  '包括所有文件': '包括所有文件',
  '云主机实例': '云主机实例',
  '文件路径': '文件路径',
  '文件列表': '文件列表',
  '备份名称': '备份名称',
  '按量计费': '按量计费',
  '添加主机': '添加主机',
  '确认备份': '确认备份',
  '请先配置': '请先配置',
  '备份文件': '备份文件',
  '计费方式': '计费方式',
  '点击下载': '点击下载',
  '加入右侧': '加入右侧',
  '加入左侧': '加入左侧',
  '源文件': '源文件',
  '工作': '工作',
  '点击确定后，备份任务立即执行': '点击确定后，备份任务立即执行',
  '只有备份成功才可恢复！': '只有备份成功才可恢复！',
  '确定立即执行备份任务吗': '确定立即执行备份任务吗',
  '立即备份请求发送成功！': '立即备份请求发送成功！',
  '确定启用备份策略吗': '确定启用备份策略吗',
  '确定禁用备份策略吗': '确定禁用备份策略吗',
  '备份策略创建失败': '备份策略创建失败',
  '当前条件暂无数据': '当前条件暂无数据',
  '备份策略创建成功': '备份策略创建成功',
  '备份软件安装失败': '备份软件安装失败',
  '备份数据成功率': '备份数据成功率',
  '备份策略创建中': '备份策略创建中',
  '请选择时间区间': '请选择时间区间',
  '备份软件安装中': '备份软件安装中',
  '目标主机可用区': '目标主机可用区',
  '创建策略失败': '创建策略失败',
  '备份策略处于': '备份策略处于',
  '策略创建失败': '策略创建失败',
  '备份开始时间': '备份开始时间',
  '编辑备份计划': '编辑备份计划',
  '创建备份计划': '创建备份计划',
  '查看备份历史': '查看备份历史',
  '备份策略详情': '备份策略详情',
  '主机IP地址': '主机IP地址',
  '主机操作系统': '主机操作系统',
  '备份文件:': '备份文件:',
  '软件安装中': '软件安装中',
  '禁用成功！': '禁用成功！',
  '备份计划数': '备份计划数',
  '备份数据量': '备份数据量',
  '选择日期:': '选择日期:',
  '策略创建中': '策略创建中',
  '启用成功！': '启用成功！',
  '目标主机名': '目标主机名',
  '备份计划': '备份计划',
  '安装失败': '安装失败',
  '立即备份': '立即备份',
  '成功记录': '成功记录',
  '创建失败': '创建失败',
  '创建成功': '创建成功',
  '保留周期': '保留周期',
  '主机名称': '主机名称',
  '策略ID': '策略ID',
  '失败数': '失败数',
  '成功数': '成功数',
  '状态，': '状态，',
  '价格': '价格',
  '总量': '总量',
  '每周': '每周',
  '允许': '允许',
  '四': '四',
  '六': '六',
  '不': '不',
  '五': '五',
  '三': '三',
  '二': '二',
  '一': '一',
  '个': '个',
  '号': '号',
  '多个文件路径支持以逗号/换行符分隔': '多个文件路径支持以逗号/换行符分隔',
  '请先配置文件路径': '请先配置文件路径',
  'ECS实例IP': 'ECS实例IP',
  '软件安装失败': '软件安装失败',
  '修改备份策略': '修改备份策略',
  '增加备份计划': '增加备份计划',
  '云主机ID': '云主机ID',
  '是否启用': '是否启用',
  '计划数': '计划数',
  '名称不能以http://或https://开头 !:': '名称不能以http://或https://开头 !:',
  '描述不能以http://或https://开头 !': '描述不能以http://或https://开头 !',
  '该操作涉及价格，请先配置NAT网关！': '该操作涉及价格，请先配置NAT网关！',
  '该操作涉及价格，请先配置合适线路！': '该操作涉及价格，请先配置合适线路！',
  '请先填写不少于两个字符的名称!': '请先填写不少于两个字符的名称!',
  '当前选项下暂无路线，请修改配置': '当前选项下暂无路线，请修改配置',
  '非必填，2-60个字符': '非必填，2-60个字符',
  '必填，2-60个字符': '必填，2-60个字符',
  '创建NAT': '创建NAT',
  'EIP购买': 'EIP购买',
  '线路': '线路',
  'EIP详情': 'EIP详情',
  '付费类型': '付费类型',
  '锁定原因': '锁定原因',
  '绑定主机': '绑定主机',
  '已分配': '已分配',
  '绑定中': '绑定中',
  '解绑中': '解绑中',
  '可用': '可用',
  '已分配状态不允许删除！': '已分配状态不允许删除！',
  '没有同网段可绑定的主机': '没有同网段可绑定的主机',
  '已分配状态不允许绑定！': '已分配状态不允许绑定！',
  '当前状态不允许绑定！': '当前状态不允许绑定！',
  '没有可解绑的云主机！': '没有可解绑的云主机！',
  '当前状态不允许删除！': '当前状态不允许删除！',
  'EIP 操作指南': 'EIP 操作指南',
  '请先选择IP！': '请先选择IP！',
  '可绑定云主机': '可绑定云主机',
  '所属运营商': '所属运营商',
  '绑定': '绑定',
  '解绑': '解绑',
  'IP地址或者cidr，多个IP支持以逗号/空格/换行符分隔': 'IP地址或者cidr，多个IP支持以逗号/空格/换行符分隔',
  '】的后缀,后缀由大小写英文字母、数字、中划线、下划线组成': '】的后缀,后缀由大小写英文字母、数字、中划线、下划线组成',
  '】的前缀,前缀由大小写英文字母、数字、中划线、下划线组成': '】的前缀,前缀由大小写英文字母、数字、中划线、下划线组成',
  '多文件总容量最大为20M，请重新上传！': '多文件总容量最大为20M，请重新上传！',
  ',目标端口数值要满足1~65535 !': ',目标端口数值要满足1~65535 !',
  '该组配置正在进行编辑，不允许删除!': '该组配置正在进行编辑，不允许删除!',
  '文件大于10M，请重新上传！': '文件大于10M，请重新上传！',
  '前缀必填，字符长度1-60': '前缀必填，字符长度1-60',
  '后缀选填，字符长度0-40': '后缀选填，字符长度0-40',
  '单文件最大容量为10M，': '单文件最大容量为10M，',
  '前缀根据项目自动匹配': '前缀根据项目自动匹配',
  '请正确填写【目标系统': '请正确填写【目标系统',
  '请先选择【目标系统': '请先选择【目标系统',
  '重新提交请求已发送': '重新提交请求已发送',
  '请正确填写【源系统': '请正确填写【源系统',
  '请正确填写目标端口': '请正确填写目标端口',
  '请先填写申请理由': '请先填写申请理由',
  '字符长度0-40': '字符长度0-40',
  '是否为临时策略': '是否为临时策略',
  '请检查书写规范': '请检查书写规范',
  '确认请求已发送': '确认请求已发送',
  '新增防火墙策略': '新增防火墙策略',
  '请正确填写【': '请正确填写【',
  '】的起止时间': '】的起止时间',
  '】的目标端口': '】的目标端口',
  '安全规则试算': '安全规则试算',
  '已申请提交!': '已申请提交!',
  '正在编辑中': '正在编辑中',
  '添加源系统': '添加源系统',
  '删除源系统': '删除源系统',
  '的目标端口': '的目标端口',
  '单文件过大': '单文件过大',
  '请先填写【': '请先填写【',
  '上传文件': '上传文件',
  '试算结果': '试算结果',
  '后缀选填': '后缀选填',
  '目标系统': '目标系统',
  '目标IP': '目标IP',
  '目标端口': '目标端口',
  '试算条件': '试算条件',
  '立即提交': '立即提交',
  '】的协议': '】的协议',
  '协议类型': '协议类型',
  '重新提交': '重新提交',
  '尚无数据': '尚无数据',
  '起至时间': '起至时间',
  '起止时间': '起止时间',
  '选择时间': '选择时间',
  '】的前缀': '】的前缀',
  '申请理由': '申请理由',
  '源系统': '源系统',
  '源IP': '源IP',
  '】的【': '】的【',
  '系统': '系统',
  '试算': '试算',
  '】的': '】的',
  '的': '的',
  '请先选择要下载的文件': '请先选择要下载的文件',
  '防火墙策略详情': '防火墙策略详情',
  '审核不通过': '审核不通过',
  '下载附件': '下载附件',
  '签批时间': '签批时间',
  '申请失败': '申请失败',
  '审批流程': '审批流程',
  '审批结果': '审批结果',
  '审批人': '审批人',
  '下发中': '下发中',
  '同意': '同意',
  '驳回': '驳回',
  '步骤': '步骤',
  '意见': '意见',
  '请正确填写目标端口,目标端口数值要满足1~65535 !': '请正确填写目标端口,目标端口数值要满足1~65535 !',
  '防火墙FW 操作指南': '防火墙FW 操作指南',
  '防火墙策略': '防火墙策略',
  '审批单号': '审批单号',
  '修改时间': '修改时间',
  '验证': '验证',
  '当不选择任何权限时，则会取消以上所选用户对应所选云主机的堡垒机权限': '当不选择任何权限时，则会取消以上所选用户对应所选云主机的堡垒机权限',
  '云主机 不能为空': '云主机 不能为空',
  '设置权限成功！': '设置权限成功！',
  '请先选择用户！': '请先选择用户！',
  '批量授权成功！': '批量授权成功！',
  '用户 不能为空': '用户 不能为空',
  'NUC用户': 'NUC用户',
  '云主机:': '云主机:',
  '设置权限': '设置权限',
  '用户类型': '用户类型',
  '暂无昵称': '暂无昵称',
  '文件上传': '文件上传',
  '批量授权': '批量授权',
  '文件下载': '文件下载',
  '本地用户': '本地用户',
  '用户:': '用户:',
  '状态:': '状态:',
  '权限:': '权限:',
  '已授权': '已授权',
  '未授权': '未授权',
  '昵称': '昵称',
  '您的浏览器不支持websocket协议,建议使用新版谷歌、火狐等浏览器，请勿使用IE10以下浏览器，360浏览器请使用极速模式，不要使用兼容模式！': '您的浏览器不支持websocket协议,建议使用新版谷歌、火狐等浏览器，请勿使用IE10以下浏览器，360浏览器请使用极速模式，不要使用兼容模式！',
  '如果确定修改，当前的页面将被重新加载, 仍要进行修改吗': '如果确定修改，当前的页面将被重新加载, 仍要进行修改吗',
  '为保持数据一致性，页面将进行刷新操作！': '为保持数据一致性，页面将进行刷新操作！',
  '没有可选租户项目': '没有可选租户项目',
  '请输入搜索内容': '请输入搜索内容',
  '管理控制台': '管理控制台',
  '无匹配数据': '无匹配数据',
  '租户列表': '租户列表',
  '访问权限': '访问权限',
  '查看更多': '查看更多',
  '兼容问题': '兼容问题',
  '项目列表': '项目列表',
  '最近项目': '最近项目',
  '消息通知': '消息通知',
  '工单': '工单',
  '预览': '预览',
  '警告': '警告',
  '需上传基本资料：包括主办单位证件、主办单位负责人证件和网站负责人证件。': '需上传基本资料：包括主办单位证件、主办单位负责人证件和网站负责人证件。',
  '要求由三个或三个以上汉字组成，与主办单位名称有关联性': '要求由三个或三个以上汉字组成，与主办单位名称有关联性',
  '请填写正确格式的应急联系人电话!': '请填写正确格式的应急联系人电话!',
  '请填写正确格式的电子邮件地址!': '请填写正确格式的电子邮件地址!',
  '请填写主办单位或主办人名称!': '请填写主办单位或主办人名称!',
  '请填写正确格式的联系方式1!': '请填写正确格式的联系方式1!',
  '请填写正确格式的联系方式2!': '请填写正确格式的联系方式2!',
  '请填写正确格式的网站名称!': '请填写正确格式的网站名称!',
  '请选择主办单位所属区域!': '请选择主办单位所属区域!',
  '请填写主办单位证件号码!': '请填写主办单位证件号码!',
  '请选择主办单位证件类型!': '请选择主办单位证件类型!',
  '请填写主办单位通讯地址!': '请填写主办单位通讯地址!',
  '请填写主办单位证件住所!': '请填写主办单位证件住所!',
  '请填写网站首页URL!': '请填写网站首页URL!',
  '请填写应急联系人电话!': '请填写应急联系人电话!',
  '请填写负责人证件类型!': '请填写负责人证件类型!',
  '请填写负责人证件号码!': '请填写负责人证件号码!',
  '请填写电子邮件地址!': '请填写电子邮件地址!',
  '主办单位或主办人名称': '主办单位或主办人名称',
  '请选择主办单位性质!': '请选择主办单位性质!',
  '请填写负责人姓名!': '请填写负责人姓名!',
  '请填写已验证域名!': '请填写已验证域名!',
  '请填写联系方式1!': '请填写联系方式1!',
  '主办单位证件号码': '主办单位证件号码',
  '主办单位所属区域': '主办单位所属区域',
  '主办单位证件住所': '主办单位证件住所',
  '主办单位通讯地址': '主办单位通讯地址',
  '个人备案无需填写': '个人备案无需填写',
  '请填写网站名称!': '请填写网站名称!',
  '主办单位证件类型': '主办单位证件类型',
  '请填写验证码!': '请填写验证码!',
  '看不清，换一张': '看不清，换一张',
  '已上传资料下载': '已上传资料下载',
  '网站首页URL': '网站首页URL',
  '应急联系人电话': '应急联系人电话',
  '负责人证件号码': '负责人证件号码',
  '负责人证件类型': '负责人证件类型',
  '主办单位性质': '主办单位性质',
  '填写主体信息': '填写主体信息',
  '填写网站信息': '填写网站信息',
  '工商执业执照': '工商执业执照',
  '组织机构代码': '组织机构代码',
  '请填写域名!': '请填写域名!',
  '电子邮件地址': '电子邮件地址',
  '请上传资料!': '请上传资料!',
  '请选择IP!': '请选择IP!',
  '联系方式2': '联系方式2',
  '已验证域名': '已验证域名',
  '负责人姓名': '负责人姓名',
  '联系方式1': '联系方式1',
  '联系方式': '联系方式',
  '资料确认': '资料确认',
  '网站编号': '网站编号',
  '提交备案': '提交备案',
  '网站名称': '网站名称',
  '产品验证': '产品验证',
  '选择IP': '选择IP',
  '信息确认': '信息确认',
  '社会团体': '社会团体',
  '事业单位': '事业单位',
  '产品类型': '产品类型',
  '资料上传': '资料上传',
  '开始备案': '开始备案',
  '详细地址': '详细地址',
  '主体信息': '主体信息',
  '网站信息': '网站信息',
  '验证码': '验证码',
  '其他市': '其他市',
  '区/县': '区/县',
  '企业': '企业',
  '县': '县',
  '区': '区',
  '市': '市',
  '主办单位或主办人全称：': '主办单位或主办人全称：',
  '主办单位所属区域：': '主办单位所属区域：',
  '主办单位证件类型：': '主办单位证件类型：',
  '主办单位证件号码：': '主办单位证件号码：',
  '主办单位证件住所：': '主办单位证件住所：',
  '主办单位通讯地址：': '主办单位通讯地址：',
  '负责人证件号码：': '负责人证件号码：',
  '负责人电子邮箱：': '负责人电子邮箱：',
  '负责人证件类型：': '负责人证件类型：',
  '主办单位性质：': '主办单位性质：',
  '应急联系电话：': '应急联系电话：',
  'ISP备案信息': 'ISP备案信息',
  '电子邮件地址：': '电子邮件地址：',
  '联系方式2：': '联系方式2：',
  '负责人姓名：': '负责人姓名：',
  '联系方式1：': '联系方式1：',
  '网站URL：': '网站URL：',
  '网站名称：': '网站名称：',
  '网站域名：': '网站域名：',
  '证件类型：': '证件类型：',
  '证件号码：': '证件号码：',
  '网站编号：': '网站编号：',
  '备案号：': '备案号：',
  '网站：': '网站：',
  '编辑备案网站信息成功！': '编辑备案网站信息成功！',
  '我的ICP备案信息：': '我的ICP备案信息：',
  '请填写主体备案号！': '请填写主体备案号！',
  '请填写网站备案号！': '请填写网站备案号！',
  'ICP主体备案状态': 'ICP主体备案状态',
  '请先选择备案进度！': '请先选择备案进度！',
  '编辑主体信息成功！': '编辑主体信息成功！',
  '请先选择备案状态！': '请先选择备案状态！',
  '首次提交备案时间': '首次提交备案时间',
  'ICP主体备案号': 'ICP主体备案号',
  '正在备案的订单': '正在备案的订单',
  '成功备案的网站': '成功备案的网站',
  '主办单位名称': '主办单位名称',
  '继续接入备案': '继续接入备案',
  '当前备案进度': '当前备案进度',
  '资料提交管局': '资料提交管局',
  '网站备案号:': '网站备案号:',
  '网站备案号': '网站备案号',
  '主体备案号': '主体备案号',
  '备案进度': '备案进度',
  '管局审核': '管局审核',
  '备案信息': '备案信息',
  '主体备案': '主体备案',
  '首次备案': '首次备案',
  '备案状态': '备案状态',
  '备案完成': '备案完成',
  '备案网站': '备案网站',
  '订单号': '订单号',
  '负责人': '负责人',
  '初审中': '初审中',
  '您的NAS卷未进行同步操作，若需要容灾后续可对新购NAS卷进行同步配置。': '您的NAS卷未进行同步操作，若需要容灾后续可对新购NAS卷进行同步配置。',
  'cifs(Window专用)': 'cifs(Window专用)',
  'nfs(Linux专用)': 'nfs(Linux专用)',
  '请填写NAS名称 !': '请填写NAS名称 !',
  '请填写目标卷名称!': '请填写目标卷名称!',
  '启用NAS同步：': '启用NAS同步：',
  '请选择协议 !': '请选择协议 !',
  '目标NAS存储': '目标NAS存储',
  '配置同步关系': '配置同步关系',
  '源NAS存储': '源NAS存储',
  '目标卷名称': '目标卷名称',
  '请输入名称': '请输入名称',
  'NAS配置': 'NAS配置',
  '可用区：': '可用区：',
  '同步频率': '同步频率',
  '设置大小': '设置大小',
  '15分钟': '15分钟',
  '30分钟': '30分钟',
  '区域：': '区域：',
  '大小': '大小',
  '建议用户新建空NAS卷，如果NAS卷是被使用中，可能会造成还原失败': '建议用户新建空NAS卷，如果NAS卷是被使用中，可能会造成还原失败',
  '删除策略会一同删除备份记录，此操作无法恢复！': '删除策略会一同删除备份记录，此操作无法恢复！',
  '没有可还原的NAS卷，请购买一个新卷': '没有可还原的NAS卷，请购买一个新卷',
  '当前状态下无法禁启用备份策略！': '当前状态下无法禁启用备份策略！',
  '当前状态下无法编辑备份策略！': '当前状态下无法编辑备份策略！',
  '该删除操作仅删除同步关系！': '该删除操作仅删除同步关系！',
  '当前状态下无法执行备份！': '当前状态下无法执行备份！',
  '还原数据指令发送成功 !': '还原数据指令发送成功 !',
  '立即执行请求已发出！': '立即执行请求已发出！',
  '地址已复制至剪切板！': '地址已复制至剪切板！',
  '编辑备份保存成功!': '编辑备份保存成功!',
  '备份时间 不能为空': '备份时间 不能为空',
  '全备日期 不能为空': '全备日期 不能为空',
  '卸载指令已经发出!': '卸载指令已经发出!',
  '挂载指令已经发出!': '挂载指令已经发出!',
  '挂载点格式错误!': '挂载点格式错误!',
  '目标NAS卷:': '目标NAS卷:',
  '任务完成时间:': '任务完成时间:',
  '暂无还原数据!': '暂无还原数据!',
  '备份策略列表': '备份策略列表',
  '备份策略编辑': '备份策略编辑',
  '最新同步时间': '最新同步时间',
  '授权主机列表': '授权主机列表',
  '容量（GB）': '容量（GB）',
  '主机 IP': '主机 IP',
  'NAS详情': 'NAS详情',
  '系统策略名': '系统策略名',
  '暂停成功！': '暂停成功！',
  '激活成功！': '激活成功！',
  '创建时间:': '创建时间:',
  '备份时间:': '备份时间:',
  '全备日期:': '全备日期:',
  '全备时间': '全备时间',
  '还原结果': '还原结果',
  '同步编辑': '同步编辑',
  'NAS卷': 'NAS卷',
  '立即执行': '立即执行',
  '全备日期': '全备日期',
  '扩容失败': '扩容失败',
  '同步关系': '同步关系',
  '访问路径': '访问路径',
  '删除同步': '删除同步',
  '目标卷': '目标卷',
  '同步卷': '同步卷',
  '使用中': '使用中',
  '策略名': '策略名',
  '不可用': '不可用',
  '扩容中': '扩容中',
  '周第': '周第',
  '挂载': '挂载',
  '对齐': '对齐',
  '卸载': '卸载',
  '路径': '路径',
  '小时': '小时',
  '分钟': '分钟',
  '激活': '激活',
  '月第': '月第',
  '模式': '模式',
  '容量': '容量',
  '还原': '还原',
  '半年': '半年',
  '源卷': '源卷',
  '启': '启',
  '天': '天',
  '每': '每',
  '当保留天数为1个月时，备份周期为一周时间，选择1-7代表星期一至星期日的一天做全量备份': '当保留天数为1个月时，备份周期为一周时间，选择1-7代表星期一至星期日的一天做全量备份',
  '当保留天数大于1个月时，备份周期为一个月时间，选择一天代表每月的当天做全量备份': '当保留天数大于1个月时，备份周期为一个月时间，选择一天代表每月的当天做全量备份',
  '温馨提示：NAS源卷扩容的同时，同步的NAS卷会自动扩容。': '温馨提示：NAS源卷扩容的同时，同步的NAS卷会自动扩容。',
  '如月份天数少于所选日期，平台将自动判断为最后一天': '如月份天数少于所选日期，平台将自动判断为最后一天',
  '如无特殊说明，周期中的其他天为增量备份': '如无特殊说明，周期中的其他天为增量备份',
  '文件存储NAS 操作指南': '文件存储NAS 操作指南',
  '协议为空，无法授权主机！': '协议为空，无法授权主机！',
  '暂不支持备份还原服务': '暂不支持备份还原服务',
  '没有可绑定的主机！': '没有可绑定的主机！',
  '请先完成所有选择！': '请先完成所有选择！',
  '保留天数 不能为空': '保留天数 不能为空',
  '扩容数据未改变 !': '扩容数据未改变 !',
  '没有可解绑主机！': '没有可解绑主机！',
  '解除授权成功！': '解除授权成功！',
  '大小(GB)：': '大小(GB)：',
  '新增授权成功！': '新增授权成功！',
  '立即备份成功！': '立即备份成功！',
  '计划备份成功！': '计划备份成功！',
  '扩容成功 !': '扩容成功 !',
  'NAS卷用途': 'NAS卷用途',
  '已授权主机': '已授权主机',
  '保留天数:': '保留天数:',
  'NAS同步': 'NAS同步',
  '选择云主机': '选择云主机',
  '计划备份': '计划备份',
  '所属区域': '所属区域',
  '扩容--': '扩容--',
  '授权主机': '授权主机',
  '保留天数': '保留天数',
  '解除授权': '解除授权',
  '挂载点': '挂载点',
  '卷名称': '卷名称',
  '读写': '读写',
  '权限': '权限',
  '扩容': '扩容',
  '请选择或新建目标NAS卷！': '请选择或新建目标NAS卷！',
  '请填写目标NAS卷名称！': '请填写目标NAS卷名称！',
  '源NAS名称:': '源NAS名称:',
  '目标NAS卷': '目标NAS卷',
  '购买成功！': '购买成功！',
  '同步配置': '同步配置',
  '租户：': '租户：',
  '项目：': '项目：',
  '区域:': '区域:',
  '当日22:00前申请的SNAT和DNAT，当日22:00开始下发；22:00之后申请的则需等到次日22:00开始下发！': '当日22:00前申请的SNAT和DNAT，当日22:00开始下发；22:00之后申请的则需等到次日22:00开始下发！',
  'SNAT（云主机IP）': 'SNAT（云主机IP）',
  'DNAT（内网IP）': 'DNAT（内网IP）',
  'NAT网关 操作指南': 'NAT网关 操作指南',
  '硬终端和软终端数量只能填大于等于0整数，请先修改第': '硬终端和软终端数量只能填大于等于0整数，请先修改第',
  '时长仅允许输入大于0整数或者1位小数，请先修改第': '时长仅允许输入大于0整数或者1位小数，请先修改第',
  '请输入大于0整数或者1位小数，单位：小时': '请输入大于0整数或者1位小数，单位：小时',
  '请输入大于等于0整数，单位：个': '请输入大于等于0整数，单位：个',
  '请输入2016-02-03': '请输入2016-02-03',
  '请先完成所有添加的配置': '请先完成所有添加的配置',
  '请先完成已添加的配置': '请先完成已添加的配置',
  '请输入60个以内字符': '请输入60个以内字符',
  '请先配置产品类型': '请先配置产品类型',
  '请先配置产品类型/租户/项目!':'请先配置产品类型/租户/项目!',
  '办公服务配置中心': '办公服务配置中心',
  '请输入使用时长': '请输入使用时长',
  '请输入一级部门': '请输入一级部门',
  '请输入使用者': '请输入使用者',
  '请输入订单号': '请输入订单号',
  '各项配置如下': '各项配置如下',
  '实际结束时间': '实际结束时间',
  '获取服务类型': '获取服务类型',
  '您一共购买了': '您一共购买了',
  '实际开始时间': '实际开始时间',
  '请输入昵称': '请输入昵称',
  '软终端数量': '软终端数量',
  '请输入部门': '请输入部门',
  '硬终端数量': '硬终端数量',
  '请查看配置': '请查看配置',
  '请输入公司': '请输入公司',
  '请先完成第': '请先完成第',
  '配置服务': '配置服务',
  '删除配置': '删除配置',
  '购买详情': '购买详情',
  '会议名称': '会议名称',
  '再买一个': '再买一个',
  '使用时长': '使用时长',
  '组的配置': '组的配置',
  '一级部门': '一级部门',
  '使用者': '使用者',
  '份服务': '份服务',
  '项目!': '项目!',
  '时长': '时长',
  '公司': '公司',
  '部门': '部门',
  '办公服务管理': '办公服务管理',
  '云视讯服务': '云视讯服务',
  '会议发起人': '会议发起人',
  '受益人公司': '受益人公司',
  '预约方数': '预约方数',
  '申请时间': '申请时间',
  '可用性运维服务-优先级': '可用性运维服务-优先级',
  '数据处理服务-类型': '数据处理服务-类型',
  '运营服务配置中心': '运营服务配置中心',
  '非关键应用': '非关键应用',
  '关键应用': '关键应用',
  '普通应用': '普通应用',
  '可用性运维服务': '可用性运维服务',
  '运营服务管理': '运营服务管理',
  '请先正确填写手机号码！': '请先正确填写手机号码！',
  '请先填写您的手机号码！': '请先填写您的手机号码！',
  '请填写正确的邮箱地址！': '请填写正确的邮箱地址！',
  '请先填写反馈内容！': '请先填写反馈内容！',
  '请先填写您的邮箱！': '请先填写您的邮箱！',
  '请先填写您的姓名！': '请先填写您的姓名！',
  '请输入您的手机号码': '请输入您的手机号码',
  '请输入您的邮箱地址': '请输入您的邮箱地址',
  '请先填写验证码！': '请先填写验证码！',
  '提交反馈成功！': '提交反馈成功！',
  '请输入您的姓名': '请输入您的姓名',
  '请填写反馈内容': '请填写反馈内容',
  '是否处理完成:': '是否处理完成:',
  '图片或附件信息': '图片或附件信息',
  '提交评价成功！': '提交评价成功！',
  '请输入验证码': '请输入验证码',
  '选择反馈时间': '选择反馈时间',
  '反馈内容:': '反馈内容:',
  '您的手机': '您的手机',
  '建议内容': '建议内容',
  '提交建议': '提交建议',
  '反馈详情': '反馈详情',
  '反馈内容': '反馈内容',
  '反馈类型': '反馈类型',
  '反馈状态': '反馈状态',
  '查看回复': '查看回复',
  '您的姓名': '您的姓名',
  '产品建议': '产品建议',
  '您的邮箱': '您的邮箱',
  '反馈投诉': '反馈投诉',
  '反馈时间': '反馈时间',
  '上传图片': '上传图片',
  '已提交': '已提交',
  '已回复': '已回复',
  '已关闭': '已关闭',
  '姓名': '姓名',
  '确认': '确认',
  '评价': '评价',
  '手机': '手机',
  '目标恢复路径': '目标恢复路径',
  '是否重写目录': '是否重写目录',
  '是否为FTP': '是否为FTP',
  '容量(GB)': '容量(GB)',
  '交换区大小': '交换区大小',
  'GPU计算': 'GPU计算',
  '无优惠活动': '无优惠活动',
  '目标库ID': '目标库ID',
  'EIP端口': 'EIP端口',
  '互联网IP': '互联网IP',
  '目标系统名': '目标系统名',
  '恢复时间点': '恢复时间点',
  '云硬盘ID': '云硬盘ID',
  '订单进度': '订单进度',
  '订单详情': '订单详情',
  '订单概要': '订单概要',
  '付费方式': '付费方式',
  '购买时间': '购买时间',
  '优惠活动': '优惠活动',
  '购买类型': '购买类型',
  'GPU卡': 'GPU卡',
  '快照大小': '快照大小',
  '磁盘大小': '磁盘大小',
  '硬盘大小': '硬盘大小',
  '子网ID': '子网ID',
  '镜像名称': '镜像名称',
  '镜像格式': '镜像格式',
  '周期备份': '周期备份',
  '单次备份': '单次备份',
  '固定带宽': '固定带宽',
  '系统名称': '系统名称',
  '10分钟': '10分钟',
  '24小时': '24小时',
  '12个月': '12个月',
  '源桶ID': '源桶ID',
  '同步桶名': '同步桶名',
  '备份桶名': '备份桶名',
  '源库ID': '源库ID',
  '计划类型': '计划类型',
  '内网IP': '内网IP',
  '目标库名': '目标库名',
  '发起人': '发起人',
  '折扣价': '折扣价',
  '30天': '30天',
  '进行中': '进行中',
  '完成': '完成',
  '原价': '原价',
  '新购': '新购',
  '升级': '升级',
  '降级': '降级',
  '单位': '单位',
  '记录': '记录',
  '天数': '天数',
  '插槽': '插槽',
  '3天': '3天',
  '每天': '每天',
  '频率': '频率',
  '时间': '时间',
  '规格': '规格',
  '选择开始时间': '选择开始时间',
  '选择结束时间': '选择结束时间',
  'OSS 自动将用户的数据以冗余的方式存储在同一区域（Region）的 1个可用区（Zone）中。提供机房级容灾能力。': 'OSS 自动将用户的数据以冗余的方式存储在同一区域（Region）的 1个可用区（Zone）中。提供机房级容灾能力。',
  '区域可用区容量包不足，存储桶冗余容灾能力关闭。需要提供容灾能力，请': '区域可用区容量包不足，存储桶冗余容灾能力关闭。需要提供容灾能力，请',
  '对象存储购买请求已发送成功 !': '对象存储购买请求已发送成功 !',
  '您所需区域下没有对象存储容量包': '您所需区域下没有对象存储容量包',
  '在您进行对象存储桶购买前先': '在您进行对象存储桶购买前先',
  'OSS对象存储新增': 'OSS对象存储新增',
  '对象容量存储包': '对象容量存储包',
  '同城容灾存储': '同城容灾存储',
  '存储类型': '存储类型',
  '集群': '集群',
  '提交': '提交',
  '一个 Bucket 可以支持多个 Referer 参数，最多10个参数。设置时使用回车作为换行符分隔。': '一个 Bucket 可以支持多个 Referer 参数，最多10个参数。设置时使用回车作为换行符分隔。',
  '提示信息：如果存储桶非空(已存在数据)，删除会失败，强制删除则可以强行删除存储桶及其数据': '提示信息：如果存储桶非空(已存在数据)，删除会失败，强制删除则可以强行删除存储桶及其数据',
  '允许空referer': '允许空referer',
  '最多10个参数!': '最多10个参数!',
  '对象存储桶管理': '对象存储桶管理',
  '对象存储存储桶': '对象存储存储桶',
  '配置成功 !': '配置成功 !',
  '强制删除：': '强制删除：',
  '存储桶名称': '存储桶名称',
  '对象容量包': '对象容量包',
  'OSS密钥': 'OSS密钥',
  '配置防盗链': '配置防盗链',
  '通用型': '通用型',
  '归档型': '归档型',
  '性能型': '性能型',
  '白名单': '白名单',
  '黑名单': '黑名单',
  '桶名称': '桶名称',
  '备份': '备份',
  '拒绝': '拒绝',
  '同步': '同步',
  'SecretKey仅在首次申请时提供': 'SecretKey仅在首次申请时提供',
  '集群 不能为空': '集群 不能为空',
  '区域 不能为空': '区域 不能为空',
  '请妥善保存使用': '请妥善保存使用',
  'n可用区：': 'n可用区：',
  'n集群：': 'n集群：',
  'n项目:': 'n项目:',
  '租户:': '租户:',
  '集群:': '集群:',
  'OSS Packages请求已发送成功 !': 'OSS Packages请求已发送成功 !',
  '名称须2-60个字符 !': '名称须2-60个字符 !',
  '请选择有效的集群信息 !': '请选择有效的集群信息 !',
  'OSS存储容量包购买': 'OSS存储容量包购买',
  '请填写名称信息 !': '请填写名称信息 !',
  '对象存储容量包': '对象存储容量包',
  '存储桶信息': '存储桶信息',
  'OSS自动将用户的数据以冗余的方式存储在同一区域(Region)的 1个可用区(Zone)中。提供机房级容灾能力。': 'OSS自动将用户的数据以冗余的方式存储在同一区域(Region)的 1个可用区(Zone)中。提供机房级容灾能力。',
  'OSS 存储桶创建请求已发送成功 !': 'OSS 存储桶创建请求已发送成功 !',
  '请先清除该容量包下的所有存储桶！': '请先清除该容量包下的所有存储桶！',
  '必填,最长32字符': '必填,最长32字符',
  '对象存储容量包扩容': '对象存储容量包扩容',
  '剩余容量(GB)': '剩余容量(GB)',
  '扩容(GB):': '扩容(GB):',
  '总容量(GB)': '总容量(GB)',
  '同城容灾存储:': '同城容灾存储:',
  '存储类型:': '存储类型:',
  '新建存储桶': '新建存储桶',
  '存储桶数': '存储桶数',
  '建桶': '建桶',
  '授权模板详情': '授权模板详情',
  '排除项目:': '排除项目:',
  '策略组:': '策略组:',
  '授权模板': '授权模板',
  '用户列表': '用户列表',
  '新增用户': '新增用户',
  '策略列表': '策略列表',
  '新增策略': '新增策略',
  '新增租户': '新增租户',
  '新增项目': '新增项目',
  '修改授权': '修改授权',
  '项目:': '项目:',
  '用户移除成功!': '用户移除成功!',
  '策略新增成功！': '策略新增成功！',
  '策略移除成功！': '策略移除成功！',
  '用户关联成功': '用户关联成功',
  '用户不能为空': '用户不能为空',
  '项目不能为空': '项目不能为空',
  '租户不能为空': '租户不能为空',
  '输入搜索条件': '输入搜索条件',
  '关联用户:': '关联用户:',
  '排除租户:': '排除租户:',
  '关联策略项': '关联策略项',
  '策略管理': '策略管理',
  '添加策略': '添加策略',
  '分组类型': '分组类型',
  '取消策略': '取消策略',
  '策略项': '策略项',
  '范围': '范围',
  '资源': '资源',
  'ID': 'ID',
  '策略名称长度须2-60个字符': '策略名称长度须2-60个字符',
  '策略修改成功！': '策略修改成功！',
  '名称不能为空': '名称不能为空',
  '账单总览生成预计需要1-5min,请耐心等待': '账单总览生成预计需要1-5min,请耐心等待',
  '-日度账单明细': '-日度账单明细',
  '-月度账单明细': '-月度账单明细',
  '下载账单明细': '下载账单明细',
  '账单生成中': '账单生成中',
  '账单周期': '账单周期',
  '订单ID': '订单ID',
  '产品ID': '产品ID',
  '账单月份': '账单月份',
  '包年包月': '包年包月',
  '账单明细': '账单明细',
  '账单日期': '账单日期',
  '点击': '点击',
  '选择': '选择',
  '月份': '月份',
  '下载': '下载',
  '请': '请',
  '年': '年',
  '账单总览生成预计需要20-60s,请耐心等待': '账单总览生成预计需要20-60s,请耐心等待',
  '下载账单概览': '下载账单概览',
  '折扣价(元)': '折扣价(元)',
  '月账单汇总': '月账单汇总',
  '按产品汇总': '按产品汇总',
  '按区域汇总': '按区域汇总',
  '按扣费周期': '按扣费周期',
  '代金券支付': '代金券支付',
  '原价(元)': '原价(元)',
  '可用区名称': '可用区名称',
  '-账单总览': '-账单总览',
  '赠送金支付': '赠送金支付',
  '账单概览': '账单概览',
  '统计周期': '统计周期',
  '现金支付': '现金支付',
  '产品名称': '产品名称',
  '访问来源': '访问来源',
  '共': '共',
  '磁盘配额修改成功 !': '磁盘配额修改成功 !',
  '2-60字符': '2-60字符',
  '中文名': '中文名',
  '配额': '配额',
  '云主机快照大小(MB)：': '云主机快照大小(MB)：',
  '单磁盘上限(GB)：': '单磁盘上限(GB)：',
  '项目配额修改成功 !': '项目配额修改成功 !',
  '磁盘大小(GB)：': '磁盘大小(GB)：',
  '硬盘大小(GB)：': '硬盘大小(GB)：',
  '可修改最大配额：': '可修改最大配额：',
  '云主机快照数量：': '云主机快照数量：',
  '内存(GB)：': '内存(GB)：',
  '当前配额：': '当前配额：',
  '修改配额：': '修改配额：',
  '实例数量：': '实例数量：',
  '磁盘数量：': '磁盘数量：',
  '项目信息': '项目信息',
  '配额信息': '配额信息',
  '修改配额': '修改配额',
  '线程数：': '线程数：',
  '已使用：': '已使用：',
  '确认修改': '确认修改',
  '项目配额': '项目配额',
  '项目备注': '项目备注',
  '天数仅允许输入大于0整数或者1位小数，请先修改第': '天数仅允许输入大于0整数或者1位小数，请先修改第',
  '请输入大于0整数或者1位小数': '请输入大于0整数或者1位小数',
  '安全服务配置中心': '安全服务配置中心',
  '安全服务管理': '安全服务管理',
  '网络安全': '网络安全',
  '请填写一级服务目录！': '请填写一级服务目录！',
  '请填写二级服务目录第': '请填写二级服务目录第',
  '新增服务目录成功！': '新增服务目录成功！',
  '添加二级服务项目': '添加二级服务项目',
  '新增一级服务目录': '新增一级服务目录',
  '一级服务目录': '一级服务目录',
  '二级服务目录': '二级服务目录',
  '条信息！': '条信息！',
  '请输入': '请输入',
  '确 定': '确 定',
  '取 消': '取 消',
  '二级目录下无三级目录后才可以删除!': '二级目录下无三级目录后才可以删除!',
  '编辑二级服务目录成功！': '编辑二级服务目录成功！',
  '二级服务目录删除成功!': '二级服务目录删除成功!',
  '新增二级服务目录成功！': '新增二级服务目录成功！',
  '二级服务目录名称': '二级服务目录名称',
  '新增二级服务': '新增二级服务',
  '研发服务': '研发服务',
  '二级服务': '二级服务',
  '返回': '返回',
  '删除服务目录已提交OA审批！': '删除服务目录已提交OA审批！',
  '是否在年初公允定价范围内': '是否在年初公允定价范围内',
  '待审批状态不允许编辑！': '待审批状态不允许编辑！',
  '待审批状态不允许删除！': '待审批状态不允许删除！',
  '目录Owner': '目录Owner',
  '推荐使用环境': '推荐使用环境',
  '服务拆分类型': '服务拆分类型',
  '服务介绍:': '服务介绍:',
  '目录负责人': '目录负责人',
  '服务级别': '服务级别',
  '服务时间': '服务时间',
  '响应时间': '响应时间',
  '解决时间': '解决时间',
  '服务定价': '服务定价',
  '收费方式': '收费方式',
  '收费对象': '收费对象',
  '计算方法': '计算方法',
  '备注说明': '备注说明',
  '服务详情': '服务详情',
  '新增服务': '新增服务',
  '修改服务': '修改服务',
  '删除服务': '删除服务',
  '有效年份': '有效年份',
  '目录类型': '目录类型',
  '单价': '单价',
  '含税': '含税',
  '税率': '税率',
  '温馨提示：提交服务目录变更操作，系统将自动发起OA审批。': '温馨提示：提交服务目录变更操作，系统将自动发起OA审批。',
  '服务目录生成预计需要20-60s,请耐心等待！': '服务目录生成预计需要20-60s,请耐心等待！',
  '请点击选择年份下载服务目录': '请点击选择年份下载服务目录',
  '点击选择年份搜索': '点击选择年份搜索',
  '二级级服务目录': '二级级服务目录',
  '日期不能为空！': '日期不能为空！',
  '服务目录生成中': '服务目录生成中',
  '单价(含税)': '单价(含税)',
  '三级服务目录': '三级服务目录',
  '新增三级服务': '新增三级服务',
  '-服务目录': '-服务目录',
  '审批状态': '审批状态',
  '审批通过': '审批通过',
  '审批驳回': '审批驳回',
  '发起失败': '发起失败',
  '日期:': '日期:',
  '待审批': '待审批',
  '一级服务目录名称': '一级服务目录名称',
  '二级服务目录数': '二级服务目录数',
  '新增一级服务': '新增一级服务',
  '工作时间：5*7（上午9:00-12:00，下午13:30-17:30）': '工作时间：5*7（上午9:00-12:00，下午13:30-17:30）',
  '备注：服务时间指人员服务时间，若为7*24小时，则需有人值班': '备注：服务时间指人员服务时间，若为7*24小时，则需有人值班',
  '7*24小时（周一至周日 00:00 - 24:00）': '7*24小时（周一至周日 00:00 - 24:00）',
  '点击【确定】后，系统将自动发起OA审批': '点击【确定】后，系统将自动发起OA审批',
  '请上传上会材料及会议纪要等相关材料': '请上传上会材料及会议纪要等相关材料',
  '推荐使用环境长度限1000！': '推荐使用环境长度限1000！',
  '三级服务目录限50个汉字！': '三级服务目录限50个汉字！',
  '服务介绍长度限1000！': '服务介绍长度限1000！',
  '服务时间长度限1000！': '服务时间长度限1000！',
  '响应时间长度限1000！': '响应时间长度限1000！',
  '解决时间长度限1000！': '解决时间长度限1000！',
  '收费方式长度限1000！': '收费方式长度限1000！',
  '计算方法长度限1000！': '计算方法长度限1000！',
  '备注说明长度限1000！': '备注说明长度限1000！',
  '服务目录已提交OA审批！': '服务目录已提交OA审批！',
  '请填写目录Owner！': '请填写目录Owner！',
  '请先填写目录负责人第': '请先填写目录负责人第',
  '请选择一级服务目录！': '请选择一级服务目录！',
  '请选择二级服务目录！': '请选择二级服务目录！',
  '请选择服务拆分类型！': '请选择服务拆分类型！',
  '单价长度限1000！': '单价长度限1000！',
  '单位长度限1000！': '单位长度限1000！',
  '请填写三级服务目录！': '请填写三级服务目录！',
  '非工作时间：不适用': '非工作时间：不适用',
  '请选择有效年份！': '请选择有效年份！',
  '请选择目录类型！': '请选择目录类型！',
  '请选择有效年份': '请选择有效年份',
  '请输入所属中心': '请输入所属中心',
  '请先上传附件！': '请先上传附件！',
  '编辑三级服务': '编辑三级服务',
  '请填写单价！': '请填写单价！',
  '请填写单位！': '请填写单位！',
  '服务介绍': '服务介绍',
  '上传附件': '上传附件',
  '采购分摊': '采购分摊',
  '受益人': '受益人',
  '按人力': '按人力',
  '按量': '按量',
  '条！': '条！',
  '消息发布时间': '消息发布时间',
  '标题内容': '标题内容',
  '消息类型': '消息类型',
  '消息时间': '消息时间',
  '预览-': '预览-',
  '链接为临时预览公告链接，非正式链接。该链接3日有效!': '链接为临时预览公告链接，非正式链接。该链接3日有效!',
  '消息详情': '消息详情',
  '消息订阅修改成功！': '消息订阅修改成功！',
  '批量已读成功！': '批量已读成功！',
  '全部已读成功！': '全部已读成功！',
  '批量已读': '批量已读',
  '全部已读': '全部已读',
  'IP协议版本': 'IP协议版本',
  '已用IP数': '已用IP数',
  '总IP数': '总IP数',
  '子网详情': '子网详情',
  '子网id': '子网id',
  '网关': '网关',
  '请输入标签键进行查询，多个标签键以英文逗号隔开': '请输入标签键进行查询，多个标签键以英文逗号隔开',
  '标签键': '标签键',
  '标签值': '标签值',
  '更改人': '更改人',
  '账单生成预计需要1-5min,请耐心等待': '账单生成预计需要1-5min,请耐心等待',
  '按项目汇总': '按项目汇总',
  '请选择VPC、子网信息 !': '请选择VPC、子网信息 !',
  '请先选择可用区！': '请先选择可用区！',
  '请先选择子网！': '请先选择子网！',
  'VIP购买': 'VIP购买',
  'VIP详情': 'VIP详情',
  '所属子网': '所属子网',
  '端口id': '端口id',
  'subnet_id为NULL,暂不能进行绑定': 'subnet_id为NULL,暂不能进行绑定',
  '没有同网段可绑定的主机！': '没有同网段可绑定的主机！',
  '没有已绑定的主机！': '没有已绑定的主机！',
  'VIP 操作指南': 'VIP 操作指南',
  '请选择实例IP': '请选择实例IP',
  '子网CIDR': '子网CIDR',
  '绑定成功！': '绑定成功！',
  '解绑成功！': '解绑成功！',
  '确定释放该': '确定释放该',
  'VIP解绑': 'VIP解绑',
  '释放成功！': '释放成功！',
  'VIP绑定': 'VIP绑定',
  '子网网关': '子网网关',
  '申请': '申请',
  '防火墙节点需至少连接一个目标节点！': '防火墙节点需至少连接一个目标节点！',
  '创建资源栈请求已发送，请稍后查看！': '创建资源栈请求已发送，请稍后查看！',
  '编辑模板资源参数配置将会重置！': '编辑模板资源参数配置将会重置！',
  '相同的连个节点只能连一条线！': '相同的连个节点只能连一条线！',
  '防火墙节点需连接一个源节点！': '防火墙节点需连接一个源节点！',
  '防火墙节点只能连入一个源！': '防火墙节点只能连入一个源！',
  '连线节点至少连接两个节点': '连线节点至少连接两个节点',
  '请先绘制画布！': '请先绘制画布！',
  '模板创建成功！': '模板创建成功！',
  '模板编辑成功！': '模板编辑成功！',
  '是否编辑模板！': '是否编辑模板！',
  '编辑资源参数': '编辑资源参数',
  '创建资源栈': '创建资源栈',
  '清空资源': '清空资源',
  '创建模板': '创建模板',
  '创建一个新云硬盘时，您可以选择一个已有的云硬盘或快照进行数据的复制，': '创建一个新云硬盘时，您可以选择一个已有的云硬盘或快照进行数据的复制，',
  '如果希望创建一个全新的云硬盘则无需选择此项': '如果希望创建一个全新的云硬盘则无需选择此项',
  '云硬盘购买请求已发送成功 !': '云硬盘购买请求已发送成功 !',
  '请填写全部参数 !': '请填写全部参数 !',
  '请填写名称 !': '请填写名称 !',
  '云硬盘购买': '云硬盘购买',
  '复制源类型': '复制源类型',
  '列表': '列表',
  '云硬盘快照列表': '云硬盘快照列表',
  '云硬盘快照ID': '云硬盘快照ID',
  '复制源类型ID': '复制源类型ID',
  '挂载主机IP': '挂载主机IP',
  '云硬盘详情': '云硬盘详情',
  '挂载主机名': '挂载主机名',
  '是否启动盘': '是否启动盘',
  '操作记录': '操作记录',
  '操作序列': '操作序列',
  '挂载主机': '挂载主机',
  '操作结果': '操作结果',
  '磁盘id': '磁盘id',
  '操作人': '操作人',
  '磁盘已被挂载，不能重复挂载！': '磁盘已被挂载，不能重复挂载！',
  '云硬盘CBS 操作指南': '云硬盘CBS 操作指南',
  '挂载命令已发出 !': '挂载命令已发出 !',
  '云主机列表获取为空': '云主机列表获取为空',
  '请先选择云主机 !': '请先选择云主机 !',
  '名称不能为空 !': '名称不能为空 !',
  '大小(GB):': '大小(GB):',
  '快照链id': '快照链id',
  '挂载路径:': '挂载路径:',
  '文件系统:': '文件系统:',
  '挂载云主机': '挂载云主机',
  '云硬盘名称': '云硬盘名称',
  '快照详情': '快照详情',
  '快照ID': '快照ID',
  '使用快照创建云硬盘将已有的云硬盘或快照进行数据的复制，与原磁盘保持相同的可用区和云硬盘类型。': '使用快照创建云硬盘将已有的云硬盘或快照进行数据的复制，与原磁盘保持相同的可用区和云硬盘类型。',
  '，在此之后的数据将会被清除，请确认数据已进行备份或处理。': '，在此之后的数据将会被清除，请确认数据已进行备份或处理。',
  '云磁盘类型 不能为空': '云磁盘类型 不能为空',
  '请选择云硬盘类型！': '请选择云硬盘类型！',
  '磁盘大小(GB)': '磁盘大小(GB)',
  '硬盘大小(GB)': '硬盘大小(GB)',
  '的数据将回滚到': '的数据将回滚到',
  '请选择云硬盘!': '请选择云硬盘!',
  '云硬盘类型:': '云硬盘类型:',
  '云硬盘描述：': '云硬盘描述：',
  '购买云硬盘': '购买云硬盘',
  '云硬盘创建': '云硬盘创建',
  '关联磁盘：': '关联磁盘：',
  '云硬盘描述': '云硬盘描述',
  '快照名称': '快照名称',
  '磁盘名称': '磁盘名称',
  '源盘名称': '源盘名称',
  '快照：': '快照：',
  '回滚': '回滚',
  '温馨提示：请在云硬盘处理处于【未挂载】状态进行回滚操作。':'温馨提示：请在云硬盘处理处于【未挂载】状态进行回滚操作。',
  '快照链详情': '快照链详情',
  '快照链ID': '快照链ID',
  '永久保留': '永久保留',
  '删除错误': '删除错误',
  '快照类型': '快照类型',
  '快照数量': '快照数量',
  '回滚中': '回滚中',
  '系统盘': '系统盘',
  '未挂载': '未挂载',
  '磁盘容量(GB)': '磁盘容量(GB)',
  '硬盘容量(GB)': '硬盘容量(GB)',
  '快照容量(GB)': '快照容量(GB)',
  'VPC子网列表': 'VPC子网列表',
  'VPC详情': 'VPC详情',
  '专有网络VPC 操作指南': '专有网络VPC 操作指南',
  '子网列表': '子网列表',
  '工单标题长度小于32位！': '工单标题长度小于32位！',
  '选择问题所属产品与服务': '选择问题所属产品与服务',
  '联系人长度小于8位！': '联系人长度小于8位！',
  '请填写正确手机格式！': '请填写正确手机格式！',
  '请填写正确邮箱格式！': '请填写正确邮箱格式！',
  '期待您的反馈及评价': '期待您的反馈及评价',
  '请填写手机号码！': '请填写手机号码！',
  '请输入工单流水号': '请输入工单流水号',
  '请填写问题描述！': '请填写问题描述！',
  '请选择联系时间！': '请选择联系时间！',
  '请填写解决信息！': '请填写解决信息！',
  '请填写工单标题！': '请填写工单标题！',
  '提交工单成功！': '提交工单成功！',
  '相关产品与服务': '相关产品与服务',
  '请填写联系人！': '请填写联系人！',
  '默认为北京时间': '默认为北京时间',
  '请输入工单编号': '请输入工单编号',
  '请选择问题类型': '请选择问题类型',
  '问题是否解决:': '问题是否解决:',
  '请选择评分！': '请选择评分！',
  '云产品和服务': '云产品和服务',
  '超过最大容量': '超过最大容量',
  '选择问题类型': '选择问题类型',
  '填写工单信息': '填写工单信息',
  '用户联系方式': '用户联系方式',
  '请选择紧急！': '请选择紧急！',
  '反馈完成！': '反馈完成！',
  '评论成功！': '评论成功！',
  '产品和服务': '产品和服务',
  '整体评价:': '整体评价:',
  '反馈建议:': '反馈建议:',
  '请填写: ': '请填写: ',
  '工单编号': '工单编号',
  '工单状态': '工单状态',
  '问题描述': '问题描述',
  '创建工单': '创建工单',
  '任何时间': '任何时间',
  '是否紧急': '是否紧急',
  '业务功能': '业务功能',
  '联系时间': '联系时间',
  '反馈评价': '反馈评价',
  '手机号码': '手机号码',
  '提交时间': '提交时间',
  '留言信息': '留言信息',
  '提交用户': '提交用户',
  '工单标题': '工单标题',
  '工单详情': '工单详情',
  '处理中': '处理中',
  '提交人': '提交人',
  '近两天': '近两天',
  '近一天': '近一天',
  '留言:': '留言:',
  '联系人': '联系人',
  '未解决': '未解决',
  '已解决': '已解决',
  '待确认': '待确认',
  '评论': '评论',
  '提单': '提单',
  '每日': '每日',
  '从不': '从不',
  '策略管理详情': '策略管理详情',
  '策略组管理详情': '策略组管理详情',
  '授权用户列表': '授权用户列表',
  '策略组名称': '策略组名称',
  '策略组ID': '策略组ID',
  '资源IP，仅支持精确搜索': '资源IP，仅支持精确搜索',
  '资源ID': '资源ID',
  '资源类型': '资源类型',
  '日志管理': '日志管理',
  '请提供证件的原件照片或者扫描件（正副本均可），文字/盖章清晰可辩认格式要求jpg、jpeg、png，不超过2MB': '请提供证件的原件照片或者扫描件（正副本均可），文字/盖章清晰可辩认格式要求jpg、jpeg、png，不超过2MB',
  '您可以通过客服热线0755-88236666或邮箱cloud@cmft.com申请更新您的手机号。': '您可以通过客服热线0755-88236666或邮箱cloud@cmft.com申请更新您的手机号。',
  '只能包含特殊字符：!@#$%^&*()_+-=;': '只能包含特殊字符：!@#$%^&*()_+-=;',
  '认证材料审核预计3-5个工作日，请您耐心等待': '认证材料审核预计3-5个工作日，请您耐心等待',
  '为了完整体验平台产品，请先完成企业实名认证': '为了完整体验平台产品，请先完成企业实名认证',
  '您未通过认证审核，请修改资料后重新提交': '您未通过认证审核，请修改资料后重新提交',
  '大小写字母、数字、特殊字符包含四种;': '大小写字母、数字、特殊字符包含四种;',
  '手机号更新一般1-2个工作日内生效。': '手机号更新一般1-2个工作日内生效。',
  '恭喜您已完成招商云企业实名认证': '恭喜您已完成招商云企业实名认证',
  '营业执照注册号位：1-18位!': '营业执照注册号位：1-18位!',
  '密码长度须8-21个字符 !': '密码长度须8-21个字符 !',
  '请务必与营业执照的注册号一致': '请务必与营业执照的注册号一致',
  '该手机号码无效，请重新输入': '该手机号码无效，请重新输入',
  '未验证,点击去验证手机号码': '未验证,点击去验证手机号码',
  '本人操作，请完成以下验证': '本人操作，请完成以下验证',
  '若您的主账号手机号不可用': '若您的主账号手机号不可用',
  '请输入正确的邮箱地址!': '请输入正确的邮箱地址!',
  '请输入正确的身份证号!': '请输入正确的身份证号!',
  '请输入正确的手机号码!': '请输入正确的手机号码!',
  '手机不可用，点击解决。': '手机不可用，点击解决。',
  '企业名称与营业执照一致': '企业名称与营业执照一致',
  '如需修改，请填写新密码': '如需修改，请填写新密码',
  '增加企业认证信息 >': '增加企业认证信息 >',
  '注册营业执照扫描件：': '注册营业执照扫描件：',
  '请先获取短信验证码！': '请先获取短信验证码！',
  '该图片超过了2MB!': '该图片超过了2MB!',
  '请输入正确的邮箱地址': '请输入正确的邮箱地址',
  '修改手机号码成功!': '修改手机号码成功!',
  '招商云隐私政策声明': '招商云隐私政策声明',
  '管理员身份证号码:': '管理员身份证号码:',
  '请先输入图片验证码': '请先输入图片验证码',
  '请先完成所有配置!': '请先完成所有配置!',
  '管理员身份证姓名:': '管理员身份证姓名:',
  '邮箱格式不正确 !': '邮箱格式不正确 !',
  '请先输入短信验证码': '请先输入短信验证码',
  '两次输入密码不一致': '两次输入密码不一致',
  '请勾选同意协议内容': '请勾选同意协议内容',
  '增加企业认证信息': '增加企业认证信息',
  '营业执照注册号：': '营业执照注册号：',
  '管理员手机号码:': '管理员手机号码:',
  '填写管理员邮箱:': '填写管理员邮箱:',
  '请输入正确的手机': '请输入正确的手机',
  '管理员身份证号码': '管理员身份证号码',
  '中国香港+852': '中国香港+852',
  '营业执照扫描件：': '营业执照扫描件：',
  '8-32位字符;': '8-32位字符;',
  '12-32位字符;': '12-32位字符;',
  '注册营业执照号：': '注册营业执照号：',
  '完成企业实名认证': '完成企业实名认证',
  '请输入短信验证码': '请输入短信验证码',
  '请输入图片验证码': '请输入图片验证码',
  '查看企业认证信息': '查看企业认证信息',
  '使用已有账号登录': '使用已有账号登录',
  '输入有效手机号码': '输入有效手机号码',
  '图片格式不正确！': '图片格式不正确！',
  '输入图片验证码': '输入图片验证码',
  '请输入行业范畴': '请输入行业范畴',
  '同意协议并注册': '同意协议并注册',
  '企业管理员信息': '企业管理员信息',
  '企业通讯地址:': '企业通讯地址:',
  '企业通讯地址：': '企业通讯地址：',
  '获取短信验证码': '获取短信验证码',
  '输入短信验证码': '输入短信验证码',
  '中国大陆+86': '中国大陆+86',
  '企业认证信息:': '企业认证信息:',
  '欢迎注册招商云': '欢迎注册招商云',
  '为确认是账户': '为确认是账户',
  '新手机号码:': '新手机号码:',
  '旧手机号码:': '旧手机号码:',
  '重新提交材料': '重新提交材料',
  '图片验证码:': '图片验证码:',
  '身份证号码：': '身份证号码：',
  '短信验证码:': '短信验证码:',
  '身份证姓名：': '身份证姓名：',
  '填写企业信息': '填写企业信息',
  '确认企业信息': '确认企业信息',
  '企业认证信息': '企业认证信息',
  '用户信息编辑': '用户信息编辑',
  '修改手机号码': '修改手机号码',
  '绑定手机号码': '绑定手机号码',
  '手机号码：': '手机号码：',
  '行业信息：': '行业信息：',
  '管理员邮箱': '管理员邮箱',
  '确认密码:': '确认密码:',
  '企业名称:': '企业名称:',
  '所在行业:': '所在行业:',
  '请输入账号': '请输入账号',
  '请选择企业': '请选择企业',
  '请输入手机': '请输入手机',
  '绑定新手机': '绑定新手机',
  '请输入邮箱': '请输入邮箱',
  '绑定成功!': '绑定成功!',
  '手机号码:': '手机号码:',
  '企业名称：': '企业名称：',
  '重新上传': '重新上传',
  '提交审核': '提交审核',
  '注册成功': '注册成功',
  '提交成功': '提交成功',
  '验证身份': '验证身份',
  '立即绑定': '立即绑定',
  '我已阅读': '我已阅读',
  '密码:': '密码:',
  '手机:': '手机:',
  '邮箱:': '邮箱:',
  '账号:': '账号:',
  '未认证': '未认证',
  '市/区': '市/区',
  '换一张': '换一张',
  '邮箱：': '邮箱：',
  '不通过': '不通过',
  '审核': '审核',
  '首页': '首页',
  '通过': '通过',
  '聚合类型': '聚合类型',
  '时间区间': '时间区间',
  'P95值': 'P95值',
  '刷新中': '刷新中',
  '时间段': '时间段',
  '最小值': '最小值',
  '最大值': '最大值',
  '平均值': '平均值',
  '原始值': '原始值',
  '不能设置如下特殊字母welcome': '不能设置如下特殊字母welcome',
  '数据库（数据库名：权限）': '数据库（数据库名：权限）',
  '账户管理 -- 新增': '账户管理 -- 新增',
  '用户权限重置成功！': '用户权限重置成功！',
  '请先创建数据库': '请先创建数据库',
  '权限修改成功！': '权限修改成功！',
  '数据库名：权限': '数据库名：权限',
  '授权数据库:': '授权数据库:',
  '特殊字符为!': '特殊字符为!',
  '数据库账号:': '数据库账号:',
  '暂无数据库': '暂无数据库',
  '属主用户:': '属主用户:',
  '应用用户:': '应用用户:',
  '所属目标库': '所属目标库',
  '数据库列表': '数据库列表',
  '用户账号:': '用户账号:',
  '部署用户': '部署用户',
  '修改权限': '修改权限',
  '目标库': '目标库',
  '恢复时间点请选择在可恢复时间范围内！': '恢复时间点请选择在可恢复时间范围内！',
  '购买恢复数据库实例': '购买恢复数据库实例',
  '请选择恢复时间点！': '请选择恢复时间点！',
  '创建恢复任务成功！': '创建恢复任务成功！',
  '恢复源数据库实例': '恢复源数据库实例',
  '恢复原数据库实例': '恢复原数据库实例',
  '磁盘大小(G)': '磁盘大小(G)',
  '可恢复时间范围': '可恢复时间范围',
  '恢复的时间点': '恢复的时间点',
  '配置恢复对象': '配置恢复对象',
  '请选择子网！': '请选择子网！',
  '恢复可用区': '恢复可用区',
  '数据库系列': '数据库系列',
  '恢复信息': '恢复信息',
  '数据实例': '数据实例',
  '恢复区域': '恢复区域',
  '还原备份': '还原备份',
  '恢复计划': '恢复计划',
  '请在数据库实例恢删除前进行数据备份操作': '请在数据库实例恢删除前进行数据备份操作',
  '恢复时间点 不能为空': '恢复时间点 不能为空',
  'RDS关系型数据库': 'RDS关系型数据库',
  '重试请求已发送！': '重试请求已发送！',
  '无可恢复时间点！': '无可恢复时间点！',
  '恢复时间范围:': '恢复时间范围:',
  '恢复时间点:': '恢复时间点:',
  '恢复数据大小': '恢复数据大小',
  '恢复结束时间': '恢复结束时间',
  '实例创建失败': '实例创建失败',
  '重试数据恢复': '重试数据恢复',
  '恢复计划名称': '恢复计划名称',
  '实例创建中': '实例创建中',
  '还原数据库': '还原数据库',
  '恢复实例': '恢复实例',
  '还原状态': '还原状态',
  '恢复完成': '恢复完成',
  '删除实例': '删除实例',
  '恢复管理': '恢复管理',
  '重试': '重试',
  '确定删除当前备份策略吗': '确定删除当前备份策略吗',
  '备份策略立即执行一次': '备份策略立即执行一次',
  '数据备份删除成功!': '数据备份删除成功!',
  '日志备份删除成功!': '日志备份删除成功!',
  '备份策略将不在执行': '备份策略将不在执行',
  '立即执行备份策略': '立即执行备份策略',
  '状态，【不】允许': '状态，【不】允许',
  '删除备份记录：': '删除备份记录：',
  '策略下发失败': '策略下发失败',
  '点击确定后，': '点击确定后，',
  '启用备份策略': '启用备份策略',
  '新增备份计划': '新增备份计划',
  '备份策略操作': '备份策略操作',
  '策略下发中': '策略下发中',
  '禁启用操作': '禁启用操作',
  '删除成功!': '删除成功!',
  '数据备份': '数据备份',
  '日志备份': '日志备份',
  '数据类型': '数据类型',
  '下发失败': '下发失败',
  '备份任务': '备份任务',
  '删除策略': '删除策略',
  '禁用中': '禁用中',
  '确认要': '确认要',
  '成功!': '成功!',
  '全备': '全备',
  '增备': '增备',
  '数据': '数据',
  '启用日志备份后，支持恢复到有效备份数据的任意时间': '启用日志备份后，支持恢复到有效备份数据的任意时间',
  '备份策略中已存在一个日志备份，保留周期的时间是：': '备份策略中已存在一个日志备份，保留周期的时间是：',
  '您创建的单次备份，备份时系统提供默认的备份时间': '您创建的单次备份，备份时系统提供默认的备份时间',
  '每周一，二，三，四，五，六，日': '每周一，二，三，四，五，六，日',
  '确认要延长日志备份的保留周期？': '确认要延长日志备份的保留周期？',
  '修改后为您自定义的备份时间': '修改后为您自定义的备份时间',
  '请先配置单次备份时间': '请先配置单次备份时间',
  '增加备份计划成功!': '增加备份计划成功!',
  '修改备份计划成功!': '修改备份计划成功!',
  '请先配置全备时间': '请先配置全备时间',
  '创建备份成功!': '创建备份成功!',
  '启用日志备份': '启用日志备份',
  '选择备份信息': '选择备份信息',
  '修改备份计划': '修改备份计划',
  '单次备份时间': '单次备份时间',
  '策略是否启动': '策略是否启动',
  '全备周期': '全备周期',
  '策略说明': '策略说明',
  '计划说明': '计划说明',
  '备份频率': '备份频率',
  '备份确认': '备份确认',
  '每天全备': '每天全备',
  '请先输入': '请先输入',
  '计划': '计划',
  '账户（账户名：权限）': '账户（账户名：权限）',
  '数据库管理--新增': '数据库管理--新增',
  '授权用户账号:': '授权用户账号:',
  '账户名：权限': '账户名：权限',
  '数据库名:': '数据库名:',
  '排序规则:': '排序规则:',
  '字符分类:': '字符分类:',
  '暂无账户': '暂无账户',
  '字符集:': '字符集:',
  '账户列表': '账户列表',
  '账户名': '账户名',
  '账户': '账户',
  '数据库节点ID': '数据库节点ID',
  '归档磁盘容量': '归档磁盘容量',
  '计算节点ID': '计算节点ID',
  '数据磁盘容量': '数据磁盘容量',
  '数据库节点': '数据库节点',
  '存储容量': '存储容量',
  '请输入可修改参数范围内的数字！': '请输入可修改参数范围内的数字！',
  '请输入可修改参数范围内的值！': '请输入可修改参数范围内的值！',
  '你确认要修改这些参数吗': '你确认要修改这些参数吗',
  '您没有修改任何参数！': '您没有修改任何参数！',
  '变更前的参数值': '变更前的参数值',
  '变更后的参数值': '变更后的参数值',
  '参数提交成功！': '参数提交成功！',
  '可修改参数值': '可修改参数值',
  '可修改参数': '可修改参数',
  '参数默认值': '参数默认值',
  '运行参数值': '运行参数值',
  '提交修改': '提交修改',
  '是否重启': '是否重启',
  '修改历史': '修改历史',
  '是否生效': '是否生效',
  '变更时间': '变更时间',
  '重启生效': '重启生效',
  '参数名': '参数名',
  '放大': '放大',
  '选择时间区间:': '选择时间区间:',
  '十分钟': '十分钟',
  '半小时': '半小时',
  '一小时': '一小时',
  '一天': '一天',
  '三天': '三天',
  '不支持any，可以多个port，用逗号隔开，个数与internal_port一致，且端口号一一对应；端口号不能重复使用；1-65534': '不支持any，可以多个port，用逗号隔开，个数与internal_port一致，且端口号一一对应；端口号不能重复使用；1-65534',
  '不支持any，可以多个port，用逗号隔开，个数与eip_port一致，1-65534': '不支持any，可以多个port，用逗号隔开，个数与eip_port一致，1-65534',
  'any：所有公网ip；支持单ip或多个ip和CIDR，多ip用逗号隔开': 'any：所有公网ip；支持单ip或多个ip和CIDR，多ip用逗号隔开',
  '名称须是以数字或字母开头并由字母、数字和下划线组成的32位字符': '名称须是以数字或字母开头并由字母、数字和下划线组成的32位字符',
  '原配置内网IP已不存在，请重新配置!': '原配置内网IP已不存在，请重新配置!',
  '请输入目标系统名，最长32位': '请输入目标系统名，最长32位',
  '没有可配置的内网IP': '没有可配置的内网IP',
  '请填写正确格式名称!': '请填写正确格式名称!',
  '没有可配置的EIP': '没有可配置的EIP',
  '请先完成必填配置!': '请先完成必填配置!',
  '正在编辑序号：': '正在编辑序号：',
  '创建DNAT': '创建DNAT',
  '内网端口': '内网端口',
  '请输入名称搜索': '请输入名称搜索',
  'NAT网关详情': 'NAT网关详情',
  '支持any，多端口号(逗号隔开,可有port段)，如:(1,3-10,12)，但与dest_ip不可同时为any；1-65534': '支持any，多端口号(逗号隔开,可有port段)，如:(1,3-10,12)，但与dest_ip不可同时为any；1-65534',
  '公网ip，支持any，多ip和CIDR(逗号隔开)，校验除私有ip外的其他公网ip': '公网ip，支持any，多ip和CIDR(逗号隔开)，校验除私有ip外的其他公网ip',
  '目标系统名须是以数字或字母开头并由字母、数字和下划线组成的32位字符': '目标系统名须是以数字或字母开头并由字母、数字和下划线组成的32位字符',
  '请填写正确格式目标系统名!': '请填写正确格式目标系统名!',
  '没有可配置的云主机': '没有可配置的云主机',
  '创建SNAT': '创建SNAT',
  '备份桶名称': '备份桶名称',
  '备份大小': '备份大小',
  '备份日志': '备份日志',
  '任务中断': '任务中断',
  '桶ID': '桶ID',
  '点击确定后，备份任务立即': '点击确定后，备份任务立即',
  '中断执行正在进行备份任务': '中断执行正在进行备份任务',
  '全量备份任务等待处理中': '全量备份任务等待处理中',
  '增量备份任务等待处理': '增量备份任务等待处理',
  '全量备份任务等待处理': '全量备份任务等待处理',
  '是否删除同步数据：': '是否删除同步数据：',
  '立即执行备份任务': '立即执行备份任务',
  '备份桶已被删除': '备份桶已被删除',
  '增量备份完成': '增量备份完成',
  '增量备份错误': '增量备份错误',
  '全量备份错误': '全量备份错误',
  '全量备份完成': '全量备份完成',
  '源桶已被删除': '源桶已被删除',
  '启用成功!': '启用成功!',
  '禁用成功!': '禁用成功!',
  '备份存储桶': '备份存储桶',
  '增量备份中': '增量备份中',
  '全量备份中': '全量备份中',
  '添加备份': '添加备份',
  '禁用任务': '禁用任务',
  '启用任务': '启用任务',
  '中断备份': '中断备份',
  '源存储桶': '源存储桶',
  '中断': '中断',
  '执行': '执行',
  '您所需区域下没有对象存储容量包,请先': '您所需区域下没有对象存储容量包,请先',
  '请先完成备份时间的配置': '请先完成备份时间的配置',
  '请先完成备份频率的配置': '请先完成备份频率的配置',
  '策略说明应不少于5个字': '策略说明应不少于5个字',
  '请输入至少5个字': '请输入至少5个字',
  '请先完成备份桶名': '请先完成备份桶名',
  '备份名称的配置': '备份名称的配置',
  '请输入备份桶名': '请输入备份桶名',
  '请输入备份名称': '请输入备份名称',
  '备份源桶': '备份源桶',
  '备份区域': '备份区域',
  '备份信息': '备份信息',
  '温馨提示：存储桶文件列表展示前50个文件，若需查看更多文件请输入文件前缀名进行搜索。': '温馨提示：存储桶文件列表展示前50个文件，若需查看更多文件请输入文件前缀名进行搜索。',
  '文件已删除，若有需要请重新上传。': '文件已删除，若有需要请重新上传。',
  '没有权限进行该操作！': '没有权限进行该操作！',
  '将文件拖到此处，或者': '将文件拖到此处，或者',
  '请输入文件名前缀匹配': '请输入文件名前缀匹配',
  '请先选择访问权限！': '请先选择访问权限！',
  '访问权限修改成功！': '访问权限修改成功！',
  '文件大小(KB)': '文件大小(KB)',
  '预签名url': '预签名url',
  '修改访问权限': '修改访问权限',
  '点击可删除': '点击可删除',
  '暂无文件~': '暂无文件~',
  '文件列表：': '文件列表：',
  '修改ACL': '修改ACL',
  '文件ACL': '文件ACL',
  '上传文件：': '上传文件：',
  '复制链接': '复制链接',
  '点击上传': '点击上传',
  '文件名称': '文件名称',
  '文件大小': '文件大小',
  '文件名': '文件名',
  '版本号': '版本号',
  '执行任务总数': '执行任务总数',
  '执行任务总数/天':'执行任务总数/天',
  '对象存储桶': '对象存储桶',
  '执行成功数': '执行成功数',
  '写请求数：': '写请求数：',
  '同步策略：': '同步策略：',
  '备份策略：': '备份策略：',
  '执行失败数': '执行失败数',
  '对象总数：': '对象总数：',
  '容量包数量': '容量包数量',
  '存储总量': '存储总量',
  '剩余总量': '剩余总量',
  '总计': '总计',
  '读': '读',
  '点击确定后，同步任务立即': '点击确定后，同步任务立即',
  '中断执行正在进行同步任务': '中断执行正在进行同步任务',
  '立即执行同步任务': '立即执行同步任务',
  '使用容量(kb)': '使用容量(kb)',
  '存储桶类型': '存储桶类型',
  '防盗链配置': '防盗链配置',
  '调用次数': '调用次数',
  '对象数量': '对象数量',
  '中断同步': '中断同步',
  '立即同步': '立即同步',
  '同步周期': '同步周期',
  '同步名称': '同步名称',
  '对象存储': '对象存储',
  '增加同步': '增加同步',
  '增加备份': '增加备份',
  '是否删除': '是否删除',
  '数据：': '数据：',
  '请先完成同步时间的配置': '请先完成同步时间的配置',
  '请先完成同步频率的配置': '请先完成同步频率的配置',
  '请先完成同步桶名': '请先完成同步桶名',
  '同步名称的配置': '同步名称的配置',
  '请输入同步桶名': '请输入同步桶名',
  '请输入同步名称': '请输入同步名称',
  '同步时间': '同步时间',
  '同步源桶': '同步源桶',
  '同步区域': '同步区域',
  '同步信息': '同步信息',
  '同步策略详情': '同步策略详情',
  '同步策略ID': '同步策略ID',
  '同步桶名称': '同步桶名称',
  '同步日志': '同步日志',
  '同步策略名称': '同步策略名称',
  '同步存储桶': '同步存储桶',
  '添加同步': '添加同步',
  '可连接节点': '可连接节点',
  '资源属性': '资源属性',
  '资源详情': '资源详情',
  '资源名称': '资源名称',
  '属性名': '属性名',
  '选项值': '选项值',
  '目标计算节点为必选': '目标计算节点为必选',
  '编辑资源成功！': '编辑资源成功！',
  '请输入资源名称': '请输入资源名称',
  '选项值为必填': '选项值为必填',
  '资源code': '资源code',
  '资源图片:': '资源图片:',
  '请先填好第': '请先填好第',
  '选项值:': '选项值:',
  '可连节点': '可连节点',
  '添加属性': '添加属性',
  '属性名称': '属性名称',
  '属性描述': '属性描述',
  '是否必填': '是否必填',
  '属性类型': '属性类型',
  '编辑资源': '编辑资源',
  '资源描述': '资源描述',
  '资源连接': '资源连接',
  '下拉框': '下拉框',
  '上传': '上传',
  '文本': '文本',
  '项！': '项！',
  '目标节点资源ID': '目标节点资源ID',
  '源节点资源ID': '源节点资源ID',
  '目标节点ID': '目标节点ID',
  '目标节点类型': '目标节点类型',
  '云主机ECS': '云主机ECS',
  '源节点ID': '源节点ID',
  '源节点类型': '源节点类型',
  '资源栈名称': '资源栈名称',
  '资源栈ID': '资源栈ID',
  '资源栈预览': '资源栈预览',
  '资源列表': '资源列表',
  '节点ID': '节点ID',
  '资源状态': '资源状态',
  '关系列表': '关系列表',
  '关联结果': '关联结果',
  '关联类型': '关联类型',
  '模板ID': '模板ID',
  '是否完成': '是否完成',
  '重试次数': '重试次数',
  '资源栈': '资源栈',
  '防火墙': '防火墙',
  '创建资源栈请求已发送，请耐心等待！': '创建资源栈请求已发送，请耐心等待！',
  '重试请求已发送，请耐心等待！': '重试请求已发送，请耐心等待！',
  '请输入资源栈名称': '请输入资源栈名称',
  '模板名称:': '模板名称:',
  '请选择模板': '请选择模板',
  '创建栈': '创建栈',
  '模板': '模板',
  '模板内容': '模板内容',
  '模板预览': '模板预览',
  '模板详情': '模板详情',
  '模板名称': '模板名称',
  '请输入模板ID': '请输入模板ID',
  '模板复制成功！': '模板复制成功！',
  '请输入模板名称': '请输入模板名称',
  '源模板ID': '源模板ID',
  '新建模板': '新建模板',
  '关闭参数配置将会清空已配置的数据！': '关闭参数配置将会清空已配置的数据！',
  '是否关闭参数配置！': '是否关闭参数配置！',
  '确认资源栈': '确认资源栈',
  '保存模板': '保存模板',
  '配置实例': '配置实例',
  '参数': '参数',
  '请先填选': '请先填选',
  'Flavor规格:': 'Flavor规格:',
  '镜像提供方:': '镜像提供方:',
  '云主机类型:': '云主机类型:',
  '系统版本:': '系统版本:',
  '实例名称:': '实例名称:',
  '应用环境:': '应用环境:',
  '记录名称:': '记录名称:',
  '生存时间:': '生存时间:',
  '目标系统:': '目标系统:',
  '申请理由:': '申请理由:',
  '实例描述:': '实例描述:',
  '数据库:': '数据库:',
  '数据盘:': '数据盘:',
  '解析网络': '解析网络',
  '源系统:': '源系统:',
  '生效时间': '生效时间',
  '大小:': '大小:',
  '机型:': '机型:',
  '子网:': '子网:',
  '名称:': '名称:',
  '描述:': '描述:',
  '协议:': '协议:',
  '备注:': '备注:',
  '类型:': '类型:',
  '内容:': '内容:',
  '请填写记录名 !': '请填写记录名 !',
  '请先选择系统版本！': '请先选择系统版本！',
  '请先选择vpc！': '请先选择vpc！',
  '可填多个，逗号隔开,长度:1~255': '可填多个，逗号隔开,长度:1~255',
  '后缀选填,字符长度0-40': '后缀选填,字符长度0-40',
  '请先填写申请理由！': '请先填写申请理由！',
  '请选择原系统前缀！': '请选择原系统前缀！',
  '请先选择项目！': '请先选择项目！',
  '是否立即生效': '是否立即生效',
  '】的生效时间': '】的生效时间',
  '目标节点': '目标节点',
  '请先选择协议！': '请先选择协议！',
  '请填写名称！': '请填写名称！',
  '请填写名称': '请填写名称',
  '数据库名由小写字母、数字组成，字母开头，字母或数字结尾': '数据库名由小写字母、数字组成，字母开头，字母或数字结尾',
  '数据库名长度为2-128个字符！': '数据库名长度为2-128个字符！',
  '数据库名长度为2-8个字符！': '数据库名长度为2-8个字符！',
  '中文简体': '中文简体',
  '中文繁体': '中文繁体',
  '英文': '英文',
  '1 v 1 入云方案咨询': '1 v 1 入云方案咨询',
  '7x24 小时专家客服': '7x24 小时专家客服',
  '最高级别安全合规': '最高级别安全合规',
  '专业架构师指引': '专业架构师指引',
  '相关法律文件': '相关法律文件',
  '产品白皮书': '产品白皮书',
  '权益与要求': '权益与要求',
  '支持与服务': '支持与服务',
  '申请加入': '申请加入',
  '优秀伙伴': '优秀伙伴',
  '招商云是集团数字化战略的核心赋能平台，是数字化转型建设的技术底座，对促进产业共享、提升收益，汇聚数据、挖掘价值，打造云化生态和产业转型升级具有不可替代的作用。是赋能二级公司客户服务、生产经营、内部管理、生态打造和助力招商局产业转型的先导工程。招商云以“云生态、云赋能、云数据、云产业”为四大目标，构建云上生态圈，打造IaaS，PaaS，SaaS三位一体的云服务。': '招商云是集团数字化战略的核心赋能平台，是数字化转型建设的技术底座，对促进产业共享、提升收益，汇聚数据、挖掘价值，打造云化生态和产业转型升级具有不可替代的作用。是赋能二级公司客户服务、生产经营、内部管理、生态打造和助力招商局产业转型的先导工程。招商云以“云生态、云赋能、云数据、云产业”为四大目标，构建云上生态圈，打造IaaS，PaaS，SaaS三位一体的云服务。',
  '您未拥有此权限，获取权限请联系管理员！': '您未拥有此权限，获取权限请联系管理员！',
  '请使用招商随行扫码登录': '请使用招商随行扫码登录',
  '请选择账号类型': '请选择账号类型',
  '请选择账户类型': '请选择账户类型',
  '请输入用户名': '请输入用户名',
  '二维码已失效': '二维码已失效',
  '刷新二维码': '刷新二维码',
  '互联网用户': '互联网用户',
  '扫码登录': '扫码登录',
  '解冻账号': '解冻账号',
  '已登入!': '已登入!',
  '账号登录': '账号登录',
  '登 录': '登 录',
  '点这里': '点这里',
  '获 取': '获 取',
  '个IP相同,请先修改!': '个IP相同,请先修改!',
  '数据删除成功!': '数据删除成功!',
  '版本发布服务': '版本发布服务',
  '数据处理服务': '数据处理服务',
  '云磁盘': '云磁盘',
  '云磁盘快照': '云磁盘快照',
  '虚拟IP': '虚拟IP',
  'OSS对象存储': 'OSS对象存储',
  'VPC子网': 'VPC子网',
  'OSS桶同步': 'OSS桶同步',
  'ecs文件备份': 'ecs文件备份',
  '固定公网IP': '固定公网IP',
  '弹性网卡': '弹性网卡',
  '桌面服务': '桌面服务',
  '云打印服务': '云打印服务',
  'OSS桶备份': 'OSS桶备份',
  '邮件服务': '邮件服务',
  '云桌面服务': '云桌面服务',
  '数据库同步': '数据库同步',
  '物理裸机': '物理裸机',
  '桌面安全': '桌面安全',
  '应用安全': '应用安全',
  'SSL证书服务': 'SSL证书服务',
  '主机安全服务': '主机安全服务',
  '数据库审计服务': '数据库审计服务',
  '态势感知服务': '态势感知服务',
  '网盘服务': '网盘服务',
  'GPU物理机服务': 'GPU物理机服务',
  '文件备份': '文件备份',
  '互联网带宽': '互联网带宽',
  '专线带宽': '专线带宽',
  'OSS存储包': 'OSS存储包',
  '弹性公网IP': '弹性公网IP',
  '数据库还原': '数据库还原',
  'ecs文件恢复': 'ecs文件恢复',
  'NAS备份': 'NAS备份',
  '云主机|云磁盘': '云主机|云磁盘',
  'NAS|NAS同步':'NAS|NAS同步',
  '云主机|EIP':'云主机|EIP',
  '文件存储': '文件存储',
  '请选择字符集 !':'请选择字符集 !',
  '请选择块大小 !':'请选择块大小 !',
  '请选择关联证书!': '请选择关联证书',
  '启/禁用状态修改成功!': '启/禁用状态修改成功!',
  '协议监听编辑成功!': '协议监听编辑成功!',
  '健康检查修改成功!': '健康检查修改成功!',
  '预检查失败': '预检查失败',
  '挂载云磁盘': '挂载云磁盘',
  '挂载NAS': '挂载NAS',
  'DNS绑定': 'DNS绑定',
  '新增后端服务器成功!': '新增后端服务器成功!',
  '问题描述:': '问题描述:',
  '请先选择搜索维度！':'请先选择搜索维度！',
  '同步级别：': '同步级别：',
  '源端数据库：': '源端数据库：',
  '目标端数据库：': '目标端数据库：',
  '新增目标端库名成功！': '新增目标端库名成功！',
  '项目负责人':'项目负责人',
  '销毁中': '销毁中',
  '删除前请确认数据是否备份，如需备份请联系存储组备份，以免造成损失': '删除前请确认数据是否备份，如需备份请联系存储组备份，以免造成损失',
  '删除前请确认数据是否备份，以免造成损失，': '删除前请确认数据是否备份，以免造成损失，',
  '备份后请及时禁用备份策略': '备份后请及时禁用备份策略',
  '去备份': '去备份',
  '到期时间': '到期时间',
  '立即销毁': '立即销毁',
  '数据库回收站': '数据库回收站',
  '备份策略,删除成功!': '备份策略,删除成功!',
  '软删除': '软删除',
  '数据库详情': '数据库详情',
  '可填多个端口或端口段，多个端口用英文逗号/空格/换行符分隔；\n多个连续端口可用中横线隔开，示例：8080-10000；\n总长度不超过100个字符':'可填多个端口或端口段，多个端口用英文逗号/空格/换行符分隔；\n多个连续端口可用中横线隔开，示例：8080-10000；\n总长度不超过100个字符',
  '充值总额:': '充值总额:',
  '开始日期': '开始日期',
  '结束日期': '结束日期',
  '过滤': '过滤',
  '编辑额度(元)：': '编辑额度(元)：',
  '项目可用余额(元)': '项目可用余额(元)',
  '额度启用': '额度启用',
  '发票信息管理':'发票信息管理',
  '项目额度管理': '项目额度管理',
  '编辑额度': '编辑额度',
  '成功！': '成功！',
  '本月当前费用': '本月当前费用',
  '预测本月费用': '预测本月费用',
  '目录类别': '目录类别',
  '适用范围': '适用范围',
  '集团': '集团',
  '内部结算': '内部结算',
  '实业板块': '实业板块',
  '外部市场': '外部市场',
  '请选择目录类别！': '请选择目录类别！',
  '最新备份记录': '最新备份记录',
  '完成时间': '完成时间',
  '请等待备份任务完成或停止备份任务后再删除。': '请等待备份任务完成或停止备份任务后再删除。',
  '数据还未备份，建议先备份以免造成损失，': '数据还未备份，建议先备份以免造成损失，',
  '可在': '可在',
  '查看该数据库完整的备份记录，并根据实际情况进行数据备份': '查看该数据库完整的备份记录，并根据实际情况进行数据备份',
  '温馨提示：您若需要卸载或删除块存储SAN，请在招商云': '温馨提示：您若需要卸载或删除块存储SAN，请在招商云',
  '块存储SAN 帮助文档':'块存储SAN 帮助文档',
  '需要网络连接后再进行购买操作。可申请工单处理完成后进行购买操作。您可重新选择其它云裸机进行挂载。': '需要网络连接后再进行购买操作。可申请工单处理完成后进行购买操作。您可重新选择其它云裸机进行挂载。',
  '块存储SAN与云裸机光纤网络连接': '块存储SAN与云裸机光纤网络连接',
  '您的云裸机的HBA网络未连接': '您的云裸机的HBA网络未连接',
  '当前条件没有存储类型！': '当前条件没有存储类型！',
  '设置SAN存储信息': '设置SAN存储信息',
  '没有可挂载的云裸机': '没有可挂载的云裸机',
  'SAN存储-编辑': 'SAN存储-编辑',
  '添加SAN存储': '添加SAN存储',
  'SAN存储购买': 'SAN存储购买',
  '请选择云裸机!': '请选择云裸机!',
  '云裸机不能为空': '云裸机不能为空',
  'SAN存储详情': 'SAN存储详情',
  '块存储SAN': '块存储SAN',
  '挂载裸机IP': '挂载裸机IP',
  '磁盘名称：': '磁盘名称：',
  '磁盘用途：': '磁盘用途：',
  '挂载云裸机': '挂载云裸机',
  '挂载裸机名': '挂载裸机名',
  '磁盘用途': '磁盘用途',
  '磁盘数量': '磁盘数量',
  '云裸机：': '云裸机：',
  '挂载成功': '挂载成功',
  '超高端': '超高端',
  '日志盘': '日志盘',
  '心跳盘': '心跳盘',
  '提工单': '提工单',
  '挂载中': '挂载中',
  '卸载中': '卸载中',
  '普通': '普通',
  '中端': '中端',
  '高端': '高端',
  '挂载SAN存储':'挂载SAN存储',
  '删除云裸机失败':'删除云裸机失败',
  '删除云裸机前请取消挂载SAN存储盘':'删除云裸机前请取消挂载SAN存储盘',
  '没有可挂载的SAN':'没有可挂载的SAN',
  'SAN存储盘':'SAN存储盘',
  'MySQL备份': 'MySQL备份',
  '确认要禁用': '确认要禁用',
  '点击确定后，备份策略将不在执行': '点击确定后，备份策略将不在执行',
  '禁用备份策略成功!': '禁用备份策略成功!',
  '确认要启用': '确认要启用',
  '点击确定后，启用备份策略': '点击确定后，启用备份策略',
  '启用备份策略成功!': '启用备份策略成功!',
  '确定删除当前备份策略吗?': '确定删除当前备份策略吗?',
  '源数据库ID': '源数据库ID',
  '数据库IP地址': '数据库IP地址',
  '源数据库实例': '源数据库实例',
  '配置备份计划': '配置备份计划',
  '请输入策略名称': '请输入策略名称',
  '请输入计划名称': '请输入计划名称',
  '租户额度未启用状态不能编辑!': '租户额度未启用状态不能编辑!',
  '请正确填写额度!': '请正确填写额度!',
  '额度最多两位小数!': '额度最多两位小数!',
  '信用额度(元)': '信用额度(元)',
  '项目额度(元)': '项目额度(元)',
  '挂载时间':'挂载时间',
  '挂载SAN':'挂载SAN',
  '请输入域名或URL': '请输入域名或URL',
  'URL刷新': 'URL刷新',
  'URL预热': 'URL预热',
  '刷新预热': '刷新预热',
  '操作内容': '操作内容',
  '所有类型': '所有类型',
  '刷新类型': '刷新类型',
  '预热区域': '预热区域',
  '每日刷新上限2000，预热上限500，目录上限100。刷新任务生效时间大约为5分钟。': '每日刷新上限2000，预热上限500，目录上限100。刷新任务生效时间大约为5分钟。',
  '当您需要刷新或预热多条请求时，请按照一行一个URL进行输入，并以http://或https://开头。\t\n刷新或预热URL，示例：http://www.test.com/test.html。\t\n刷新目录需以 / 结束，示例：http://www.test.com/test/。': '当您需要刷新或预热多条请求时，请按照一行一个URL进行输入，并以http://或https://开头。\t\n刷新或预热URL，示例：http://www.test.com/test.html。\t\n刷新目录需以 / 结束，示例：http://www.test.com/test/。',
  '请输入正确的URL，必须以http://或https://开头，不能重复 !': '请输入正确的URL，必须以http://或https://开头，不能重复 !',
  '请输入正确的URL，刷新目录需以"/"结束 !': '请输入正确的URL，刷新目录需以"/"结束 !',
  '文件刷新': '文件刷新',
  '目录刷新': '目录刷新',
  '请选择操作类型 !': '请选择操作类型 !',
  '请选择刷新类型 !': '请选择刷新类型 !',
  '请选择预热区域 !': '请选择预热区域 !',
  '请先填写URL !': '请先填写URL !',
  '预热刷新中': '预热刷新中',
  '后端UUID':'后端UUID',
  '当前条件没有配置相应工单,请先配置！':'当前条件没有配置相应工单,请先配置！',
  '剩余刷新量': '剩余刷新量',
  '操作失败': '操作失败',
  '备份策略处于【备份软件安装中】/【策略下发中】状态，【不】允许删除!': '备份策略处于【备份软件安装中】/【策略下发中】状态，【不】允许删除!',
  '源数据库IP': '源数据库IP',
  '建议选择购买当前云裸机已挂载使用的存储类型和磁盘类型': '建议选择购买当前云裸机已挂载使用的存储类型和磁盘类型',
  '超高端存储：稳定性和安全性最好，适用于核心业务系统': '超高端存储：稳定性和安全性最好，适用于核心业务系统',
  '高端存储：稳定性和安全性较好，适用于重要业务系统': '高端存储：稳定性和安全性较好，适用于重要业务系统',
  '中端存储：稳定性和安全性一般，适用于一般业务系统': '中端存储：稳定性和安全性一般，适用于一般业务系统',
  '普通存储：稳定性和安全性较差，适用于边缘业务系统': '普通存储：稳定性和安全性较差，适用于边缘业务系统',
  'NVME：新一代固态磁盘，性能最好、延时最低，适用于核心业务系统': 'NVME：新一代固态磁盘，性能最好、延时最低，适用于核心业务系统',
  'SSD：固态磁盘，性能较好、延时较低，适用于重要业务系统': 'SSD：固态磁盘，性能较好、延时较低，适用于重要业务系统',
  'SAS：机械磁盘，性能一般、延时一般，适用于一般业务系统': 'SAS：机械磁盘，性能一般、延时一般，适用于一般业务系统',
  'SATA：机械磁盘，性能较差、延时较高，适用于边缘业务系统和归档数据': 'SATA：机械磁盘，性能较差、延时较高，适用于边缘业务系统和归档数据',
  '申请工单':'申请工单',
  '删除前请确保数据已备份，若未备份删除后数据无法找回':'删除前请确保数据已备份，若未备份删除后数据无法找回',
  '账号需要具备所迁移对象的 RELOAD, SELECT, SHOW VIEW, EVENT, TRIGGER及MySQL库的SELECT权限。': '账号需要具备所迁移对象的 RELOAD, SELECT, SHOW VIEW, EVENT, TRIGGER及MySQL库的SELECT权限。',
  '表级别迁移：账号需要具备 select_catalog_role, select any table 或 DBA权限。': '表级别迁移：账号需要具备 select_catalog_role, select any table 或 DBA权限。',
  '用户级别迁移：账户需要具备 EXP_FULL_DATABASE 或 DBA权限。': '用户级别迁移：账户需要具备 EXP_FULL_DATABASE 或 DBA权限。',
  '账号需要具备 INSERT, CREATE, SUPER, DROP, ALTER, EXECUTE, CREATE VIEW, CREATE ROUTINE, ALTER ROUTINE, EVENT, TRIGGER权限。': '账号需要具备 INSERT, CREATE, SUPER, DROP, ALTER, EXECUTE, CREATE VIEW, CREATE ROUTINE, ALTER ROUTINE, EVENT, TRIGGER权限。',
  '表级别迁移：账号需要具备 select_catalog_role及目标对象的操作权限 或 DBA权限。': '表级别迁移：账号需要具备 select_catalog_role及目标对象的操作权限 或 DBA权限。',
  '用户级别迁移：账户需要具备 IMP_FULL_DATABASE 或 DBA权限。': '用户级别迁移：账户需要具备 IMP_FULL_DATABASE 或 DBA权限。',
  '账号需要具备所同步对象的 SELECT, SHOW VIEW, TRIGGER, RELOAD, REPLICATION SLAVE, REPLICATION CLIENT及MySQL库的SELECT权限。': '账号需要具备所同步对象的 SELECT, SHOW VIEW, TRIGGER, RELOAD, REPLICATION SLAVE, REPLICATION CLIENT及MySQL库的SELECT权限。',
  '账号需要具备 SELECT, INSERT, UPDATE, DELETE, INDEX, CREATE, DROP, ALTER, SUPER, EXECUTE, CREATE VIEW, CREATE ROUTINE, ALTER ROUTINE, TRIGGER权限。': '账号需要具备 SELECT, INSERT, UPDATE, DELETE, INDEX, CREATE, DROP, ALTER, SUPER, EXECUTE, CREATE VIEW, CREATE ROUTINE, ALTER ROUTINE, TRIGGER权限。',
  '账户需要具备DBA权限。': '账户需要具备DBA权限。',
  '检查源数据库的账号权限是否满足迁移要求': '检查源数据库的账号权限是否满足迁移要求',
  '检查源库是否存在待同步的结构对象': '检查源库是否存在待同步的结构对象',
  '未检查': '未检查',
  '启用DDL同步：': '启用DDL同步：',
  '源数据共用：': '源数据共用：',
  '高级选项': '高级选项',
  '配件类型': '配件类型',
  '配件型号': '配件型号',
  '配件数量': '配件数量',
  '+添加物理配件': '+添加物理配件',
  '配件': '配件',
  '源数据库名称': '源数据库名称',
  '当前状态不支持创建备份策略！': '当前状态不支持创建备份策略！',
  '配件数量不能大于插槽口数量!': '配件数量不能大于插槽口数量!',
  '配件类型和配件数量需要同时配置!': '配件类型和配件数量需要同时配置!',
  '配置项不能为空!': '配置项不能为空!',
  '备份策略处于【启动中】/【备份软件安装中】/【策略下发中】状态，【不】允许删除!': '备份策略处于【启动中】/【备份软件安装中】/【策略下发中】状态，【不】允许删除!',
  '一次最多可授权10台主机！': '一次最多可授权10台主机！',
  '目录计费类型': '目录计费类型',
  '收费对象性质': '收费对象性质',
  '请选择目录计费类型！': '请选择目录计费类型！',
  '请选择收费对象性质！': '请选择收费对象性质！',
  '目录类别:': '目录类别',
  '请选择目录类别': '请选择目录类别',
  '适用范围:': '适用范围',
  '请选择适用范围': '请选择适用范围',
  '云环境': '云环境',
  '当前选项下暂无区域，请修改配置': '当前选项下暂无区域，请修改配置',
  '集群类型': '集群类型',
  '通用集群': '通用集群',
  '高级设置': '高级设置',
  '请先选择集群类型！': '请先选择集群类型！',
  'IP类型': 'IP类型',
  '不支持any，可以多个port，用逗号隔开，1-65534': '不支持any，可以多个port，用逗号隔开，1-65534',
  '请先选择内网IP !': '请先选择内网IP !',
  '请先填写内网端口 !': '请先填写内网端口 !',
  '请先选择协议类型 !': '请先选择协议类型 !',
  '不支持any，可以多个port，用逗号隔开，个数与internal_port一致，且端口号一一对应；端口号不能重复使用；1-65535': '不支持any，可以多个port，用逗号隔开，个数与internal_port一致，且端口号一一对应；端口号不能重复使用；1-65535',
  '不支持any，可以多个port，用逗号隔开，个数与eip_port一致，1-65535': '不支持any，可以多个port，用逗号隔开，个数与eip_port一致，1-65535',
  '支持any，多端口号(逗号隔开,可有port段)，如:(1,3-10,12)，但与dest_ip不可同时为any；1-65535': '支持any，多端口号(逗号隔开,可有port段)，如:(1,3-10,12)，但与dest_ip不可同时为any；1-65535',
  '主机名:': '主机名:',
  '配置:': '配置:',
  '展示的是招商私有云的云数据库实例为运行状态的统计数据': '展示的是招商私有云的云数据库实例为运行状态的统计数据',
  '展示的是招商私有云的云主机资源概览': '展示的是招商私有云的云主机资源概览',
  '展示的是招商私有云的云硬盘资源概览': '展示的是招商私有云的云硬盘资源概览',
  '通用型云硬盘(个(GB))': '通用型云硬盘(个(GB))',
  '云主机(台(vCPU))': '云主机(台(vCPU))',
  '招商私有云计算资源概览': '招商私有云计算资源概览',
  '云数据库类型分布情况': '云数据库类型分布情况',
  '数据库实例总数(个)': '数据库实例总数(个)',
  '公有云计算资源概览': '公有云计算资源概览',
  '本月当前费用(元)': '本月当前费用(元)',
  '预测本月费用(元)': '预测本月费用(元)',
  '云主机总数(台)': '云主机总数(台)',
  '项目资源使用情况': '项目资源使用情况',
  '数据库实例(个)': '数据库实例(个)',
  '云主机快照(个)': '云主机快照(个)',
  '通用型系统存储': '通用型系统存储',
  '云主机运行情况': '云主机运行情况',
  '云硬盘运行情况': '云硬盘运行情况',
  'NAS(个)': 'NAS(个)',
  '云资源概览': '云资源概览',
  '云硬盘总量': '云硬盘总量',
  '产品类目：': '产品类目：',
  '项目名称：': '项目名称：',
  '数据库实例名称': '数据库实例名称',
  '待查事项': '待查事项',
  '待办工单': '待办工单',
  '待办审批': '待办审批',
  '最新公告': '最新公告',
  '资源IP': '资源IP',
  '高性能型': '高性能型',
  '运行总数': '运行总数',
  '华为云': '华为云',
  '天翼云': '天翼云',
  '容量型': '容量型',
  '告警': '告警',
  '职能':'职能',
  '运维管理':'运维管理',
  '请先输入计划名称':'请先输入计划名称',
  '您的MySQL数据库未进行备份操作':'您的MySQL数据库未进行备份操作',
  '若有需要，请后续MySQL数据库进行备份操作':'若有需要，请后续MySQL数据库进行备份操作',
  '备份设置':'备份设置',
  '启动数据库备份':'启动数据库备份',
  '修改数据库备份':'修改数据库备份',
  '计算节点': '计算节点',
  'AD域': 'AD域',
  'openstack集群': 'openstack集群',
  'Flavor': 'Flavor',
  '地区': '地区',
  '动作': '动作',
  '短信功能': '短信功能',
  'DNS': 'DNS',
  '策略组': '策略组',
  'NAS': 'NAS',
  '策略子项': '策略子项',
  'Mysql数据库': 'Mysql数据库',
  'Redis数据库': 'Redis数据库',
  'Oracle数据库': 'Oracle数据库',
  'Mongo数据库': 'Mongo数据库',
  'PostgreSQL数据库': 'PostgreSQL数据库',
  '数据库规格管理': '数据库规格管理',
  '数据库版本管理': '数据库版本管理',
  '数据库类型管理': '数据库类型管理',
  '数据库托管项目配置': '数据库托管项目配置',
  '云主机文件备份': '云主机文件备份',
  'SAN存储': 'SAN存储',
  '回收站': '回收站',
  '公有云': '公有云',
  '密码找回': '密码找回',
  '密码重置': '密码重置',
  '输入新密码': '输入新密码',
  '确认新密码': '确认新密码',
  '确 认': '确 认',
  '返回登录': '返回登录',
  '仅支持互联网用户找回密码！': '仅支持互联网用户找回密码！',
  '两次密码不一致 !': '两次密码不一致 !',
  '密码格式错误': '密码格式错误',
  '密码重置成功！': '密码重置成功！',
  '昵称:': '昵称:',
  '验证码:': '验证码:',
  '新密码': '新密码',
  '如更改，请填写新密码': '如更改，请填写新密码',
  '8-21位字符': '8-21位字符',
  '请填写昵称!': '请填写昵称!',
  '请填写验证码！': '请填写验证码！',
  '已使用容量': '已使用容量',
  '不能包含中文字符': '不能包含中文字符',
  '不能包含中文字符;': '不能包含中文字符;',
  '请正确填写密码!': '请正确填写密码!',
  '请正确填写邮箱!': '请正确填写邮箱!',
  '天翼云磁盘暂不支持编辑功能': '天翼云磁盘暂不支持编辑功能',
  '忘记密码': '忘记密码',
  '必须为有效邮箱': '必须为有效邮箱',
  '必须包含大小写字母、数字、特殊字符': '必须包含大小写字母、数字、特殊字符',
  'NAS卷名称': 'NAS卷名称',
  'NAS可用区': 'NAS可用区',
  '备份NAS名称': '备份NAS名称',
  'NAS协议': 'NAS协议',
  'NAS名称': 'NAS名称',
  '保留数据': '保留数据',
  '源NAS卷名称': '源NAS卷名称',
  '目标NAS名称': '目标NAS名称',
  '目标NAS可用区': '目标NAS可用区',
  '目标NAS的ID': '目标NAS的ID',
  '恢复NAS卷': '恢复NAS卷',
  '请输入需要创建的恢复名称':'请输入需要创建的恢复名称',
  '目标nas卷名称': '目标nas卷名称',
  '请填写恢复名称': '请填写恢复名称',
  '请选择目标NAS卷': '请选择目标NAS卷',
  '请填写策略名称': '请填写策略名称',
  '备份发起时间': '备份发起时间',
  '请先配置全量计划名称': '请先配置全量计划名称',
  '请先配置全量开始时间': '请先配置全量开始时间',
  '请先配置全量备份周期': '请先配置全量备份周期',
  '请先配置每周备份日期': '请先配置每周备份日期',
  '请先配置每月备份日期': '请先配置每月备份日期',
  '请先配置备份保留时间': '请先配置备份保留时间',
  '请先配置增量计划名称': '请先配置增量计划名称',
  '请先配置增量开始时间': '请先配置增量开始时间',
  '请先配置增量备份周期': '请先配置增量备份周期',
  '请先配置增量每周备份日期': '请先配置增量每周备份日期',
  '请先配置增量每月备份日期': '请先配置增量每月备份日期',
  '启用NAS备份': '启用NAS备份',
  '您的NAS卷未进行备份操作，若需要容灾后续可对新购NAS卷进行备份配置。': '您的NAS卷未进行备份操作，若需要容灾后续可对新购NAS卷进行备份配置。',
  'NAS同步备份': 'NAS同步备份',
  '已启动': '已启动',
  '未启动': '未启动',
  '修改NAS备份': '修改NAS备份',
  '指定IP': '指定IP',
  '请输入需要指定的IP': '請输入需要指定的IP',
  '请输入正确的IPv4地址!': '请输入正确的IPv4地址!',
  '回收人': '回收人',
  '回收时间': '回收时间',
  '云主机回收':'云主机回收',
  '系统和文件备份':'系统和文件备份',
  '招商云建议进行在云主机回收前进行系统和文件的备份。':'招商云建议进行在云主机回收前进行系统和文件的备份。',
  '文件备份:':'文件备份:',
  '创建文件备份':'创建文件备份',
  '确认回收':'确认回收',
  '请输入验证码:':'请输入验证码:',
  '销毁资源':'销毁资源',
  'NAS授权':'NAS授权',
  '已授权的NAS列表':'已授权的NAS列表',
  '销毁云主机后NAS会自动卸载并取消授权':'销毁云主机后NAS会自动卸载并取消授权',
  '云网络产品':'云网络产品',
  '销毁':'销毁',
  '回收':'回收',
  '云主机的相关磁盘同时进行恢复，恢复后将正常收取招商云费用。':'云主机的相关磁盘同时进行恢复，恢复后将正常收取招商云费用。',
  '云主机销毁':'云主机销毁',
  '创建快照 & 下一步':'创建快照 & 下一步',
  '请输入快照名称':'请输入快照名称',
  '已挂载的云硬盘列表':'已挂载的云硬盘列表',
  '回收云硬盘前请确认数据已备份':'回收云硬盘前请确认数据已备份',
  '请先填写快照名称':'请先填写快照名称',
  '请先获取并填写短信验证码':'请先获取并填写短信验证码',
  '计算资源回收':'计算资源回收',
  '资源销毁':'资源销毁',
  'IP释放':'IP释放',
  '源端用户': '源端用户',
  '源库ip': '源库ip',
  '目标库ip': '目标库ip',
  '源端租户': '源端租户',
  '目标端租户': '目标端租户',
  '源端租户名称': '源端租户名称',
  '目标端租户名称': '目标端租户名称',
  '跨租户迁移': '跨租户迁移',
  '账号需要具备所迁移对象的SELECT权限':'账号需要具备所迁移对象的SELECT权限',
  '表级别迁移：账号需要具备 select_catalog_role, select any table 或 DBA权限。': '表级别迁移：账号需要具备 select_catalog_role, select any table 或 DBA权限。',
  '销毁成功':'销毁成功',
  '3.oracle迁移不支持列名小写': '3.oracle迁移不支持列名小写',
  '数据表名不能重复新增': '数据表名不能重复新增',
  '请输入中文名': '请输入中文名',
  '请输入域账号': '请输入域账号',
  '开票名称1': '开票名称1',
  '开票名称2': '开票名称2',
  '开票名称': '开票名称',
  '目录负责人域账号': '目录负责人域账号',
  '温馨提示：卸载云磁盘需先执行umount（Linux）或脱机（windows）操作，否则会导致磁盘再次挂载不可用。': '温馨提示：卸载云磁盘需先执行umount（Linux）或脱机（windows）操作，否则会导致磁盘再次挂载不可用。',
  '请选择云环境': '请选择云环境',
  '资源纳管项目名称': '资源纳管项目名称',
  '从公有云同步至招商云的资源将暂存在此项目，后续可切换至该项目查看同步的资源，': '从公有云同步至招商云的资源将暂存在此项目，后续可切换至该项目查看同步的资源，',
  '并修改资源归属项目。': '并修改资源归属项目。',
  '项目名称长度最长61个字符': '项目名称长度最长61个字符',
  '资源纳管项目中文名': '资源纳管项目中文名',
  '项目中文名长度最长64个字符': '项目中文名长度最长64个字符',
  '资源纳管项目备注': '资源纳管项目备注',
  '项目备注长度最长64个字符': '项目备注长度最长64个字符',
  '请填写Access Key ID！': '请填写Access Key ID！',
  '请填写Access Key Secret！': '请填写Access Key Secret！',
  '请填写资源纳管项目名称！': '请填写资源纳管项目名称！',
  '云账号添加成功！': '云账号添加成功！',
  '云账号编辑成功！': '云账号编辑成功！',
  '同步操作开始！': '同步操作开始！',
  '校验成功！': '校验成功！',
  'AccessKey管理': 'AccessKey管理',
  '同步概况': '同步概况',
  '同步开始时间': '同步开始时间',
  '同步结束时间': '同步结束时间',
  '同步人': '同步人',
  '同步成功': '同步成功',
  '同步失败': '同步失败',
  '请注意！': '请注意！',
  '一次只能启用一个AccessKey，请在启用新的AccessKey前，禁用正在使用的AccessKey。': '一次只能启用一个AccessKey，请在启用新的AccessKey前，禁用正在使用的AccessKey。',
  '网卡多队列': '网卡多队列',
  '目标网端口长度为1-80！': '目标网端口长度为1-80！',
  '端口为any时请勿写入其他端口号': '端口为any时请勿写入其他端口号',
  '端口范围为1-65535！': '端口范围为1-65535！',
  '端口号不可重复！': '端口号不可重复！',
  '目标端口和目标ip不可同时为any！': '目标端口和目标ip不可同时为any！',
  'EIP端口及内网端口长度为1-80！': 'EIP端口及内网端口长度为1-80！',
  '不支持any，支持多IP和CIDR（英文逗号隔开），IP长度为：1～2000': '不支持any，支持多IP和CIDR（英文逗号隔开），IP长度为：1～2000',
  '不支持any，支持多端口（英文逗号隔开）或端口段（用中横线连接），\n示例：（1，3-10，12）；端口长度为：1～1024；端口范围为1～65535': '不支持any，支持多端口（英文逗号隔开）或端口段（用中横线连接），\n示例：（1，3-10，12）；端口长度为：1～1024；端口范围为1～65535',
  'EIP端口与内网端口个数需一致！': 'EIP端口与内网端口个数需一致！',
  '备份策略处于【创建中】状态，【不】允许删除!': '备份策略处于【创建中】状态，【不】允许删除!',
  '空表单无法提交': '空表单无法提交',
  '资源监控': '资源监控',
  '引擎监控': '引擎监控',
  '温馨提示：在云主机回收前，建议先进行文件备份，以免造成损失': '温馨提示：在云主机回收前，建议先进行文件备份，以免造成损失',
  '云账号': '云账号',
  '云账号管理': '云账号管理',
  '云账号名称': '云账号名称',
  '添加云账号': '添加云账号',
  '启用NAS同步': '启用NAS同步',
  '周备份': '周备份',
  '月备份': '月备份',
  '常规备份': '常规备份',
  '备份中': '备份中',
  '已复制至剪切板！': '已复制至剪切板！',
  '请先配置计划名称': '请先配置计划名称',
  '请先配置开始时间': '请先配置开始时间',
  '请先配置备份周期': '请先配置备份周期',
  '请先配置备份类型': '请先配置备份类型',
  '请先配置备份周期具体天数': '请先配置备份周期具体天数',
  '增量式备份': '增量式备份',
  '用户备份':'用户备份',
  '用户存档': '用户存档',
  '累积增量式备份': '累积增量式备份',
  '事务日志备份': '事务日志备份',
  '恢复成功': '恢复成功',
  '部分恢复成功': '部分恢复成功',
  '创建恢复任务': '创建恢复任务',
  '当前策略无备份记录可恢复': '当前策略无备份记录可恢复',
  '确定禁用备份策略吗?': '确定禁用备份策略吗?',
  '当前状态不能编辑':'当前状态不能编辑',
  '确定立即执行备份任务吗?':'确定立即执行备份任务吗?',
  '请输入恢复名称': '请输入恢复名称',
  '请选择需要恢复的备份记录': '请选择需要恢复的备份记录',
  '请选择目标nas卷名称': '请选择目标nas卷名称',
  'NAS 详情': 'NAS 详情',
  '创建NAS策略备份': '创建NAS策略备份',
  '添加备份NAS': '添加备份NAS',
  '有效nas卷': '有效nas卷',
  '请先配置恢复记录名称': '请先配置恢复记录名称',
  '请先选择恢复的目标nas名称': '请先选择恢复的目标nas名称',
  '多云管理': '多云管理',
  '温馨提示：Flavor规则配置修改会重启数据库实例,请评估业务影响范围,选择合适时间窗口变更,谨慎操作。': '温馨提示：Flavor规则配置修改会重启数据库实例,请评估业务影响范围,选择合适时间窗口变更,谨慎操作。',
  '正在查询价格': '正在查询价格',
  '修改后：': '修改后：',
  '修改前：': '修改前：',
  '磁盘扩容': '磁盘扩容',
  '当前磁盘容量已为最大值！': '当前磁盘容量已为最大值！',
  '请先选择Flavor规格！': '请先选择Flavor规格！',
  '修改配置成功！': '修改配置成功！',
  '请至少扩容50GB！': '请至少扩容50GB！',
  '磁盘扩容成功！': '磁盘扩容成功！',
  '申请理由最长1000字符': '申请理由最长1000字符',
  '备注最长1000字符': '备注最长1000字符',
  '插件管理': '插件管理',
  '可用插件': '可用插件',
  '插件名': '插件名',
  '插件名称': '插件名称',
  '默认版本': '默认版本',
  '当前版本': '当前版本',
  '安装': '安装',
  '该【': '该【',
  '】插件?': '】插件?',
  '安装插件成功！': '安装插件成功！',
  '卸载插件成功！': '卸载插件成功！',
  '同步详情': '同步详情',
  'NAS还原': 'NAS还原',
  '当前用户已解锁 !': '当前用户已解锁 !',
  '当前用户已被锁定 !': '当前用户已被锁定 !',
  '云账号详情': '云账号详情',
  '请勾选需要批量操作的资源':'请勾选需要批量操作的资源',
  '主机配置':'主机配置',
  '主机IP':'主机IP',
  '选择云环境':'选择云环境',
  '请选择需要同步的区域，将其添加到平台中进行资源同步':'请选择需要同步的区域，将其添加到平台中进行资源同步',
  '账号设置':'账号设置',
  '公有云项目设置':'公有云项目设置',
  '选择同步区域':'选择同步区域',
  '请输入描述':'请输入描述',
  '请输入云账号名称':'请输入云账号名称',
  '同步区域管理':'同步区域管理',
  '区域名称':'区域名称',
  '待选择区域':'待选择区域',
  '已选择区域':'已选择区域',
  '确定要移除【':'确定要移除【',
  '自定义权限': '自定义权限',
  '自定义标签': '自定义标签',
  '权限列表': '权限列表',
  '自定义权限不能为空！': '自定义权限不能为空！',
  '自定义用户': '自定义用户',
  '权限更新成功！': '权限更新成功！',
  '默认表空间': '默认表空间',
  '临时表空间': '临时表空间',
  'data盘总容量：':'data盘总容量：',
  '所有表空间已占容量：': '所有表空间已占容量：',
  '表空间类型：': '表空间类型：',
  '表空间大小：': '表空间大小：',
  '配额类型：': '配额类型：',
  '表空间名称': '表空间名称',
  '表空间类型': '表空间类型',
  '已用容量(GB)': '已用容量(GB)',
  '用户配额': '用户配额',
  '表空间': '表空间',
  '请填写表空间名称': '请填写表空间名称',
  '数据表空间': '数据表空间',
  '修改用户配额': '修改用户配额',
  '不限配额': '不限配额',
  '取消配额': '取消配额',
  '表空间名由字母开头，小写字母，数字、下划线组成， 字母或数字结尾，最长30个字符': '表空间名由字母开头，小写字母，数字、下划线组成， 字母或数字结尾，最长30个字符',
  '请选择表空间类型': '请选择表空间类型',
  '表空间创建成功！': '表空间创建成功！',
  '扩容成功！': '扩容成功！',
  '请选择需要配置的用户名': '请选择需要配置的用户名',
  '请选择配额类型': '请选择配额类型',
  '配额修改成功！': '配额修改成功！',
  '认证': '认证',
  '有': '有',
  '请先填写kafka集群!': '请先填写kafka集群!',
  '集群地址': '集群地址',
  '账号需要具备SELECT, REPLICATION SLAVE, REPLICATION CLIENT权限。': '账号需要具备SELECT, REPLICATION SLAVE, REPLICATION CLIENT权限。',
  '账号需要具备 SELECT,INSERT, CREATE, SUPER, DROP, ALTER, EXECUTE, CREATE VIEW, CREATE ROUTINE, ALTER ROUTINE, EVENT, TRIGGER权限。': '账号需要具备 SELECT,INSERT, CREATE, SUPER, DROP, ALTER, EXECUTE, CREATE VIEW, CREATE ROUTINE, ALTER ROUTINE, EVENT, TRIGGER权限。',
  '包年包月<br/>包年包月是一种先付费后使用的计费方式，这种方式适用于提前预估设备需求量的场景。您可以通过包年包月的模式提前预留资源，享受更大的价格优惠，更大程度降低您的支出。': '包年包月<br/>包年包月是一种先付费后使用的计费方式，这种方式适用于提前预估设备需求量的场景。您可以通过包年包月的模式提前预留资源，享受更大的价格优惠，更大程度降低您的支出。',
  '按量计费<br/>按量付费是一种先使用后付费的计费方式。通过按量付费，您无需提前购买大量资源，可以按需开通和释放资源，减少资源浪费，大幅降低实例使用成本。': '按量计费<br/>按量付费是一种先使用后付费的计费方式。通过按量付费，您无需提前购买大量资源，可以按需开通和释放资源，减少资源浪费，大幅降低实例使用成本。',
  '云环境是指能够从动态虚拟化的资源池中向您按需提供计算能力、存储能力或者虚拟机服务等的互联网或者大数据环境。<br/>为了让您更好地享受云服务请您选择招商云环境，如招商云没有您所需的资源，您可选择其它云环境。': '云环境是指能够从动态虚拟化的资源池中向您按需提供计算能力、存储能力或者虚拟机服务等的互联网或者大数据环境。<br/>为了让您更好地享受云服务请您选择招商云环境，如招商云没有您所需的资源，您可选择其它云环境。',
  '区域指的是 ECS 实例所在的物理位置。<br/>招商云的服务器托管分布在多个位置，由不同的区域构成。每个区域都指一个独立的物理数据中心，不同区域的实例之间内网互不相通；您可以选择距离您客户最近的区域来降低网络时延、提高您客户的访问速度。': '区域指的是 ECS 实例所在的物理位置。<br/>招商云的服务器托管分布在多个位置，由不同的区域构成。每个区域都指一个独立的物理数据中心，不同区域的实例之间内网互不相通；您可以选择距离您客户最近的区域来降低网络时延、提高您客户的访问速度。',
  '可用区是指在同一区域内，电力和网络互相独立的物理区域。<br/>每个可用区都是独立的，同一可用区内的 ECS 实例网络延时更小。在同一区域内可用区与可用区之间内网互通，可用区之间能做到故障隔离。是否将云服务器 ECS 实例放在同一可用区内，主要取决于对容灾能力和网络延时的要求。如果您的应用需要较高的容灾能力，建议您将云服务器ECS实例部署在同一区域的不同可用区内。如果您的应用在实例之间需要较低的网络时延，则建议您将 ECS 实例创建在相同的可用区内。可用区是指在同一区域内，电力和网络互相独立的物理区域。': '可用区是指在同一区域内，电力和网络互相独立的物理区域。<br/>每个可用区都是独立的，同一可用区内的 ECS 实例网络延时更小。在同一区域内可用区与可用区之间内网互通，可用区之间能做到故障隔离。是否将云服务器 ECS 实例放在同一可用区内，主要取决于对容灾能力和网络延时的要求。如果您的应用需要较高的容灾能力，建议您将云服务器ECS实例部署在同一区域的不同可用区内。如果您的应用在实例之间需要较低的网络时延，则建议您将 ECS 实例创建在相同的可用区内。可用区是指在同一区域内，电力和网络互相独立的物理区域。',
  '公共镜像<br/>是由招商云官方或第三方合作商家提供的标准操作系统镜像，仅包括初始系统环境。请您根据实际情况自助配置应用环境或相关软件。': '公共镜像<br/>是由招商云官方或第三方合作商家提供的标准操作系统镜像，仅包括初始系统环境。请您根据实际情况自助配置应用环境或相关软件。',
  '自定义镜像<br/>基于实例创建的系统模板，包括初始系统环境、应用环境和相关软件配置。您可使用自定义镜像快速批量地创建云服务器，节省重复配置的时间。': '自定义镜像<br/>基于实例创建的系统模板，包括初始系统环境、应用环境和相关软件配置。您可使用自定义镜像快速批量地创建云服务器，节省重复配置的时间。',
  '快照<br/>招商云快照是一种便捷高效的数据容灾手段,您可用于数据备份、制作自定义镜像、应用容灾等。': '快照<br/>招商云快照是一种便捷高效的数据容灾手段,您可用于数据备份、制作自定义镜像、应用容灾等。',
  '数据盘主要用来存储用户数据，分为通用型、高性能型、容量型，您可以按照实际业务需求选择数据盘大小。': '数据盘主要用来存储用户数据，分为通用型、高性能型、容量型，您可以按照实际业务需求选择数据盘大小。',
  '入门型<br/>入门型云主机适用于个人博客、小网站等轻量应用业务。<br/>计算型<br/>适用于数据分析、数据编码解码、批量计算、Web前端、在线实时业务等对计算能力要求较高的业务场景。<br/>内存型<br/>适用于缓存服务、搜索集群、企业级数据库、高性能集群、大数据集群等对内存要求较大的应用场景，您可根据业务需求选择内存大小。<br/>通用型<br/>适用于各类型的网站，绝大多数应用，如企业网站、中小型数据库、缓存、中小型企业业务等性能比较均衡的业务场景。': '入门型<br/>入门型云主机适用于个人博客、小网站等轻量应用业务。<br/>计算型<br/>适用于数据分析、数据编码解码、批量计算、Web前端、在线实时业务等对计算能力要求较高的业务场景。<br/>内存型<br/>适用于缓存服务、搜索集群、企业级数据库、高性能集群、大数据集群等对内存要求较大的应用场景，您可根据业务需求选择内存大小。<br/>通用型<br/>适用于各类型的网站，绝大多数应用，如企业网站、中小型数据库、缓存、中小型企业业务等性能比较均衡的业务场景。',
  'x86计算<br/>x86计算具有资源独享，稳定性较高的特点，适用于绝大部分用户的上云场景，一般用户在选择招商云服务器实例规格都会基于x86计算架构进行选择。<br/>GPU计算<br/>GPU计算比传统CPU效率更高，具有实时高速、低延迟，计算能力强大等特点，价格高于x86计算架构，适用于高性能计算、图形渲染、视频解码、深度学习、科学计算等应用场景。': 'x86计算<br/>x86计算具有资源独享，稳定性较高的特点，适用于绝大部分用户的上云场景，一般用户在选择招商云服务器实例规格都会基于x86计算架构进行选择。<br/>GPU计算<br/>GPU计算比传统CPU效率更高，具有实时高速、低延迟，计算能力强大等特点，价格高于x86计算架构，适用于高性能计算、图形渲染、视频解码、深度学习、科学计算等应用场景。',
  '招商云私有网络（Virtual Private Cloud，VPC）是您在招商云上自定义的逻辑隔离网络空间，您可以完全掌握私有网络环境，包括选择IP地址范围、自定义网段划分、和路由策略等。您可以在自己定义的专有网络中使用云资源如云主机、云数据库、NAT网关和负载均衡等。': '招商云私有网络（Virtual Private Cloud，VPC）是您在招商云上自定义的逻辑隔离网络空间，您可以完全掌握私有网络环境，包括选择IP地址范围、自定义网段划分、和路由策略等。您可以在自己定义的专有网络中使用云资源如云主机、云数据库、NAT网关和负载均衡等。',
  '部署单元是指控制一组云主机分布在指定项目及可用区内不同计算节点上的策略，以此保证业务的高可用性和底层容灾能力。': '部署单元是指控制一组云主机分布在指定项目及可用区内不同计算节点上的策略，以此保证业务的高可用性和底层容灾能力。',
  '专有宿主机 (Dedicated Host Service, CDH) 是招商云提供的云专有宿主机服务，这是一种物理资源独享、配置灵活、安全且专有的宿主机服务，支持按需购买、按量付费、灵活配置超分比，可以极度压榨物理机的资源，切实降低您的单实例部署成本。使用云专有宿主机，您无需再与其他租户争抢资源，可在其上灵活创建、管理多种规格的独享型云主，且可获得更高的安全性，满足更严格的合规和监管要求。': '专有宿主机 (Dedicated Host Service, CDH) 是招商云提供的云专有宿主机服务，这是一种物理资源独享、配置灵活、安全且专有的宿主机服务，支持按需购买、按量付费、灵活配置超分比，可以极度压榨物理机的资源，切实降低您的单实例部署成本。使用云专有宿主机，您无需再与其他租户争抢资源，可在其上灵活创建、管理多种规格的独享型云主，且可获得更高的安全性，满足更严格的合规和监管要求。',
  '子网是每个VPC内的IP地址块，VPC中的所有云资源都必须部署在子网内。同一个VPC下,子网网段不可重复。子网创建成功后,网段无法修改。': '子网是每个VPC内的IP地址块，VPC中的所有云资源都必须部署在子网内。同一个VPC下,子网网段不可重复。子网创建成功后,网段无法修改。',
  '基础版:适用于开发、测试、预发布、容灾环境；<br>高可用版:适用于生产环境':'基础版:适用于开发、测试、预发布、容灾环境；<br>高可用版:适用于生产环境',
  '请合理评估您所需的硬盘大小，避免资源浪费。': '请合理评估您所需的硬盘大小，避免资源浪费。',
  '发起通信的地址': '发起通信的地址',
  '接收通信的地址': '接收通信的地址',
  '访问目的地址的端口号': '访问目的地址的端口号',
  '通信双方所使用的网络协议': '通信双方所使用的网络协议',
  '您在存储数据到表中的时候所用到的字符集,不同字符集编码格式不同。': '您在存储数据到表中的时候所用到的字符集,不同字符集编码格式不同。',
  '下载请求发送成功': '下载请求发送成功',
  '请耐心等待！': '请耐心等待！',
  '迁移结果报表': '迁移结果报表',
  '引擎类型': '引擎类型',
  '分片数': '分片数',
  '副本数': '副本数',
  '配额状态未修改': '配额状态未修改',
  '当前配额为【不限配额】，请进行配额修改再提交': '当前配额为【不限配额】，请进行配额修改再提交',
  '当前配额为【取消配额】，请进行配额修改再提交': '当前配额为【取消配额】，请进行配额修改再提交',
  '当前表空间容量：': '当前表空间容量：',
  '用户已分配配额总量：': '用户已分配配额总量：',
  '表空间容量：': '表空间容量：',
  '用戶名由字母開頭，小寫字母，數字、下劃線組成， 字母或數字結尾，最長30個字符': '用戶名由字母開頭，小寫字母，數字、下劃線組成， 字母或數字結尾，最長30個字符',
  'M内存': 'M內存',
  '仅允许批量编辑同账号下的公有云主机！': '仅允许批量编辑同账号下的公有云主机！',
  '当日申请的SNAT和DNAT，将在次日00:10开始下发': '当日申请的SNAT和DNAT，将在次日00:10开始下发',
  '权重': '权重',
  '请先配置服务器权重!': '请先配置服务器权重',
  '请填写【长度为1-60个英文或中文字符，必须以字母或汉字开头,可包含数字,点号(.),下划线(_)和短横线(-)】': '请填写【长度为1-60个英文或中文字符，必须以字母或汉字开头,可包含数字,点号(.),下划线(_)和短横线(-)】',
  '深度归档型': '深度归档型',
  '自定义类型': '自定义类型',
  '权重可配置范围在0-100!': '权重可配置范围在0-100!',
  '请选择子网信息 !': '请选择子网信息 !',
  '仅允许批量编辑同账号下的公有云资源！': '仅允许批量编辑同账号下的公有云资源！',
  '公有云暂不支持此操作！': '公有云暂不支持此操作！',
  '用户名长度最长30个字符！': '用户名长度最长30个字符！',
  '当前状态为【创建中】, 不支持用户创建': '当前状态为【创建中】, 不支持用户创建',
  '请填写存储桶名称信息 !': '请填写存储桶名称信息 !',
  '当前选项下暂无相关存储类型，请修改配置': '当前选项下暂无相关存储类型，请修改配置',
  '请选择访问权限!': '请选择访问权限!',
  '请修改配置': '请修改配置',
  '当前选项下暂无相关存储类型!': '当前选项下暂无相关存储类型!',
  '升级后：': '升级后：',
  '升级前：': '升级前：',
  '请至少扩容100G！': '请至少扩容100G！',
  '数据磁盘至少扩容70G！': '数据磁盘至少扩容70G！',
  '归档磁盘至少扩容30G！': '归档磁盘至少扩容30G！',
  '非测试环境防火墙策略，在完成审批流程后才会在当天18:00后开始真正下发。': '非测试环境防火墙策略，在完成审批流程后才会在当天18:00后开始真正下发。',
  '暂存': '暂存',
  '主出口IP':'主出口IP',
  '备出口IP':'备出口IP',
  '已选择云主机：': '已选择云主机：',
  '云盘名称': '云盘名称',
  '共享云盘': '共享云盘',
  '添加授权主机': '添加授权主机',
  '选择授权的主机': '选择授权的主机',
  '请先选择需要授权的主机！': '请先选择需要授权的主机！',
  '请先选择需要筛选的类型': '请先选择需要筛选的类型',
  '主机授权成功！': '主机授权成功！',
  '请输入要搜索的主机IP': '请输入要搜索的主机IP',
  '请输入要搜索的主机名称': '请输入要搜索的主机名称',
  '解除授权主机': '解除授权主机',
  '选择要解除授权的主机': '选择要解除授权的主机',
  '主机解除授权成功！': '主机解除授权成功！',
  '共享云盘详情': '共享云盘详情',
  '授权列表': '授权列表',
  '解除挂载': '解除挂载',
  '扩容记录': '扩容记录',
  '原大小(GB)': '原大小(GB)',
  '扩容后大小(GB)': '扩容后大小(GB)',
  '确定挂载【': '确定挂载【',
  '】吗?': '】吗?',
  '确定解除挂载【': '确定解除挂载【',
  '主机挂载成功!': '主机挂载成功!',
  '主机解除挂载成功!': '主机解除挂载成功!',
  '请输入共享云盘名称': '请输入共享云盘名称',
  '温馨提示：挂载前请确认主机能识别共享云盘，否则可能会导致创建共享云盘失败，具体操作查看': '温馨提示：挂载前请确认主机能识别共享云盘，否则可能会导致创建共享云盘失败，具体操作查看',
  '帮助文档': '帮助文档',
  '主机ECS': '主机ECS',
  '云盘大小(GB)': '云盘大小(GB)',
  '共享云盘购买': '共享云盘购买',
  '请选则协议': '请选则协议',
  '请选则操作系统': '请选则操作系统',
  '容量平台': '容量平台',
  '主机视图': '主机视图',
  '项目视图': '项目视图',
  '数据库视图': '数据库视图',
  '存储视图': '存储视图',
  '当前可用区暂不支持此功能！': '当前可用区暂不支持此功能！',
  '校验': '校验',
  '取消授权': '取消授权',
  '共享云盘进行读写时禁止取消授权，取消授权前要取消挂载。': '共享云盘进行读写时禁止取消授权，取消授权前要取消挂载。',
  '单选': '单选',
  'windows主机请查看ecsadmin密码。':'windows主机请查看ecsadmin密码。',
  'linux主机请查看rhlog的密码。':'linux主机请查看rhlog的密码。',
  'root不支持linux系统直接登录。':'root不支持linux系统直接登录。',
  '请更换协议或监听端口': '请更换协议或监听端口',
  'udp协议暂不支持对端口4789的监听': 'udp协议暂不支持对端口4789的监听',
  '点击跳转指定文件夹': '点击跳转指定文件夹',
  '当前目录OSS': '当前目录OSS',
  '创建文件夹': '创建文件夹',
  '文件夹名': '文件夹名',
  '请输入文件夹名称': '请输入文件夹名称',
  '文件上传成功': '文件上传成功',
  '文件正在下载，请耐心等待': '文件正在下载，请耐心等待',
  '文件夹创建成功': '文件夹创建成功',
  '当前文件类型为': '当前文件类型为',
  '暂不支持下载': '暂不支持下载',
  '文件夹命名规范：': '文件夹命名规范：',
  '1、不能以"/","\"开头': '1、不能以"/","\"开头',
  '2、不能以".."为目录名': '2、不能以".."为目录名',
  '3、不允许出现连续的"//"字符': '3、不允许出现连续的"//"字符',
  '4、可使用"/"分割路径，创建多级目录': '4、可使用"/"分割路径，创建多级目录',
  '5、总长度控制在1~254个字符': '5、总长度控制在1~254个字符',
  '请输入符合规范的文件夹名称': '请输入符合规范的文件夹名称',
  'Server类型': 'Server类型',
  'Server配置': 'Server配置',
  '高可用': '高可用',
  'FTP Server创建命令发送成功！': 'FTP Server创建命令发送成功！',
  '创建FTP Server': '创建FTP Server',
  'FTP 存储网关详情': 'FTP 存储网关详情',
  '关联OSS': '关联OSS',
  'oss名称': 'oss名称',
  '关联时间': '关联时间',
  '解绑OSS': '解绑OSS',
  '添加账户': '添加账户',
  '账号名称': '账号名称',
  '删除文件操作': '删除文件操作',
  'OSS桶': 'OSS桶',
  '6-8位字符': '6-8位字符',
  '大小写字母、数字、特殊字符,特殊字符为-_.*': '大小写字母、数字、特殊字符,特殊字符为-_.*',
  'Server名称': 'Server名称',
  'FTP Server端口': 'FTP Server端口',
  '请选择OSS桶！': '请选择OSS桶！',
  '关联OSS成功！': '关联OSS成功！',
  '解绑OSS成功！': '解绑OSS成功！',
  '添加账户成功！': '添加账户成功！',
  '密码查询成功！': '密码查询成功！',
  '删除账户成功！': '删除账户成功！',
  'Server 端口': 'Server 端口',
  '重启Server': '重启Server',
  'FTP 存储网关': 'FTP 存储网关',
  'FTP 存储网关服务关联OSS，需要绑定在同一可用区的存储桶。若需要购买请点击购买': 'FTP 存储网关服务关联OSS，需要绑定在同一可用区的存储桶。若需要购买请点击购买',
  '请确认已解绑存储桶，删除后将解绑存储桶。': '请确认已解绑存储桶，删除后将解绑存储桶。',
  '请输入3~16个字符，支持数字、大小写字母、点、中横线、下划线': '请输入3~16个字符，支持数字、大小写字母、点、中横线、下划线',
  '编辑FTP Server成功！': '编辑FTP Server成功！',
  '确定重启该【': '确定重启该【',
  '】服务?': '】服务?',
  '重启服务成功！': '重启服务成功！',
  '确定停止该【': '确定停止该【',
  '停止服务成功！': '停止服务成功！',
  '启动服务成功！': '启动服务成功！',
  '是否允许删除文件操作': '是否允许删除文件操作',
  '删除账号后，用户将无法登录，重启FTP Server后生效': '删除账号后，用户将无法登录，重启FTP Server后生效',
  '重置密码在重启FTP Server后生效': '重置密码在重启FTP Server后生效',
  '关联OSS在重启FTP Server后生效': '关联OSS在重启FTP Server后生效',
  '添加账户在重启FTP Server后生效': '添加账户在重启FTP Server后生效',
  '解绑OSS在重启FTP Server后生效': '解绑OSS在重启FTP Server后生效',
  '修改配置在重启FTP Server后生效': '修改配置在重启FTP Server后生效',
  '共享云盘购买成功 !': '共享云盘购买成功 !',
  '已授权或挂载共享云盘列表': '已授权或挂载共享云盘列表',
  '销毁云主机后共享云盘会自动卸载并取消授权': '销毁云主机后共享云盘会自动卸载并取消授权',
  '共享云盘名称': '共享云盘名称',
  '源端主机名称':'源端主机名称',
  '服务提供商':'服务提供商',
  '目的端主机IP':'目的端主机IP',
  '创建迁移任务':'创建迁移任务',
  '选择迁移配置':'选择迁移配置',
  '是否覆盖同名文件':'是否覆盖同名文件',
  '目的端云主机名称':'目的端云主机名称',
  '源端文件链接':'源端文件链接',
  '源系统密码':'源系统密码',
  '迁移目的端信息':'迁移目的端信息',
  '制作源端主机镜像':'制作源端主机镜像',
  '将迁移源端的云主机创建成镜像' :'将迁移源端的云主机创建成镜像',
  '查看制作镜像帮助文档':'查看制作镜像帮助文档',
  '创建源端OSS':'创建源端OSS',
  '购买源端OSS产品':'购买源端OSS产品',
  '上传文件至源端OSS':'上传文件至源端OSS',
  '将镜像文件上传至源端OSS':'将镜像文件上传至源端OSS',
  '创建目的端OSS':'创建目的端OSS',
  '购买招商云的OSS产品':'购买招商云的OSS产品',
  '请填写正确的阿里云源端文件链接!':'请填写正确的阿里云源端文件链接',
  '请填写正确的腾讯云源端文件链接!':'请填写正确的腾讯云源端文件链接!',
  '请填写正确的招商云源端文件链接!':'请填写正确的招商云源端文件链接!',
  '请在使用堡垒机前操作纳管云主机！': '请在使用堡垒机前操作纳管云主机！',
  '修改owner成功！': '修改owner成功！',
  '修改owner': '修改owner',
  '账号列表': '账号列表',
  '节点数': '节点数',
  '最大连接数': '最大连接数',
  '最大iops': '最大iops',
  '规格名称': '规格名称',
  '腾讯云暂不支持创建账户！': '腾讯云暂不支持创建账户！',
  '存储引擎': '存储引擎',
  '需全局唯一，不能与已有的任何桶名称重复':'需全局唯一，不能与已有的任何桶名称重复',
  '数据库迁移DTS 操作指南': '数据库迁移DTS 操作指南',
  '数据库迁移 DTS': '数据库迁移 DTS',
  '源端数据库版本': '源端数据库版本',
  '文件至数据库迁移详情': '文件至数据库迁移详情',
  '迁移进度': '迁移进度',
  '购买数据库实例': '购买数据库实例',
  '调用CAE建用户': '调用CAE建用户',
  '购买NAS,挂载NAS': '购买NAS,挂载NAS',
  '下载文件': '下载文件',
  '解压文件': '解压文件',
  '执行导入命令': '执行导入命令',
  '源端实例类型': '源端实例类型',
  'NAS ID': 'NAS ID',
  '文件总大小': '文件总大小',
  '请输入任务名': '请输入任务名',
  '数据库版本': '数据库版本',
  '备份级别': '备份级别',
  '选购目标库': '选购目标库',
  '当前数据库版本不支持，请选择其他版本': '当前数据库版本不支持，请选择其他版本',
  '选择对象存储': '选择对象存储',
  '存储桶可用容量': '存储桶可用容量',
  '温馨提示：若需要': '温馨提示：若需要',
  '购买新对象存储': '购买新对象存储',
  '，请先暂存任务再购买': '，请先暂存任务再购买',
  '已上传文件列表：': '已上传文件列表：',
  '当前文件不存在，请重新上传或删除': '当前文件不存在，请重新上传或删除',
  '请至少填写至选购目标库的项目，可将此条任务暂时保存': '请至少填写至选购目标库的项目，可将此条任务暂时保存',
  '可将此条任务暂时保存': '可将此条任务暂时保存',
  '文件迁移': '文件迁移',
  'IDC自建数据库': 'IDC自建数据库',
  '实例级别': '实例级别',
  'SCHEMA级别': 'SCHEMA级别',
  '公有云暂不支持': '公有云暂不支持',
  '请输入任务名！': '请输入任务名！',
  '任务名由字母，数字、下划线与中划线组成、字母或数字开头，最长64个字符': '任务名由字母，数字、下划线与中划线组成、字母或数字开头，最长64个字符',
  '请选择实例类型！': '请选择实例类型！',
  '请选择数据库类型！': '请选择数据库类型！',
  '请选择数据库版本！': '请选择数据库版本！',
  '请选择备份类型！': '请选择备份类型！',
  '请选择备份级别！': '请选择备份级别！',
  '请选择字符集！': '请选择字符集！',
  '请选择块大小！': '请选择块大小！',
  '实例名称规则': '实例名称规则',
  '由字母开头，小写字母和数字组成，最长为128个字符': '由字母开头，小写字母和数字组成，最长为128个字符',
  '校验异常': '校验异常',
  '任务名重复或数据库版本异常，请查看页面红色文字提示！': '任务名重复或数据库版本异常，请查看页面红色文字提示！',
  '请先选择对象存储桶！': '请先选择对象存储桶！',
  '文件类型有误': '文件类型有误',
  '请输入任务名，再暂存': '请输入任务名，再暂存',
  '请选择实例类型，再暂存': '请选择实例类型，再暂存',
  '请选择数据库类型，再暂存': '请选择数据库类型，再暂存',
  '请选择数据库版本，再暂存': '请选择数据库版本，再暂存',
  '请选择备份类型，再暂存': '请选择备份类型，再暂存',
  '请选择备份级别，再暂存': '请选择备份级别，再暂存',
  '请选择字符集，再暂存': '请选择字符集，再暂存',
  '请选择块大小，再暂存': '请选择块大小，再暂存',
  '当前内容已暂存！': '当前内容已暂存！',
  '支持上传的文件类型:': '支持上传的文件类型',
  '文件正在上传中，暂不能启动！': '文件正在上传中，暂不能启动！',
  '当前未上传文件！': '当前未上传文件！',
  '请先上传文件再启动！': '请先上传文件再启动！',
  '目前仅支持单个zip文件,或多个zip分卷': '目前仅支持单个zip文件,或多个zip分卷',
  '文件总容量：': '文件总容量：',
  '数据库至数据库迁移': '数据库至数据库迁移',
  '文件至数据库迁移': '文件至数据库迁移',
  '数据库迁移': '数据库迁移',
  '文件已上传至存储桶，若需要重新选择存储桶，请先删除已上传文件再选择': '文件已上传至存储桶，若需要重新选择存储桶，请先删除已上传文件再选择',
  '成本优化分析': '成本优化分析',
  '查看优化策略': '查看优化策略',
  '优化对象': '优化对象',
  '优化费用': '优化费用',
  '优化前月费用': '优化前月费用',
  '优化后月费用': '优化后月费用',
  '可节省费用': '可节省费用',
  '优化建议': '优化建议',
  '建议优化资源列表': '建议优化资源列表',
  '忽略优化资源列表': '忽略优化资源列表',
  '优化策略': '优化策略',
  '适用资源': '适用资源',
  '闲置资源预测': '闲置资源预测',
  'CPU使用率Max值小于5%，并且内存使用率Max值小于10%，建议降配或释放。': 'CPU使用率Max值小于5%，并且内存使用率Max值小于10%，建议降配或释放。',
  '未绑定到ECS主机的块存储，建议释放。': '未绑定到ECS主机的块存储，建议释放。',
  '未绑定到ECS云主机的弹性IP，建议释放。': '未绑定到ECS云主机的弹性IP，建议释放。',
  '超配资源预测': '超配资源预测',
  'CPU使用率Max值小于30%或内存使用率Max值小于30%，建议降配。': 'CPU使用率Max值小于30%或内存使用率Max值小于30%，建议降配。',
  '资源扩容预测': '资源扩容预测',
  'CPU使用率Max值大于80%或内存使用率Max值大于80%，建议升配。': 'CPU使用率Max值大于80%或内存使用率Max值大于80%，建议升配。',
  '优化前': '优化前',
  '优化后': '优化后',
  '已节约': '已节约',
  '混合云资源概览': '混合云资源概览',
  '其他数据库': '其他数据库',
  '云主机概况': '云主机概况',
  '新建云主机ECS概况': '新建云主机ECS概况',
  '柱状图': '柱状图',
  '折线图': '折线图',
  '云主机使用概况': '云主机使用概况',
  '云数据库总数': '云数据库总数',
  '私有云资源概览': '私有云资源概览',
  '计算资源概览': '计算资源概览',
  '云主机配置运行情况': '云主机配置运行情况',
  '云主机系统运行情况': '云主机系统运行情况',
  '数据库资源概览': '数据库资源概览',
  '数据库总数': '数据库总数',
  '数据库分布': '数据库分布',
  '阿里云资源概览': '阿里云资源概览',
  '腾讯云资源概览': '腾讯云资源概览',
  '华为云资源概览': '华为云资源概览',
  '招商云资源概览': '招商云资源概览',
  '招商私有云数据库资源概览': '招商私有云数据库资源概览',
  '数据库总数(台)': '数据库总数(台)',
  '招商私有云数据库类型': '招商私有云数据库类型',
  '公有云云硬盘资源概览': '公有云云硬盘资源概览',
  '招商公有云数据库概览': '招商公有云数据库概览',
  '可优化总数': '可优化总数',
  '建议释放': '建议释放',
  '建议降配': '建议降配',
  '建议升配': '建议升配',
  '忽略优化': '忽略优化',
  '请输入忽略原因!(不超过200字)': '请输入忽略原因!(不超过200字)',
  '确定对': '确定对',
  '变化后成本': '变化后成本',
  '当前成本': '当前成本',
  '建议配置': '建议配置',
  '子网总数': '子网总数',
  '云主机总数': '云主机总数',
  '总数': '总数',
  '云硬盘总数': '云硬盘总数',
  '总运行数': '总运行数',
  '环境': '环境',
  '云主机(台)': '云主机(台)',
  '数据库实例': '数据库实例',
  '费用信息': '费用信息',
  '当月费用': '当月费用',
  '昨日总费用': '昨日总费用',
  '上月总费用': '上月总费用',
  '本月总费用（预估）': '本月总费用（预估）',
  '本月当前已产生费用': '本月当前已产生费用',
  '环比上月': '环比上月',
  '总费用趋势': '总费用趋势',
  '消费': '消费',
  '温馨提示：目前招商云平台暂不支持Oracle、PostgreSQL自助备份功能，如需申请备份数据库数据或日志，请': '温馨提示：目前招商云平台暂不支持Oracle、PostgreSQL自助备份功能，如需申请备份数据库数据或日志，请',
  '温馨提示：目前招商云平台暂不支持MongoDB自助备份功能，如需申请备份数据库数据或日志，请': '温馨提示：目前招商云平台暂不支持MongoDB自助备份功能，如需申请备份数据库数据或日志，请',
  '到存储组人工处理。': '到存储组人工处理。',
  '建设背景': '建设背景',
  '系统介绍': '系统介绍',
  '上线时间': '上线时间',
  '部署方式': '部署方式',
  'SLA要求': 'SLA要求',
  '采购情况': '采购情况',
  '目前状态': '目前状态',
  '附件': '附件',
  '需上传项目架构图、立项说明等材料': '需上传项目架构图、立项说明等材料',
  '配置审批人': '配置审批人',
  '部门长': '部门长',
  '手动输入': '手动输入',
  '是否使用公有云资源': '是否使用公有云资源',
  '选择您要使用的公有云：': '选择您要使用的公有云：',
  '总台数：': '总台数：',
  '台': '台',
  '总CPU：': '总CPU：',
  '总内存：': '总内存：',
  '总个数：': '总个数：',
  '总大小：': '总大小：',
  '总实例：': '总实例：',
  '设置项目信息': '设置项目信息',
  '配置公有云资源需求': '配置公有云资源需求',
  '请填写中文名！': '请填写中文名！',
  '请选择项目负责人！': '请选择项目负责人！',
  '请填写建设背景！': '请填写建设背景！',
  '请填写系统介绍！': '请填写系统介绍！',
  '请上传附件！': '请上传附件！',
  '请选择/填写部门长！': '请选择/填写部门长！',
  '请选择/填写CDO！': '请选择/填写CDO！',
  '请检查输入！': '请检查输入！',
  '创建成功！': '创建成功！',
  '公有云资源配额': '公有云资源配额',
  '已用：': '已用：',
  '审批进度': '审批进度',
  '无需审批': '无需审批',
  '审批中': '审批中',
  '审批不通过': '审批不通过',
  '审批成功': '审批成功',
  '扩容审批中': '扩容审批中',
  '扩容审批不通过': '扩容审批不通过',
  '账单周期：': '账单周期：',
  '租户及日期不能为空！': '租户及日期不能为空！',
  '混合云账单总览': '混合云账单总览',
  '开始月份': '开始月份',
  '结束月份': '结束月份',
  '时间范围说明：时间可选择最大范围为12个月，当选择期间超过12个月时，以开始时间的一年为准，': '时间范围说明：时间可选择最大范围为12个月，当选择期间超过12个月时，以开始时间的一年为准，',
  '如：时间期间选择为：2018年1月到2020年10月, 则展示2018年1月到12月的账单数据': '如：时间期间选择为：2018年1月到2020年10月, 则展示2018年1月到12月的账单数据',
  '上升': '上升',
  '下降': '下降',
  '云环境成本趋势图': '云环境成本趋势图',
  '公有云账单概览': '公有云账单概览',
  '选择月': '选择月',
  '本月已消费金额': '本月已消费金额',
  '对比上月': '对比上月',
  '本月预计消费金额': '本月预计消费金额',
  '云帐号成本分析': '云帐号成本分析',
  '资源成本分析': '资源成本分析',
  '近三月': '近三月',
  '堆叠柱状图': '堆叠柱状图',
  '混合云租户账单总览': '混合云租户账单总览',
  '招商云租户账单概览': '招商云租户账单概览',
  '公有云租户账单概览': '公有云租户账单概览',
  '招商云租户账单明细': '招商云租户账单明细',
  '公有云租户账单明细': '公有云租户账单明细',
  '招商云项目账单概览': '招商云项目账单概览',
  '招商云项目账单明细': '招商云项目账单明细',
  'DMS数据管理': 'DMS数据管理',
  '新增实例': '新增实例',
  '输入数据库进行过滤': '输入数据库进行过滤',
  '暂无连接数据…': '暂无连接数据…',
  '请先连接数据库': '请先连接数据库',
  '输入关键字进行过滤': '输入关键字进行过滤',
  '当前数据库': '当前数据库',
  '当前实例名称': '当前实例名称',
  '当前账号': '当前账号',
  '切换账号': '切换账号',
  '当前窗口id': '当前窗口id',
  '注意：当前单次查询结果最多返回1,000条;': '注意：当前单次查询结果最多返回1,000条;',
  '创建表': '创建表',
  '打开表': '打开表',
  '编辑表': '编辑表',
  '删除表': '删除表',
  '对象信息': '对象信息',
  '创建视图': '创建视图',
  '编辑视图': '编辑视图',
  '删除视图': '删除视图',
  '属性值': '属性值',
  '创建语句': '创建语句',
  '数据库类型：': '数据库类型：',
  '数据库实例：': '数据库实例：',
  '请选择数据库实例': '请选择数据库实例',
  '请选择数据库类型': '请选择数据库类型',
  '数据管理DMS': '数据管理DMS',
  '数据库用户名：': '数据库用户名：',
  '密码：': '密码：',
  '温馨提示：切换账号登录会退出当前账号并清理当前账号的所有连接窗口': '温馨提示：切换账号登录会退出当前账号并清理当前账号的所有连接窗口',
  '表': '表',
  '存储过程': '存储过程',
  '请选择一个数据库': '请选择一个数据库',
  '当前数据库下没有表信息': '当前数据库下没有表信息',
  '当前表下没有字段信息': '当前表下没有字段信息',
  '当前表下没有主键': '当前表下没有主键',
  '当前表下没有外键': '当前表下没有外键',
  '当前表下没有唯一键': '当前表下没有唯一键',
  '当前索引下没有字段': '当前索引下没有字段',
  '当前主键下没有字段': '当前主键下没有字段',
  '当前外键下没有字段': '当前外键下没有字段',
  '当前数据库下没有函数信息': '当前数据库下没有函数信息',
  '当前唯一键下没有字段': '当前唯一键下没有字段',
  '当前数据库下没有视图信息': '当前数据库下没有视图信息',
  '当前视图下没有字段信息': '当前视图下没有字段信息',
  '已复制至剪切板': '已复制至剪切板',
  '请选择数据库': '请选择数据库',
  '视图': '视图',
  '函数': '函数',
  '消息': '消息',
  '结果集': '結果集',
  '执行记录': '执行记录',
  '迁移任务详情': '迁移任务详情',
  '子任务阶段': '子任务阶段',
  '源端主机': '源端主机',
  '源端镜像文件链接': '源端镜像文件链接',
  '系统盘大小': '系统盘大小',
  '目的端桶名称': '目的端桶名称',
  '任务信息': '任务信息',
  '进度': '进度',
  '迁移源端信息': '迁移源端信息',
  '请选择数据库用户': '请选择数据库用户',
  '数据库登录': '数据库登录',
  '长度范围为3到63个字符，支持小写字母、数字、中划线（-）、英文句号（.）': '长度范围为3到63个字符，支持小写字母、数字、中划线（-）、英文句号（.）',
  '禁止两个英文句号（.）或英文句号（.）和中划线（-）相邻，禁止以英文句号（.）和中划线（-）开头或结尾。,或多个zip分卷': '禁止两个英文句号（.）或英文句号（.）和中划线（-）相邻，禁止以英文句号（.）和中划线（-）开头或结尾。,或多个zip分卷',
  '禁止使用IP地址。': '禁止使用IP地址。',
  '如果名称中包含英文句号（.），访问桶或对象时可能会进行安全证书校验': '如果名称中包含英文句号（.），访问桶或对象时可能会进行安全证书校验',
  '删除桶或并行文件系统后，需要等待30分钟才能创建同名桶或并行文件系统': '删除桶或并行文件系统后，需要等待30分钟才能创建同名桶或并行文件系统',
  '云迁移': '云迁移',
  '主机迁移': '主机迁移',
  '创建主机': '创建主机',
  '公有云账单明细': '公有云账单明细',
  '云帐号': '云帐号',
  '共享带宽': '共享带宽',
  '带宽名称': '带宽名称',
  '该可用区暂无可用数据库规格购买!': '该可用区暂无可用数据库规格购买!',
  '招商私有云云主机运行情况': '招商私有云云主机运行情况',
  '招商私有云云硬盘运行情况': '招商私有云云硬盘运行情况',
  '跨租户传输': '跨租户传输',
  '审批人导入': '审批人导入',
  '增加审批流程': '增加审批流程',
  '项目审批人': '项目审批人',
  '数字化专员': '数字化专员',
  '请输入手机号、邮箱或域账号，多个账号用英文逗号分隔，最多可输入8个账号': '请输入手机号、邮箱或域账号，多个账号用英文逗号分隔，最多可输入8个账号',
  '请选择项目审批人！': '请选择项目审批人！',
  '请选择数字化专员！': '请选择数字化专员！',
  '请选择CDO！': '请选择CDO！',
  '请使用英文逗号作为分隔符！': '请使用英文逗号作为分隔符！',
  '最多可输入8个账号！': '最多可输入8个账号！',
  '审批人导入成功！': '审批人导入成功！',
  '扩容公有云资源': '扩容公有云资源',
  '扩容公有云资源需求': '扩容公有云资源需求',
  '修改总台数：': '修改总台数：',
  '修改总CPU：': '修改总CPU：',
  '修改总内存：': '修改总内存：',
  '修改总个数：': '修改总个数：',
  '修改总大小：': '修改总大小：',
  '修改总实例：': '修改总实例：',
  '扩容公有云资源配额': '扩容公有云资源配额',
  '扩容公有云资源配额成功！': '扩容公有云资源配额成功！',
  '上传证书': '上传证书',
  '已上传': '已上传',
  '文件': '文件',
  '须由字母、数字、下划线、中划线组成，字母开头，字母或数字结尾': '须由字母、数字、下划线、中划线组成，字母开头，字母或数字结尾',
  '请先填写目标库账号！': '请先填写目标库账号！',
  '请先输入Topic！': '请先输入Topic！',
  '请检查Topic输入格式！': '请检查Topic输入格式！',
  '请上传正确的文件krb5.conf！': '请上传正确的文件krb5.conf！',
  '请上传正确的文件user.keytab！': '请上传正确的文件user.keytab！',
  '只能上传krb5.conf文件，且只可上传一份': '只能上传krb5.conf文件，且只可上传一份',
  '只能上传user.keytab文件，且只可上传一份': '只能上传user.keytab文件，且只可上传一份',
  '字母、数字、下划线、中划线': '字母、数字、下划线、中划线',
  'Topic名称长度为1-249字符！': 'Topic名称长度为1-249字符！',
  'Topic名称由字母、数字、下划线、中划线组成！': 'Topic名称由字母、数字、下划线、中划线组成！',
  '源端表空间': '源端表空间',
  '表空间名长度需2-30个字符': '表空间名长度需2-30个字符',
  '表空间大小不能为空！': '表空间大小不能为空！',
  '由字母开头，小写字母和数字组成，最长为8个字符': '由字母开头，小写字母和数字组成，最长为8个字符',
  '云硬盘(个(GB))': '云硬盘(个(GB))',
  'NAS(个(GB))': 'NAS(个(GB))',
  '当前用户暂无权限跳转gitLab, 请联系gitLab管理员设置相关权限': '当前用户暂无权限跳转gitLab, 请联系gitLab管理员设置相关权限',
  '文件类型:': '文件类型',
  '资源共享': '资源共享',
  '名称：': '名称：',
  '所属项目：': '所属项目：',
  '所属租户：': '所属租户：',
  '未选择项目': '未选择项目',
  '已选择项目': '已选择项目',
  '请选择需要共享使用该资源的项目，未选择的项目则无法共享该资源。': '请选择需要共享使用该资源的项目，未选择的项目则无法共享该资源。',
  '请先上传指定的url!': '请先上传指定的url!',
  '共享指令已发送成功!': '共享指令已发送成功!',
  '行政组织': '行政组织',
  '请选择行政组织！': '请选择行政组织！',
  '共享设置': '共享设置',
  '共享项目': '共享项目',
  '请先选择共享项目！': '请先选择共享项目！',
  '共享设置成功！': '共享设置成功！',
  '目标端大数据湖': '目标端大数据湖',
  '迁移对象选择': '迁移对象选择',
  '源端信息': '源端信息',
  '源端库或Schema':'源端库或Schema',
  '源端表': '源端表',
  '源端参数': '源端参数',
  '一次性读取到内存中的记录条数': '一次性读取到内存中的记录条数',
  '执行读取数DB数据的线程数，多线程更快': '执行读取数DB数据的线程数，多线程更快',
  '切分表数据依赖列，需带索引或是主键，不填时自动寻找主键，没有则不切分表': '切分表数据依赖列，需带索引或是主键，不填时自动寻找主键，没有则不切分表',
  '增量时使用，需符合sql语法，参考：where 字段': '增量时使用，需符合sql语法，参考：where 字段',
  '目标端信息': '目标端信息',
  '目标端参数': '目标端参数',
  'Stg层库对应的Schema': 'Stg层库对应的Schema',
  'Stg层对应的表名':'Stg层对应的表名',
  'Stg层数是否可复写。true/false': 'Stg层数是否可复写。true/false',
  '执行入湖的线程数，多线程可能更快':'执行入湖的线程数，多线程可能更快',
  'ods层数据库schema': 'ods层数据库schema',
  'ods层数tableName':'ods层数tableName',
  'ods层分区名称':'ods层分区名称',
  '请先选择磁盘类型！': '请先选择磁盘类型！',
  '请填写备注！': '请填写备注！',
  '输入名称前缀匹配': '输入名称前缀匹配',
  '公司全称': '公司全称',
  '公司性质':'公司性质',
  '发票类型': '发票类型',
  '发票种类':'发票种类',
  '公司税号':'公司税号',
  '开户行':'开户行',
  '银行账号':'银行账号',
  '分机号':'分机号',
  '终端号':'终端号',
  '合同编号':'合同编号',
  '开票方': '开票方',
  '合同号':'合同号',
  '联系人手机':'联系人手机',
  '非企业':'非企业',
  '纸质专票':'纸质专票',
  '纸质普票':'纸质普票',
  '电子普票':'电子普票',
  '长度在 1 到 100 个字符':'长度在 1 到 100 个字符',
  '长度在 1 到 20 个字符':'长度在 1 到 20 个字符',
  '不能超出20个字符': '不能超出20个字符',
  '不能超出255个字符':'不能超出255个字符',
  '长度在 1 到 8 个字符': '长度在 1 到 8 个字符',
  '长度在 1 到 5 个字符': '长度在 1 到 5 个字符',
  '长度在 1 到 80 个字符':'长度在 1 到 80 个字符',
  '必填，在1-200范围内':'必填，在1-200范围内',
  '电子发票开具后自动发送至邮箱':'电子发票开具后自动发送至邮箱',
  '请输入数字':'请输入数字',
  '确定要删除开票信息？':'确定要删除开票信息？',
  '删除后系统将无法开具该开票方发票':'删除后系统将无法开具该开票方发票',
  '请输入公司名称进行查询' : '请输入公司名称进行查询',
  '行政组织选择错误' : '行政组织选择错误',
  '当前为全选状态，无法展开节点' : '当前为全选状态，无法展开节点',
  '点击选择月份' : '点击选择月份',
  '确认账单金额' : '确认账单金额',
  '账单金额' : '账单金额',
  '账单行政组织' : '账单行政组织',
  '集合' : '集合',
  '标准层级' : '标准层级',
  '账单确认' : '账单确认',
  '账单提交' : '账单提交',
  '账单确认成功！' : '账单确认成功！',
  '账单提交成功！' : '账单提交成功！',
  '请先选择账单 !' : '请先选择账单 !',
  '账单下载' : '账单下载',
  '月度账单汇总' : '月度账单汇总',
  '批量账单确认' : '批量账单确认',
  '请至少选择一个行政组织！' : '请至少选择一个行政组织！',
  '账单ID' : '账单ID',
  '账单总额' : '账单总额',
  '账单确认时间' : '账单确认时间',
  '未确认' : '未确认',
  '已确认' : '已确认',
  '申请开票' : '申请开票',
  '开票完成' : '开票完成',
  '账单生成时间' : '账单生成时间',
  '账单核对' : '账单核对',
  '批量确认' : '批量确认',
  '批量下载' : '批量下载',
  '请输入关键词搜索':'请输入关键词搜索',
  '行政组织授权':'行政组织授权',
  '此节点为无效节点':'此节点为无效节点',
  '已授权用户':'已授权用户',
  '编辑权限':'编辑权限',
  '移除用户': '移除用戶',
  '清除全部': '清除全部',
  '选择全部': '选择全部',
  '保存所有':'保存所有',
  '移除失败':'移除失败',
  '批量移除用户成功！':'批量移除用户成功！',
  '开票':'开票',
  '11-20字符，格式：区号-固定号码':'11-20字符，格式：区号-固定号码',
  '长度在 11 到 20 个字符':'长度在 11 到 20 个字符',
  '运营管理':'运营管理',
  '置灰的组织节点为没有挂载项目或无效的组织节点':'置灰的组织节点为没有挂载项目或无效的组织节点',
  '触发器信息':'触发器信息',
  '触发时机':'触发时机',
  '事件':'事件',
  '触发表':'触发表',
  '触发语句':'触发语句',
  '格式化SQL':'格式化SQL',
  '导 出':'导 出',
  '创建触发器':'创建触发器',
  '编辑触发器':'编辑触发器',
  'SQL变更提交预览':'SQL变更提交预览',
  '触发器变更提交预览':'触发器变更提交预览',
  '编辑函数':'编辑函数',
  '设置行数':'设置行数',
  '选择格式':'选择格式',
  'Oracle备份': 'Oracle备份',
  'Oracle实例': 'Oracle实例',
  '数据库服务IP': '数据库服务IP',
  '数据库所在位置': '数据库所在位置',
  '实例名称': '实例名称',
  'IP': 'IP',
  '添加Oracle实例': '添加Oracle实例',
  'oracle实例': 'oracle实例',
  '请输入实例名称': '请输入实例名称',
  '确认要删除这个': '确认要删除这个',
  '实例吗?': '实例吗?',
  '确认删除后，Oracle实例不再显示在列表': '确认删除后，Oracle实例不再显示在列表',
  '实例删除成功！': '实例删除成功！',
  '英文名须a-zA-Z-_0-9！': '英文名须a-zA-Z-_0-9！',
  '空表单无法提交!': '空表单无法提交!',
  '无符合条件的数据库':'无符合条件的数据库',
  '服务IP':'服务IP',
  '注册Oracle实例':'注册Oracle实例',
  '数据库名称':'数据库名称',
  '请选择租户 !':'请选择租户 !',
  '请选择项目 !':'请选择项目 !',
  '请输入实例名称 !':'请输入实例名称 !',
  '请选择数据库服务IP !':'请选择数据库服务IP !',
  '实例创建请求已发送成功 !':'实例创建请求已发送成功 !',
  '请先选择搜索维度 !':'请先选择搜索维度 !',
  '请输入搜索关键字 !':'请输入搜索关键字 !',
  '添加时间':'添加时间',
  'Oracle详情':'Oracle详情',
  '客户端列表':'客户端列表',
  '认证用户名':'认证用户名',
  '认证方式':'认证方式',
  'os系统认证方式':'os系统认证方式',
  '策略已启用!':'策略已启用!',
  '策略已禁用!':'策略已禁用!',
  '备份策略吗?':'备份策略吗?',
  '确认删除备份策略后，备份策略下备份计划同步删除':'确认删除备份策略后，备份策略下备份计划同步删除',
  '策略删除成功！':'策略删除成功！',
  '注册Oracle实例:':'注册Oracle实例:',
  '开启日志备份':'开启日志备份',
  '注册的Oracle实例':'注册的Oracle实例',
  'Oracle备份策略详情':'Oracle备份策略详情',
  '【创建备份计划】/【编辑备份计划】/【立即备份】/【删除备份计划】':'【创建备份计划】/【编辑备份计划】/【立即备份】/【删除备份计划】',
  '备份策略已被【':'备份策略已被【',
  '】，当前备份策略状态处于【':'】，当前备份策略状态处于【',
  '】,【不】允许':'】,【不】允许',
  '确定启用备份策略吗?':'确定启用备份策略吗?',
  '确认要删除这个【':'确认要删除这个【',
  '】备份计划吗?':'】备份计划吗?',
  '计划删除成功！':'计划删除成功！',
  '数据库实例IP地址':'数据库实例IP地址',
  'Oracle实例名称':'Oracle实例名称',
  '】备份策略吗?':'】备份策略吗?',
  '当前策略已有日志备份':'当前策略已有日志备份',
  '备份计划创建成功！':'备份计划创建成功！',
  '策略说明最长支持256个字符！':'策略说明最长支持256个字符！',
  'oracle实例名称': '',
  '数据库实例IP' : '',
  '刷新账单':'刷新账单',
  '账单刷新操作已提交，请耐心等待':'账单刷新操作已提交，请耐心等待',
  '为保证账单的准确性，当行政组织挂载的项目发生变化时，需要在批量操作下手动执行刷新账单操作':'为保证账单的准确性，当行政组织挂载的项目发生变化时，需要在批量操作下手动执行刷新账单操作',
  '置灰的组织节点为没有权限、没有挂载项目或无效的组织节点':'置灰的组织节点为没有权限、没有挂载项目或无效的组织节点',
  '集团行政组织树，项目可挂载在组织节点上':'集团行政组织树，项目可挂载在组织节点上',
  '该节点为无效节点': '该节点为无效节点',
  '该组织节点未挂载任何项目': '该组织节点未挂载任何项目',
  '您没有该组织节点的权限':'您没有该组织节点的权限',
  'Windows主机信息':'Windows主机信息',
  '快照时间':'快照时间',
  '温馨提示：启动数据库备份，会按照收费标准收取费用，生产可用区的数据库强烈建议开启数据库备份，否则在数据库出现数据损坏、丢失、误删等情况下，将无法找回原始数据。':'温馨提示：启动数据库备份，会按照收费标准收取费用，生产可用区的数据库强烈建议开启数据库备份，否则在数据库出现数据损坏、丢失、误删等情况下，将无法找回原始数据。',
  '确认不启动数据库备份吗?':'确认不启动数据库备份吗?',
  '关闭数据库备份，在数据库出现数据损坏、丢失、误删等情况下，将无法找回原始数据。':'关闭数据库备份，在数据库出现数据损坏、丢失、误删等情况下，将无法找回原始数据。',
  '开票记录查看':'开票记录查看',
  '开票申请':'开票申请',
  '合并开票申请':'合并开票申请',
  '服务版块':'服务版块',
  '待开票金额':'待开票金额',
  '开票记录':'开票记录',
  '消费账单':'消费账单',
  '合计':'合计',
  '合并开票':'合并开票',
  '开票公司全称':'开票公司全称',
  '开票金额':'开票金额',
  '开票记录ID':'开票记录ID',
  '账单金额（含税）':'账单金额（含税）',
  '可开票金额（含税）':'可开票金额（含税）',
  '云服务费':'云服务费',
  '请至少勾选2个需要合并开票的资源':'请至少勾选2个需要合并开票的资源',
  '请先选择开票公司！':'请先选择开票公司！',
  '请先选择发票类型！':'请先选择发票类型！',
  '申请开票成功！':'申请开票成功！',
  '请在发票管理详情关注审批结果':'请在发票管理详情关注审批结果',
  '开票信息':'开票信息',
  '发票信息详情':'发票信息详情',
  '审批信息':'审批信息',
  '业务单号':'业务单号',
  '发票代码':'发票代码',
  '发票号码':'发票号码',
  '详情':'详情',
  '开票人':'开票人',
  '申请开票时间':'申请开票时间',
  '产权码':'产权码',
  '等待GOA审批':'等待GOA审批',
  'GOA审批通过':'GOA审批通过',
  'GOA审批不通过':'GOA审批不通过',
  '发票开具成功':'发票开具成功',
  '发票开具失败':'发票开具失败',
  '开票金额不能为0！': '开票金额不能为0！',
  '勾选项中存在待开票金额为0的资源': '勾选项中存在待开票金额为0的资源',
  '待开票金额为0，不可申请开票！': '待开票金额为0，不可申请开票！',
  '单月账单列表': '单月账单列表',
  '审批时间': '审批时间',
  '请选择磁盘类型！': '请选择磁盘类型！',
  '确定卸载该':'确定卸载该',
  '请选择比源端库大的数据盘':'请选择比源端库大的数据盘',
  '请输入与源端库RMAN备份时一致的实例名':'请输入与源端库RMAN备份时一致的实例名',
  'EXPDP逻辑备份':'EXPDP逻辑备份',
  'RMAN物理备份':'RMAN物理备份',
  '温馨提示：云磁盘卸载后，将变成“空闲”状态，会继续收费。 如果您不再需要该云磁盘，请到【存储】--【云磁盘CBS】的界面删除空闲状态的该盘！':'温馨提示：云磁盘卸载后，将变成“空闲”状态，会继续收费。 如果您不再需要该云磁盘，请到【存储】--【云磁盘CBS】的界面删除空闲状态的该盘！',
  '温馨提示：云磁盘卸载后，将变成“空闲”状态，会继续收费。 如果您不再需要该云磁盘，请在列表删除空闲状态的该盘！':'温馨提示：云磁盘卸载后，将变成“空闲”状态，会继续收费。 如果您不再需要该云磁盘，请在列表删除空闲状态的该盘！',
  '证书品牌':'证书品牌',
  '证书域名类型':'证书域名类型',
  '域名验证方式':'域名验证方式',
  '加密算法':'加密算法',
  '密钥对参数':'密钥对参数',
  '有效期限':'有效期限',
  '已选证书':'已选证书',
  '设置公司信息':'设置公司信息',
  '公司地址':'公司地址',
  '邮政编码':'邮政编码',
  '公司电话':'公司电话',
  '联系人姓氏':'联系人姓氏',
  '联系人名字':'联系人名字',
  '联系人电话':'联系人电话',
  '联系人邮箱':'联系人邮箱',
  '联系人职位':'联系人职位',
  '当首次购买OV/EV证书时，需要上传公司信息确认函':'当首次购买OV/EV证书时，需要上传公司信息确认函',
  '公司信息确认函用于审核企业信息，请下载公司信息确认函模板，正确填写并加盖公章后，扫描成PDF上传完成审核':'公司信息确认函用于审核企业信息，请下载公司信息确认函模板，正确填写并加盖公章后，扫描成PDF上传完成审核',
  '总数量':'总数量',
  '购买证书':'购买证书',
  '待域名验证':'待域名验证',
  '待续费':'待续费',
  '确认函状态':'确认函状态',
  '暂无公司信息确认函':'暂无公司信息确认函',
  '暂无':'暂无',
  '点击此处下载公司信息确认函模板':'点击此处下载公司信息确认函模板',
  '点击此处上传公司信息确认函':'点击此处上传公司信息确认函',
  '证书格式':'证书格式',
  '证书密码':'证书密码',
  '续费年限':'续费年限',
  '证书吊销是指已经签发的证书从签发证书机构处注销':'证书吊销是指已经签发的证书从签发证书机构处注销',
  '证书吊销后将失去加密效果，浏览器不在信任该证书':'证书吊销后将失去加密效果，浏览器不在信任该证书',
  '签发后30天内吊销，可以取消订单，签发后超过30天无法完成吊销':'签发后30天内吊销，可以取消订单，签发后超过30天无法完成吊销',
  '吊销确认函用于审核SSL证书的吊销申请':'吊销确认函用于审核SSL证书的吊销申请',
  '请下载吊销信息函模板，正确填写并加盖公章后，扫描成电子文件上传完成审核':'请下载吊销信息函模板，正确填写并加盖公章后，扫描成电子文件上传完成审核',
  '上传文件类型可以是jpg、png、gif、tiff、pdf、zip、rar等':'上传文件类型可以是jpg、png、gif、tiff、pdf、zip、rar等',
  '点击此处下载吊销确认函模板':'点击此处下载吊销确认函模板',
  '点击此处上传吊销确认函模板':'点击此处上传吊销确认函模板',
  '您确定要吊销证书吗':'您确定要吊销证书吗',
  '域名验证值':'域名验证值',
  '域名验证值为':'域名验证值为',
  '请及时根据域名验证值到做域名验证，逾期订单可能会被拒绝，谢谢':'请及时根据域名验证值到做域名验证，逾期订单可能会被拒绝，谢谢',
  '吊销验证值':'吊销验证值',
  '吊销验证值为':'吊销验证值为',
  '请及时根据吊销验证值到做吊销验证，谢谢':'请及时根据吊销验证值到做吊销验证，谢谢',
  '您确定要取消订单吗':'您确定要取消订单吗',
  '上传信息确认函':'上传信息确认函',
  '公司信息确认函用于审核企业信息，请正确填写并加盖公章后，扫描成电子文件上传完成审核。上传文件类型可以是jpg、png、gif、tiff、pdf、zip、rar等':'公司信息确认函用于审核企业信息，请正确填写并加盖公章后，扫描成电子文件上传完成审核。上传文件类型可以是jpg、png、gif、tiff、pdf、zip、rar等',
  '证书所服务项目':'证书所服务项目',
  '告警历史':'告警历史',
  '指标':'指标',
  '指标信息':'指标信息',
  '告警值':'告警值',
  '级别':'级别',
  '发生时间':'发生时间',
  '持续时长':'持续时长',
  '高':'高',
  '中':'中',
  '低':'低',
  '正在告警':'正在告警',
}


// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN.js